export const GridData = [
    {
        ProductID: 1,
        Title: 'Eco Gaming Mouse',
        Description: 'The Eco Gaming Mouse combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-01-02',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 545,
        },
    },
    {
        ProductID: 2,
        Title: 'Compact Home Security Camera',
        Description:
            'The Compact Home Security Camera combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-01-03',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 225,
        },
    },
    {
        ProductID: 3,
        Title: 'Portable Wireless Charger',
        Description:
            'Upgrade your setup with the Portable Wireless Charger, engineered for speed, durability, and convenience.',
        datasetDate: '2024-01-04',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 940,
        },
    },
    {
        ProductID: 4,
        Title: 'Premium Laptop Stand',
        Description:
            'Experience improved productivity with this Premium Laptop Stand, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-01-05',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 588,
        },
    },
    {
        ProductID: 5,
        Title: 'Pro Electric Toothbrush',
        Description:
            'Designed for everyday use, this Pro Electric Toothbrush delivers reliable performance and modern features.',
        datasetDate: '2024-01-06',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 24,
        },
    },
    {
        ProductID: 6,
        Title: 'Advanced Mechanical Keyboard',
        Description:
            'The Advanced Mechanical Keyboard combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-01-07',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 520,
        },
    },
    {
        ProductID: 7,
        Title: 'Wireless Action Camera',
        Description:
            'Upgrade your setup with the Wireless Action Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-01-08',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 384,
        },
    },
    {
        ProductID: 8,
        Title: 'Compact Noise Cancelling Headphones',
        Description:
            'A versatile Noise Cancelling Headphones featuring compact construction and dependable performance for daily tasks.',
        datasetDate: '2024-01-09',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 957,
        },
    },
    {
        ProductID: 9,
        Title: 'Compact Smart LED Bulb',
        Description:
            'The Compact Smart LED Bulb combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-01-10',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 917,
        },
    },
    {
        ProductID: 10,
        Title: 'Compact Smart LED Bulb',
        Description:
            'Designed for everyday use, this Compact Smart LED Bulb delivers reliable performance and modern features.',
        datasetDate: '2024-01-11',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 952,
        },
    },
    {
        ProductID: 11,
        Title: 'Eco Electric Toothbrush',
        Description:
            'A versatile Electric Toothbrush featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-01-12',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 669,
        },
    },
    {
        ProductID: 12,
        Title: 'Advanced Robot Vacuum',
        Description:
            'The Advanced Robot Vacuum combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-01-13',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 529,
        },
    },
    {
        ProductID: 13,
        Title: 'Ultra Noise Cancelling Headphones',
        Description:
            'Designed for everyday use, this Ultra Noise Cancelling Headphones delivers reliable performance and modern features.',
        datasetDate: '2024-01-14',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 420,
        },
    },
    {
        ProductID: 14,
        Title: 'Durable Coffee Grinder',
        Description:
            'Designed for everyday use, this Durable Coffee Grinder delivers reliable performance and modern features.',
        datasetDate: '2024-01-15',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 668,
        },
    },
    {
        ProductID: 15,
        Title: 'Smart Coffee Grinder',
        Description:
            'A versatile Coffee Grinder featuring smart construction and dependable performance for daily tasks.',
        datasetDate: '2024-01-16',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 986,
        },
    },
    {
        ProductID: 16,
        Title: 'Portable Laptop Stand',
        Description:
            'Experience improved productivity with this Portable Laptop Stand, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-01-17',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 78,
        },
    },
    {
        ProductID: 17,
        Title: 'Portable 4K Monitor',
        Description:
            'The Portable 4K Monitor combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-01-18',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 688,
        },
    },
    {
        ProductID: 18,
        Title: 'Ultra Smart LED Bulb',
        Description:
            'The Ultra Smart LED Bulb combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-01-19',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 772,
        },
    },
    {
        ProductID: 19,
        Title: 'Advanced Robot Vacuum',
        Description:
            'A versatile Robot Vacuum featuring advanced construction and dependable performance for daily tasks.',
        datasetDate: '2024-01-20',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 830,
        },
    },
    {
        ProductID: 20,
        Title: 'Compact Fitness Tracker',
        Description:
            'Upgrade your setup with the Compact Fitness Tracker, engineered for speed, durability, and convenience.',
        datasetDate: '2024-01-21',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 920,
        },
    },
    {
        ProductID: 21,
        Title: 'Pro 4K Monitor',
        Description: 'The Pro 4K Monitor combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-01-22',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 933,
        },
    },
    {
        ProductID: 22,
        Title: 'Advanced Webcam',
        Description: 'The Advanced Webcam combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-01-23',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 593,
        },
    },
    {
        ProductID: 23,
        Title: 'Compact Fitness Tracker',
        Description:
            'A versatile Fitness Tracker featuring compact construction and dependable performance for daily tasks.',
        datasetDate: '2024-01-24',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 69,
        },
    },
    {
        ProductID: 24,
        Title: 'Wireless Electric Toothbrush',
        Description:
            'The Wireless Electric Toothbrush combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-01-25',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 267,
        },
    },
    {
        ProductID: 25,
        Title: 'Premium Bluetooth Speaker',
        Description:
            'A versatile Bluetooth Speaker featuring premium construction and dependable performance for daily tasks.',
        datasetDate: '2024-01-26',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 362,
        },
    },
    {
        ProductID: 26,
        Title: 'Durable Mechanical Keyboard',
        Description:
            'Upgrade your setup with the Durable Mechanical Keyboard, engineered for speed, durability, and convenience.',
        datasetDate: '2024-01-27',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 667,
        },
    },
    {
        ProductID: 27,
        Title: 'Durable Air Purifier',
        Description:
            'The Durable Air Purifier combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-01-28',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 45,
        },
    },
    {
        ProductID: 28,
        Title: 'Premium Electric Toothbrush',
        Description:
            'A versatile Electric Toothbrush featuring premium construction and dependable performance for daily tasks.',
        datasetDate: '2024-01-29',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 446,
        },
    },
    {
        ProductID: 29,
        Title: 'Premium Smart Plug',
        Description:
            'Upgrade your setup with the Premium Smart Plug, engineered for speed, durability, and convenience.',
        datasetDate: '2024-01-30',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 573,
        },
    },
    {
        ProductID: 30,
        Title: 'Wireless Smart Plug',
        Description:
            'The Wireless Smart Plug combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-01-31',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 164,
        },
    },
    {
        ProductID: 31,
        Title: 'Eco Coffee Grinder',
        Description:
            'Designed for everyday use, this Eco Coffee Grinder delivers reliable performance and modern features.',
        datasetDate: '2024-02-01',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 931,
        },
    },
    {
        ProductID: 32,
        Title: 'Pro Laptop Stand',
        Description: 'Upgrade your setup with the Pro Laptop Stand, engineered for speed, durability, and convenience.',
        datasetDate: '2024-02-02',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 743,
        },
    },
    {
        ProductID: 33,
        Title: 'Durable Webcam',
        Description:
            'Designed for everyday use, this Durable Webcam delivers reliable performance and modern features.',
        datasetDate: '2024-02-03',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 773,
        },
    },
    {
        ProductID: 34,
        Title: 'Pro USB-C Hub',
        Description: 'The Pro USB-C Hub combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-02-04',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 298,
        },
    },
    {
        ProductID: 35,
        Title: 'Smart Smart Plug',
        Description:
            'Designed for everyday use, this Smart Smart Plug delivers reliable performance and modern features.',
        datasetDate: '2024-02-05',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 986,
        },
    },
    {
        ProductID: 36,
        Title: 'Smart USB-C Hub',
        Description:
            'Designed for everyday use, this Smart USB-C Hub delivers reliable performance and modern features.',
        datasetDate: '2024-02-06',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 376,
        },
    },
    {
        ProductID: 37,
        Title: 'Ultra Bluetooth Speaker',
        Description:
            'Experience improved productivity with this Ultra Bluetooth Speaker, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-02-07',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 473,
        },
    },
    {
        ProductID: 38,
        Title: 'Portable External SSD',
        Description:
            'A versatile External SSD featuring portable construction and dependable performance for daily tasks.',
        datasetDate: '2024-02-08',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 118,
        },
    },
    {
        ProductID: 39,
        Title: 'Durable Gaming Mouse',
        Description:
            'Experience improved productivity with this Durable Gaming Mouse, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-02-09',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 870,
        },
    },
    {
        ProductID: 40,
        Title: 'Wireless USB-C Hub',
        Description:
            'Experience improved productivity with this Wireless USB-C Hub, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-02-10',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 381,
        },
    },
    {
        ProductID: 41,
        Title: 'Durable Smart Plug',
        Description:
            'Designed for everyday use, this Durable Smart Plug delivers reliable performance and modern features.',
        datasetDate: '2024-02-11',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 662,
        },
    },
    {
        ProductID: 42,
        Title: 'Ultra Gaming Mouse',
        Description:
            'Upgrade your setup with the Ultra Gaming Mouse, engineered for speed, durability, and convenience.',
        datasetDate: '2024-02-12',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 409,
        },
    },
    {
        ProductID: 43,
        Title: 'Eco Air Purifier',
        Description:
            'Experience improved productivity with this Eco Air Purifier, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-02-13',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 75,
        },
    },
    {
        ProductID: 44,
        Title: 'Smart Mechanical Keyboard',
        Description:
            'The Smart Mechanical Keyboard combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-02-14',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 855,
        },
    },
    {
        ProductID: 45,
        Title: 'Pro Action Camera',
        Description: 'The Pro Action Camera combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-02-15',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 281,
        },
    },
    {
        ProductID: 46,
        Title: 'Eco Wireless Charger',
        Description:
            'The Eco Wireless Charger combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-02-16',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 650,
        },
    },
    {
        ProductID: 47,
        Title: 'Smart Laptop Stand',
        Description: 'The Smart Laptop Stand combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-02-17',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 157,
        },
    },
    {
        ProductID: 48,
        Title: 'Pro 4K Monitor',
        Description:
            'Designed for everyday use, this Pro 4K Monitor delivers reliable performance and modern features.',
        datasetDate: '2024-02-18',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 923,
        },
    },
    {
        ProductID: 49,
        Title: 'Portable USB-C Hub',
        Description:
            'A versatile USB-C Hub featuring portable construction and dependable performance for daily tasks.',
        datasetDate: '2024-02-19',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 286,
        },
    },
    {
        ProductID: 50,
        Title: 'Compact Air Purifier',
        Description:
            'Upgrade your setup with the Compact Air Purifier, engineered for speed, durability, and convenience.',
        datasetDate: '2024-02-20',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 830,
        },
    },
    {
        ProductID: 51,
        Title: 'Smart Electric Toothbrush',
        Description:
            'Designed for everyday use, this Smart Electric Toothbrush delivers reliable performance and modern features.',
        datasetDate: '2024-02-21',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 155,
        },
    },
    {
        ProductID: 52,
        Title: 'Ultra Mechanical Keyboard',
        Description:
            'Designed for everyday use, this Ultra Mechanical Keyboard delivers reliable performance and modern features.',
        datasetDate: '2024-02-22',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 686,
        },
    },
    {
        ProductID: 53,
        Title: 'Advanced Gaming Mouse',
        Description:
            'Upgrade your setup with the Advanced Gaming Mouse, engineered for speed, durability, and convenience.',
        datasetDate: '2024-02-23',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 873,
        },
    },
    {
        ProductID: 54,
        Title: 'Smart Wireless Charger',
        Description:
            'Upgrade your setup with the Smart Wireless Charger, engineered for speed, durability, and convenience.',
        datasetDate: '2024-02-24',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 672,
        },
    },
    {
        ProductID: 55,
        Title: 'Eco Laptop Stand',
        Description: 'The Eco Laptop Stand combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-02-25',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 185,
        },
    },
    {
        ProductID: 56,
        Title: 'Eco Smart LED Bulb',
        Description:
            'Designed for everyday use, this Eco Smart LED Bulb delivers reliable performance and modern features.',
        datasetDate: '2024-02-26',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 463,
        },
    },
    {
        ProductID: 57,
        Title: 'Durable Gaming Mouse',
        Description:
            'The Durable Gaming Mouse combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-02-27',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 844,
        },
    },
    {
        ProductID: 58,
        Title: 'Durable Electric Toothbrush',
        Description:
            'Designed for everyday use, this Durable Electric Toothbrush delivers reliable performance and modern features.',
        datasetDate: '2024-02-28',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 427,
        },
    },
    {
        ProductID: 59,
        Title: 'Wireless Bluetooth Speaker',
        Description:
            'Experience improved productivity with this Wireless Bluetooth Speaker, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-02-29',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 793,
        },
    },
    {
        ProductID: 60,
        Title: 'Smart Laptop Stand',
        Description:
            'Experience improved productivity with this Smart Laptop Stand, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-03-01',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 654,
        },
    },
    {
        ProductID: 61,
        Title: 'Advanced Wireless Charger',
        Description:
            'Designed for everyday use, this Advanced Wireless Charger delivers reliable performance and modern features.',
        datasetDate: '2024-03-02',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 394,
        },
    },
    {
        ProductID: 62,
        Title: 'Durable USB-C Hub',
        Description:
            'Upgrade your setup with the Durable USB-C Hub, engineered for speed, durability, and convenience.',
        datasetDate: '2024-03-03',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 953,
        },
    },
    {
        ProductID: 63,
        Title: 'Compact Coffee Grinder',
        Description:
            'Designed for everyday use, this Compact Coffee Grinder delivers reliable performance and modern features.',
        datasetDate: '2024-03-04',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 942,
        },
    },
    {
        ProductID: 64,
        Title: 'Compact Home Security Camera',
        Description:
            'A versatile Home Security Camera featuring compact construction and dependable performance for daily tasks.',
        datasetDate: '2024-03-05',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 522,
        },
    },
    {
        ProductID: 65,
        Title: 'Portable Mechanical Keyboard',
        Description:
            'Experience improved productivity with this Portable Mechanical Keyboard, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-03-06',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 598,
        },
    },
    {
        ProductID: 66,
        Title: 'Wireless Air Purifier',
        Description:
            'Experience improved productivity with this Wireless Air Purifier, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-03-07',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 804,
        },
    },
    {
        ProductID: 67,
        Title: 'Ultra Bluetooth Speaker',
        Description:
            'A versatile Bluetooth Speaker featuring ultra construction and dependable performance for daily tasks.',
        datasetDate: '2024-03-08',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 602,
        },
    },
    {
        ProductID: 68,
        Title: 'Wireless 4K Monitor',
        Description:
            'A versatile 4K Monitor featuring wireless construction and dependable performance for daily tasks.',
        datasetDate: '2024-03-09',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 212,
        },
    },
    {
        ProductID: 69,
        Title: 'Ultra Air Purifier',
        Description:
            'Designed for everyday use, this Ultra Air Purifier delivers reliable performance and modern features.',
        datasetDate: '2024-03-10',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 592,
        },
    },
    {
        ProductID: 70,
        Title: 'Eco Smart LED Bulb',
        Description:
            'Designed for everyday use, this Eco Smart LED Bulb delivers reliable performance and modern features.',
        datasetDate: '2024-03-11',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 374,
        },
    },
    {
        ProductID: 71,
        Title: 'Advanced Webcam',
        Description: 'A versatile Webcam featuring advanced construction and dependable performance for daily tasks.',
        datasetDate: '2024-03-12',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 118,
        },
    },
    {
        ProductID: 72,
        Title: 'Advanced External SSD',
        Description:
            'The Advanced External SSD combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-03-13',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 596,
        },
    },
    {
        ProductID: 73,
        Title: 'Wireless 4K Monitor',
        Description:
            'The Wireless 4K Monitor combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-03-14',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 839,
        },
    },
    {
        ProductID: 74,
        Title: 'Ultra Webcam',
        Description: 'Designed for everyday use, this Ultra Webcam delivers reliable performance and modern features.',
        datasetDate: '2024-03-15',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 146,
        },
    },
    {
        ProductID: 75,
        Title: 'Portable Laptop Stand',
        Description:
            'The Portable Laptop Stand combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-03-16',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 848,
        },
    },
    {
        ProductID: 76,
        Title: 'Durable Robot Vacuum',
        Description:
            'The Durable Robot Vacuum combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-03-17',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 456,
        },
    },
    {
        ProductID: 77,
        Title: 'Eco Noise Cancelling Headphones',
        Description:
            'Experience improved productivity with this Eco Noise Cancelling Headphones, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-03-18',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 848,
        },
    },
    {
        ProductID: 78,
        Title: 'Premium USB-C Hub',
        Description: 'A versatile USB-C Hub featuring premium construction and dependable performance for daily tasks.',
        datasetDate: '2024-03-19',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 659,
        },
    },
    {
        ProductID: 79,
        Title: 'Portable Fitness Tracker',
        Description:
            'Designed for everyday use, this Portable Fitness Tracker delivers reliable performance and modern features.',
        datasetDate: '2024-03-20',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 791,
        },
    },
    {
        ProductID: 80,
        Title: 'Advanced Smart Plug',
        Description:
            'A versatile Smart Plug featuring advanced construction and dependable performance for daily tasks.',
        datasetDate: '2024-03-21',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 150,
        },
    },
    {
        ProductID: 81,
        Title: 'Eco Coffee Grinder',
        Description:
            'Upgrade your setup with the Eco Coffee Grinder, engineered for speed, durability, and convenience.',
        datasetDate: '2024-03-22',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 889,
        },
    },
    {
        ProductID: 82,
        Title: 'Ultra Mechanical Keyboard',
        Description:
            'Experience improved productivity with this Ultra Mechanical Keyboard, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-03-23',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 535,
        },
    },
    {
        ProductID: 83,
        Title: 'Eco Laptop Stand',
        Description: 'A versatile Laptop Stand featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-03-24',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 167,
        },
    },
    {
        ProductID: 84,
        Title: 'Wireless Fitness Tracker',
        Description:
            'The Wireless Fitness Tracker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-03-25',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 672,
        },
    },
    {
        ProductID: 85,
        Title: 'Compact Robot Vacuum',
        Description:
            'The Compact Robot Vacuum combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-03-26',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 945,
        },
    },
    {
        ProductID: 86,
        Title: 'Advanced Fitness Tracker',
        Description:
            'A versatile Fitness Tracker featuring advanced construction and dependable performance for daily tasks.',
        datasetDate: '2024-03-27',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 696,
        },
    },
    {
        ProductID: 87,
        Title: 'Eco Gaming Mouse',
        Description: 'Upgrade your setup with the Eco Gaming Mouse, engineered for speed, durability, and convenience.',
        datasetDate: '2024-03-28',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 256,
        },
    },
    {
        ProductID: 88,
        Title: 'Premium Air Purifier',
        Description:
            'Experience improved productivity with this Premium Air Purifier, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-03-29',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 934,
        },
    },
    {
        ProductID: 89,
        Title: 'Advanced Robot Vacuum',
        Description:
            'The Advanced Robot Vacuum combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-03-30',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 691,
        },
    },
    {
        ProductID: 90,
        Title: 'Ultra Wireless Charger',
        Description:
            'Experience improved productivity with this Ultra Wireless Charger, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-03-31',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 698,
        },
    },
    {
        ProductID: 91,
        Title: 'Advanced Wireless Charger',
        Description:
            'A versatile Wireless Charger featuring advanced construction and dependable performance for daily tasks.',
        datasetDate: '2024-04-01',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 238,
        },
    },
    {
        ProductID: 92,
        Title: 'Premium Webcam',
        Description:
            'Designed for everyday use, this Premium Webcam delivers reliable performance and modern features.',
        datasetDate: '2024-04-02',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 561,
        },
    },
    {
        ProductID: 93,
        Title: 'Premium Smart LED Bulb',
        Description:
            'Upgrade your setup with the Premium Smart LED Bulb, engineered for speed, durability, and convenience.',
        datasetDate: '2024-04-03',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 901,
        },
    },
    {
        ProductID: 94,
        Title: 'Durable Mechanical Keyboard',
        Description:
            'The Durable Mechanical Keyboard combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-04-04',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 751,
        },
    },
    {
        ProductID: 95,
        Title: 'Smart Laptop Stand',
        Description:
            'A versatile Laptop Stand featuring smart construction and dependable performance for daily tasks.',
        datasetDate: '2024-04-05',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 261,
        },
    },
    {
        ProductID: 96,
        Title: 'Advanced Webcam',
        Description:
            'Experience improved productivity with this Advanced Webcam, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-04-06',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 481,
        },
    },
    {
        ProductID: 97,
        Title: 'Durable Home Security Camera',
        Description:
            'Designed for everyday use, this Durable Home Security Camera delivers reliable performance and modern features.',
        datasetDate: '2024-04-07',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 801,
        },
    },
    {
        ProductID: 98,
        Title: 'Ultra Noise Cancelling Headphones',
        Description:
            'Upgrade your setup with the Ultra Noise Cancelling Headphones, engineered for speed, durability, and convenience.',
        datasetDate: '2024-04-08',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 686,
        },
    },
    {
        ProductID: 99,
        Title: 'Compact Action Camera',
        Description:
            'Experience improved productivity with this Compact Action Camera, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-04-09',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 857,
        },
    },
    {
        ProductID: 100,
        Title: 'Premium Air Purifier',
        Description:
            'Upgrade your setup with the Premium Air Purifier, engineered for speed, durability, and convenience.',
        datasetDate: '2024-04-10',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 901,
        },
    },
    {
        ProductID: 101,
        Title: 'Advanced Noise Cancelling Headphones',
        Description:
            'A versatile Noise Cancelling Headphones featuring advanced construction and dependable performance for daily tasks.',
        datasetDate: '2024-04-11',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 883,
        },
    },
    {
        ProductID: 102,
        Title: 'Wireless Webcam',
        Description:
            'Designed for everyday use, this Wireless Webcam delivers reliable performance and modern features.',
        datasetDate: '2024-04-12',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 340,
        },
    },
    {
        ProductID: 103,
        Title: 'Advanced Gaming Mouse',
        Description:
            'Designed for everyday use, this Advanced Gaming Mouse delivers reliable performance and modern features.',
        datasetDate: '2024-04-13',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 514,
        },
    },
    {
        ProductID: 104,
        Title: 'Durable Bluetooth Speaker',
        Description:
            'Experience improved productivity with this Durable Bluetooth Speaker, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-04-14',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 977,
        },
    },
    {
        ProductID: 105,
        Title: 'Compact Smart Plug',
        Description:
            'Designed for everyday use, this Compact Smart Plug delivers reliable performance and modern features.',
        datasetDate: '2024-04-15',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 861,
        },
    },
    {
        ProductID: 106,
        Title: 'Durable Noise Cancelling Headphones',
        Description:
            'The Durable Noise Cancelling Headphones combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-04-16',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 474,
        },
    },
    {
        ProductID: 107,
        Title: 'Smart Home Security Camera',
        Description:
            'A versatile Home Security Camera featuring smart construction and dependable performance for daily tasks.',
        datasetDate: '2024-04-17',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 858,
        },
    },
    {
        ProductID: 108,
        Title: 'Wireless Action Camera',
        Description:
            'Upgrade your setup with the Wireless Action Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-04-18',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 19,
        },
    },
    {
        ProductID: 109,
        Title: 'Durable USB-C Hub',
        Description: 'A versatile USB-C Hub featuring durable construction and dependable performance for daily tasks.',
        datasetDate: '2024-04-19',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 392,
        },
    },
    {
        ProductID: 110,
        Title: 'Wireless Bluetooth Speaker',
        Description:
            'A versatile Bluetooth Speaker featuring wireless construction and dependable performance for daily tasks.',
        datasetDate: '2024-04-20',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 575,
        },
    },
    {
        ProductID: 111,
        Title: 'Ultra External SSD',
        Description: 'The Ultra External SSD combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-04-21',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 841,
        },
    },
    {
        ProductID: 112,
        Title: 'Ultra Fitness Tracker',
        Description:
            'The Ultra Fitness Tracker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-04-22',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 2,
        },
    },
    {
        ProductID: 113,
        Title: 'Durable Action Camera',
        Description:
            'The Durable Action Camera combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-04-23',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 511,
        },
    },
    {
        ProductID: 114,
        Title: 'Advanced Coffee Grinder',
        Description:
            'A versatile Coffee Grinder featuring advanced construction and dependable performance for daily tasks.',
        datasetDate: '2024-04-24',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 76,
        },
    },
    {
        ProductID: 115,
        Title: 'Eco Noise Cancelling Headphones',
        Description:
            'The Eco Noise Cancelling Headphones combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-04-25',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 893,
        },
    },
    {
        ProductID: 116,
        Title: 'Eco Webcam',
        Description: 'A versatile Webcam featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-04-26',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 541,
        },
    },
    {
        ProductID: 117,
        Title: 'Eco Action Camera',
        Description: 'The Eco Action Camera combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-04-27',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 477,
        },
    },
    {
        ProductID: 118,
        Title: 'Premium Air Purifier',
        Description:
            'A versatile Air Purifier featuring premium construction and dependable performance for daily tasks.',
        datasetDate: '2024-04-28',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 898,
        },
    },
    {
        ProductID: 119,
        Title: 'Compact Action Camera',
        Description:
            'Designed for everyday use, this Compact Action Camera delivers reliable performance and modern features.',
        datasetDate: '2024-04-29',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 924,
        },
    },
    {
        ProductID: 120,
        Title: 'Portable Home Security Camera',
        Description:
            'Upgrade your setup with the Portable Home Security Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-04-30',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 910,
        },
    },
    {
        ProductID: 121,
        Title: 'Eco Bluetooth Speaker',
        Description:
            'A versatile Bluetooth Speaker featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-05-01',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 664,
        },
    },
    {
        ProductID: 122,
        Title: 'Smart External SSD',
        Description:
            'Experience improved productivity with this Smart External SSD, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-05-02',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 704,
        },
    },
    {
        ProductID: 123,
        Title: 'Ultra Wireless Charger',
        Description:
            'The Ultra Wireless Charger combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-05-03',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 728,
        },
    },
    {
        ProductID: 124,
        Title: 'Premium Home Security Camera',
        Description:
            'Experience improved productivity with this Premium Home Security Camera, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-05-04',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 706,
        },
    },
    {
        ProductID: 125,
        Title: 'Advanced Laptop Stand',
        Description:
            'A versatile Laptop Stand featuring advanced construction and dependable performance for daily tasks.',
        datasetDate: '2024-05-05',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 658,
        },
    },
    {
        ProductID: 126,
        Title: 'Pro Fitness Tracker',
        Description:
            'Experience improved productivity with this Pro Fitness Tracker, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-05-06',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 226,
        },
    },
    {
        ProductID: 127,
        Title: 'Premium Air Purifier',
        Description:
            'The Premium Air Purifier combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-05-07',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 152,
        },
    },
    {
        ProductID: 128,
        Title: 'Portable Action Camera',
        Description:
            'Designed for everyday use, this Portable Action Camera delivers reliable performance and modern features.',
        datasetDate: '2024-05-08',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 724,
        },
    },
    {
        ProductID: 129,
        Title: 'Smart Wireless Charger',
        Description:
            'The Smart Wireless Charger combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-05-09',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 821,
        },
    },
    {
        ProductID: 130,
        Title: 'Ultra Electric Toothbrush',
        Description:
            'The Ultra Electric Toothbrush combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-05-10',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 336,
        },
    },
    {
        ProductID: 131,
        Title: 'Premium Air Purifier',
        Description:
            'A versatile Air Purifier featuring premium construction and dependable performance for daily tasks.',
        datasetDate: '2024-05-11',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 494,
        },
    },
    {
        ProductID: 132,
        Title: 'Ultra 4K Monitor',
        Description:
            'Experience improved productivity with this Ultra 4K Monitor, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-05-12',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 45,
        },
    },
    {
        ProductID: 133,
        Title: 'Compact Bluetooth Speaker',
        Description:
            'Upgrade your setup with the Compact Bluetooth Speaker, engineered for speed, durability, and convenience.',
        datasetDate: '2024-05-13',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 709,
        },
    },
    {
        ProductID: 134,
        Title: 'Premium Fitness Tracker',
        Description:
            'The Premium Fitness Tracker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-05-14',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 12,
        },
    },
    {
        ProductID: 135,
        Title: 'Portable Smart LED Bulb',
        Description:
            'Experience improved productivity with this Portable Smart LED Bulb, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-05-15',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 461,
        },
    },
    {
        ProductID: 136,
        Title: 'Smart Bluetooth Speaker',
        Description:
            'A versatile Bluetooth Speaker featuring smart construction and dependable performance for daily tasks.',
        datasetDate: '2024-05-16',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 348,
        },
    },
    {
        ProductID: 137,
        Title: 'Smart Robot Vacuum',
        Description:
            'Upgrade your setup with the Smart Robot Vacuum, engineered for speed, durability, and convenience.',
        datasetDate: '2024-05-17',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 684,
        },
    },
    {
        ProductID: 138,
        Title: 'Advanced 4K Monitor',
        Description:
            'A versatile 4K Monitor featuring advanced construction and dependable performance for daily tasks.',
        datasetDate: '2024-05-18',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 882,
        },
    },
    {
        ProductID: 139,
        Title: 'Pro Home Security Camera',
        Description:
            'A versatile Home Security Camera featuring pro construction and dependable performance for daily tasks.',
        datasetDate: '2024-05-19',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 767,
        },
    },
    {
        ProductID: 140,
        Title: 'Ultra Air Purifier',
        Description:
            'Designed for everyday use, this Ultra Air Purifier delivers reliable performance and modern features.',
        datasetDate: '2024-05-20',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 756,
        },
    },
    {
        ProductID: 141,
        Title: 'Durable Smart LED Bulb',
        Description:
            'The Durable Smart LED Bulb combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-05-21',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 455,
        },
    },
    {
        ProductID: 142,
        Title: 'Advanced Smart LED Bulb',
        Description:
            'Experience improved productivity with this Advanced Smart LED Bulb, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-05-22',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 518,
        },
    },
    {
        ProductID: 143,
        Title: 'Pro Smart LED Bulb',
        Description: 'The Pro Smart LED Bulb combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-05-23',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 156,
        },
    },
    {
        ProductID: 144,
        Title: 'Premium USB-C Hub',
        Description:
            'Designed for everyday use, this Premium USB-C Hub delivers reliable performance and modern features.',
        datasetDate: '2024-05-24',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 558,
        },
    },
    {
        ProductID: 145,
        Title: 'Portable 4K Monitor',
        Description:
            'Experience improved productivity with this Portable 4K Monitor, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-05-25',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 891,
        },
    },
    {
        ProductID: 146,
        Title: 'Ultra External SSD',
        Description:
            'Upgrade your setup with the Ultra External SSD, engineered for speed, durability, and convenience.',
        datasetDate: '2024-05-26',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 854,
        },
    },
    {
        ProductID: 147,
        Title: 'Pro Laptop Stand',
        Description: 'The Pro Laptop Stand combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-05-27',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 636,
        },
    },
    {
        ProductID: 148,
        Title: 'Wireless Home Security Camera',
        Description:
            'Designed for everyday use, this Wireless Home Security Camera delivers reliable performance and modern features.',
        datasetDate: '2024-05-28',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 552,
        },
    },
    {
        ProductID: 149,
        Title: 'Durable Home Security Camera',
        Description:
            'A versatile Home Security Camera featuring durable construction and dependable performance for daily tasks.',
        datasetDate: '2024-05-29',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 253,
        },
    },
    {
        ProductID: 150,
        Title: 'Premium External SSD',
        Description:
            'Upgrade your setup with the Premium External SSD, engineered for speed, durability, and convenience.',
        datasetDate: '2024-05-30',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 450,
        },
    },
    {
        ProductID: 151,
        Title: 'Pro Noise Cancelling Headphones',
        Description:
            'Designed for everyday use, this Pro Noise Cancelling Headphones delivers reliable performance and modern features.',
        datasetDate: '2024-05-31',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 248,
        },
    },
    {
        ProductID: 152,
        Title: 'Ultra Smart Plug',
        Description: 'The Ultra Smart Plug combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-06-01',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 905,
        },
    },
    {
        ProductID: 153,
        Title: 'Ultra Action Camera',
        Description:
            'Designed for everyday use, this Ultra Action Camera delivers reliable performance and modern features.',
        datasetDate: '2024-06-02',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 813,
        },
    },
    {
        ProductID: 154,
        Title: 'Ultra External SSD',
        Description:
            'Upgrade your setup with the Ultra External SSD, engineered for speed, durability, and convenience.',
        datasetDate: '2024-06-03',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 104,
        },
    },
    {
        ProductID: 155,
        Title: 'Durable Bluetooth Speaker',
        Description:
            'A versatile Bluetooth Speaker featuring durable construction and dependable performance for daily tasks.',
        datasetDate: '2024-06-04',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 664,
        },
    },
    {
        ProductID: 156,
        Title: 'Portable Smart LED Bulb',
        Description:
            'Upgrade your setup with the Portable Smart LED Bulb, engineered for speed, durability, and convenience.',
        datasetDate: '2024-06-05',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 570,
        },
    },
    {
        ProductID: 157,
        Title: 'Compact Home Security Camera',
        Description:
            'A versatile Home Security Camera featuring compact construction and dependable performance for daily tasks.',
        datasetDate: '2024-06-06',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 867,
        },
    },
    {
        ProductID: 158,
        Title: 'Compact USB-C Hub',
        Description: 'A versatile USB-C Hub featuring compact construction and dependable performance for daily tasks.',
        datasetDate: '2024-06-07',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 951,
        },
    },
    {
        ProductID: 159,
        Title: 'Wireless Bluetooth Speaker',
        Description:
            'Experience improved productivity with this Wireless Bluetooth Speaker, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-06-08',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 562,
        },
    },
    {
        ProductID: 160,
        Title: 'Ultra Coffee Grinder',
        Description:
            'Upgrade your setup with the Ultra Coffee Grinder, engineered for speed, durability, and convenience.',
        datasetDate: '2024-06-09',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 564,
        },
    },
    {
        ProductID: 161,
        Title: 'Smart Home Security Camera',
        Description:
            'A versatile Home Security Camera featuring smart construction and dependable performance for daily tasks.',
        datasetDate: '2024-06-10',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 249,
        },
    },
    {
        ProductID: 162,
        Title: 'Wireless Gaming Mouse',
        Description:
            'Experience improved productivity with this Wireless Gaming Mouse, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-06-11',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 423,
        },
    },
    {
        ProductID: 163,
        Title: 'Advanced Wireless Charger',
        Description:
            'The Advanced Wireless Charger combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-06-12',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 492,
        },
    },
    {
        ProductID: 164,
        Title: 'Ultra Laptop Stand',
        Description:
            'Upgrade your setup with the Ultra Laptop Stand, engineered for speed, durability, and convenience.',
        datasetDate: '2024-06-13',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 210,
        },
    },
    {
        ProductID: 165,
        Title: 'Ultra Home Security Camera',
        Description:
            'Upgrade your setup with the Ultra Home Security Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-06-14',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 363,
        },
    },
    {
        ProductID: 166,
        Title: 'Wireless Bluetooth Speaker',
        Description:
            'Designed for everyday use, this Wireless Bluetooth Speaker delivers reliable performance and modern features.',
        datasetDate: '2024-06-15',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 499,
        },
    },
    {
        ProductID: 167,
        Title: 'Compact Mechanical Keyboard',
        Description:
            'Upgrade your setup with the Compact Mechanical Keyboard, engineered for speed, durability, and convenience.',
        datasetDate: '2024-06-16',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 190,
        },
    },
    {
        ProductID: 168,
        Title: 'Ultra Electric Toothbrush',
        Description:
            'A versatile Electric Toothbrush featuring ultra construction and dependable performance for daily tasks.',
        datasetDate: '2024-06-17',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 607,
        },
    },
    {
        ProductID: 169,
        Title: 'Wireless Noise Cancelling Headphones',
        Description:
            'The Wireless Noise Cancelling Headphones combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-06-18',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 163,
        },
    },
    {
        ProductID: 170,
        Title: 'Eco Air Purifier',
        Description: 'A versatile Air Purifier featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-06-19',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 578,
        },
    },
    {
        ProductID: 171,
        Title: 'Eco Bluetooth Speaker',
        Description:
            'The Eco Bluetooth Speaker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-06-20',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 806,
        },
    },
    {
        ProductID: 172,
        Title: 'Premium Laptop Stand',
        Description:
            'A versatile Laptop Stand featuring premium construction and dependable performance for daily tasks.',
        datasetDate: '2024-06-21',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 550,
        },
    },
    {
        ProductID: 173,
        Title: 'Premium Air Purifier',
        Description:
            'The Premium Air Purifier combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-06-22',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 188,
        },
    },
    {
        ProductID: 174,
        Title: 'Advanced Action Camera',
        Description:
            'Designed for everyday use, this Advanced Action Camera delivers reliable performance and modern features.',
        datasetDate: '2024-06-23',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 732,
        },
    },
    {
        ProductID: 175,
        Title: 'Eco USB-C Hub',
        Description:
            'Experience improved productivity with this Eco USB-C Hub, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-06-24',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 454,
        },
    },
    {
        ProductID: 176,
        Title: 'Wireless Mechanical Keyboard',
        Description:
            'A versatile Mechanical Keyboard featuring wireless construction and dependable performance for daily tasks.',
        datasetDate: '2024-06-25',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 267,
        },
    },
    {
        ProductID: 177,
        Title: 'Eco Mechanical Keyboard',
        Description:
            'A versatile Mechanical Keyboard featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-06-26',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 680,
        },
    },
    {
        ProductID: 178,
        Title: 'Wireless Webcam',
        Description: 'Upgrade your setup with the Wireless Webcam, engineered for speed, durability, and convenience.',
        datasetDate: '2024-06-27',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 947,
        },
    },
    {
        ProductID: 179,
        Title: 'Wireless Smart LED Bulb',
        Description:
            'Experience improved productivity with this Wireless Smart LED Bulb, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-06-28',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 12,
        },
    },
    {
        ProductID: 180,
        Title: 'Compact Webcam',
        Description: 'Upgrade your setup with the Compact Webcam, engineered for speed, durability, and convenience.',
        datasetDate: '2024-06-29',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 572,
        },
    },
    {
        ProductID: 181,
        Title: 'Wireless Action Camera',
        Description:
            'Designed for everyday use, this Wireless Action Camera delivers reliable performance and modern features.',
        datasetDate: '2024-06-30',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 11,
        },
    },
    {
        ProductID: 182,
        Title: 'Smart Wireless Charger',
        Description:
            'Designed for everyday use, this Smart Wireless Charger delivers reliable performance and modern features.',
        datasetDate: '2024-07-01',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 743,
        },
    },
    {
        ProductID: 183,
        Title: 'Compact Mechanical Keyboard',
        Description:
            'Upgrade your setup with the Compact Mechanical Keyboard, engineered for speed, durability, and convenience.',
        datasetDate: '2024-07-02',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 971,
        },
    },
    {
        ProductID: 184,
        Title: 'Advanced Smart Plug',
        Description:
            'Upgrade your setup with the Advanced Smart Plug, engineered for speed, durability, and convenience.',
        datasetDate: '2024-07-03',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 54,
        },
    },
    {
        ProductID: 185,
        Title: 'Portable External SSD',
        Description:
            'Experience improved productivity with this Portable External SSD, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-07-04',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 366,
        },
    },
    {
        ProductID: 186,
        Title: 'Pro Home Security Camera',
        Description:
            'Experience improved productivity with this Pro Home Security Camera, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-07-05',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 451,
        },
    },
    {
        ProductID: 187,
        Title: 'Premium Electric Toothbrush',
        Description:
            'A versatile Electric Toothbrush featuring premium construction and dependable performance for daily tasks.',
        datasetDate: '2024-07-06',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 170,
        },
    },
    {
        ProductID: 188,
        Title: 'Eco Mechanical Keyboard',
        Description:
            'Designed for everyday use, this Eco Mechanical Keyboard delivers reliable performance and modern features.',
        datasetDate: '2024-07-07',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 634,
        },
    },
    {
        ProductID: 189,
        Title: 'Portable Fitness Tracker',
        Description:
            'A versatile Fitness Tracker featuring portable construction and dependable performance for daily tasks.',
        datasetDate: '2024-07-08',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 856,
        },
    },
    {
        ProductID: 190,
        Title: 'Durable Home Security Camera',
        Description:
            'Designed for everyday use, this Durable Home Security Camera delivers reliable performance and modern features.',
        datasetDate: '2024-07-09',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 562,
        },
    },
    {
        ProductID: 191,
        Title: 'Smart Action Camera',
        Description:
            'Experience improved productivity with this Smart Action Camera, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-07-10',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 637,
        },
    },
    {
        ProductID: 192,
        Title: 'Premium Electric Toothbrush',
        Description:
            'Designed for everyday use, this Premium Electric Toothbrush delivers reliable performance and modern features.',
        datasetDate: '2024-07-11',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 225,
        },
    },
    {
        ProductID: 193,
        Title: 'Eco Wireless Charger',
        Description:
            'A versatile Wireless Charger featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-07-12',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 241,
        },
    },
    {
        ProductID: 194,
        Title: 'Pro Fitness Tracker',
        Description:
            'Upgrade your setup with the Pro Fitness Tracker, engineered for speed, durability, and convenience.',
        datasetDate: '2024-07-13',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 749,
        },
    },
    {
        ProductID: 195,
        Title: 'Wireless Coffee Grinder',
        Description:
            'The Wireless Coffee Grinder combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-07-14',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 416,
        },
    },
    {
        ProductID: 196,
        Title: 'Wireless Smart LED Bulb',
        Description:
            'Experience improved productivity with this Wireless Smart LED Bulb, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-07-15',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 833,
        },
    },
    {
        ProductID: 197,
        Title: 'Premium Webcam',
        Description: 'Upgrade your setup with the Premium Webcam, engineered for speed, durability, and convenience.',
        datasetDate: '2024-07-16',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 863,
        },
    },
    {
        ProductID: 198,
        Title: 'Eco 4K Monitor',
        Description: 'Upgrade your setup with the Eco 4K Monitor, engineered for speed, durability, and convenience.',
        datasetDate: '2024-07-17',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 603,
        },
    },
    {
        ProductID: 199,
        Title: 'Compact Wireless Charger',
        Description:
            'The Compact Wireless Charger combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-07-18',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 470,
        },
    },
    {
        ProductID: 200,
        Title: 'Durable Action Camera',
        Description:
            'Upgrade your setup with the Durable Action Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-07-19',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 383,
        },
    },
    {
        ProductID: 201,
        Title: 'Durable Air Purifier',
        Description:
            'Experience improved productivity with this Durable Air Purifier, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-07-20',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 950,
        },
    },
    {
        ProductID: 202,
        Title: 'Pro Webcam',
        Description: 'A versatile Webcam featuring pro construction and dependable performance for daily tasks.',
        datasetDate: '2024-07-21',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 268,
        },
    },
    {
        ProductID: 203,
        Title: 'Premium Robot Vacuum',
        Description:
            'The Premium Robot Vacuum combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-07-22',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 981,
        },
    },
    {
        ProductID: 204,
        Title: 'Premium Action Camera',
        Description:
            'A versatile Action Camera featuring premium construction and dependable performance for daily tasks.',
        datasetDate: '2024-07-23',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 302,
        },
    },
    {
        ProductID: 205,
        Title: 'Advanced Fitness Tracker',
        Description:
            'Designed for everyday use, this Advanced Fitness Tracker delivers reliable performance and modern features.',
        datasetDate: '2024-07-24',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 521,
        },
    },
    {
        ProductID: 206,
        Title: 'Eco Mechanical Keyboard',
        Description:
            'A versatile Mechanical Keyboard featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-07-25',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 223,
        },
    },
    {
        ProductID: 207,
        Title: 'Pro Coffee Grinder',
        Description:
            'Upgrade your setup with the Pro Coffee Grinder, engineered for speed, durability, and convenience.',
        datasetDate: '2024-07-26',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 719,
        },
    },
    {
        ProductID: 208,
        Title: 'Wireless Mechanical Keyboard',
        Description:
            'A versatile Mechanical Keyboard featuring wireless construction and dependable performance for daily tasks.',
        datasetDate: '2024-07-27',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 332,
        },
    },
    {
        ProductID: 209,
        Title: 'Eco Action Camera',
        Description:
            'Experience improved productivity with this Eco Action Camera, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-07-28',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 489,
        },
    },
    {
        ProductID: 210,
        Title: 'Ultra Robot Vacuum',
        Description:
            'Experience improved productivity with this Ultra Robot Vacuum, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-07-29',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 444,
        },
    },
    {
        ProductID: 211,
        Title: 'Portable Noise Cancelling Headphones',
        Description:
            // eslint-disable-next-line max-len
            'Experience improved productivity with this Portable Noise Cancelling Headphones, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-07-30',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 350,
        },
    },
    {
        ProductID: 212,
        Title: 'Smart USB-C Hub',
        Description:
            'Designed for everyday use, this Smart USB-C Hub delivers reliable performance and modern features.',
        datasetDate: '2024-07-31',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 758,
        },
    },
    {
        ProductID: 213,
        Title: 'Pro Coffee Grinder',
        Description:
            'A versatile Coffee Grinder featuring pro construction and dependable performance for daily tasks.',
        datasetDate: '2024-08-01',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 784,
        },
    },
    {
        ProductID: 214,
        Title: 'Pro Fitness Tracker',
        Description:
            'The Pro Fitness Tracker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-08-02',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 392,
        },
    },
    {
        ProductID: 215,
        Title: 'Wireless Smart LED Bulb',
        Description:
            'Experience improved productivity with this Wireless Smart LED Bulb, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-08-03',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 452,
        },
    },
    {
        ProductID: 216,
        Title: 'Pro Air Purifier',
        Description:
            'Experience improved productivity with this Pro Air Purifier, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-08-04',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 445,
        },
    },
    {
        ProductID: 217,
        Title: 'Ultra Fitness Tracker',
        Description:
            'The Ultra Fitness Tracker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-08-05',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 537,
        },
    },
    {
        ProductID: 218,
        Title: 'Ultra Mechanical Keyboard',
        Description:
            'A versatile Mechanical Keyboard featuring ultra construction and dependable performance for daily tasks.',
        datasetDate: '2024-08-06',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 654,
        },
    },
    {
        ProductID: 219,
        Title: 'Premium Robot Vacuum',
        Description:
            'A versatile Robot Vacuum featuring premium construction and dependable performance for daily tasks.',
        datasetDate: '2024-08-07',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 619,
        },
    },
    {
        ProductID: 220,
        Title: 'Compact Smart LED Bulb',
        Description:
            'Upgrade your setup with the Compact Smart LED Bulb, engineered for speed, durability, and convenience.',
        datasetDate: '2024-08-08',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 593,
        },
    },
    {
        ProductID: 221,
        Title: 'Advanced Bluetooth Speaker',
        Description:
            'The Advanced Bluetooth Speaker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-08-09',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 291,
        },
    },
    {
        ProductID: 222,
        Title: 'Eco Smart Plug',
        Description:
            'Experience improved productivity with this Eco Smart Plug, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-08-10',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 377,
        },
    },
    {
        ProductID: 223,
        Title: 'Premium Fitness Tracker',
        Description:
            'Experience improved productivity with this Premium Fitness Tracker, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-08-11',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 158,
        },
    },
    {
        ProductID: 224,
        Title: 'Eco Smart LED Bulb',
        Description:
            'Designed for everyday use, this Eco Smart LED Bulb delivers reliable performance and modern features.',
        datasetDate: '2024-08-12',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 65,
        },
    },
    {
        ProductID: 225,
        Title: 'Portable Home Security Camera',
        Description:
            'Experience improved productivity with this Portable Home Security Camera, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-08-13',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 700,
        },
    },
    {
        ProductID: 226,
        Title: 'Eco Bluetooth Speaker',
        Description:
            'Designed for everyday use, this Eco Bluetooth Speaker delivers reliable performance and modern features.',
        datasetDate: '2024-08-14',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 888,
        },
    },
    {
        ProductID: 227,
        Title: 'Wireless Laptop Stand',
        Description:
            'The Wireless Laptop Stand combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-08-15',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 259,
        },
    },
    {
        ProductID: 228,
        Title: 'Ultra Bluetooth Speaker',
        Description:
            'Upgrade your setup with the Ultra Bluetooth Speaker, engineered for speed, durability, and convenience.',
        datasetDate: '2024-08-16',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 638,
        },
    },
    {
        ProductID: 229,
        Title: 'Portable Noise Cancelling Headphones',
        Description:
            'Upgrade your setup with the Portable Noise Cancelling Headphones, engineered for speed, durability, and convenience.',
        datasetDate: '2024-08-17',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 564,
        },
    },
    {
        ProductID: 230,
        Title: 'Pro Smart Plug',
        Description:
            'Experience improved productivity with this Pro Smart Plug, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-08-18',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 847,
        },
    },
    {
        ProductID: 231,
        Title: 'Wireless Action Camera',
        Description:
            'Upgrade your setup with the Wireless Action Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-08-19',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 480,
        },
    },
    {
        ProductID: 232,
        Title: 'Compact Wireless Charger',
        Description:
            'Experience improved productivity with this Compact Wireless Charger, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-08-20',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 674,
        },
    },
    {
        ProductID: 233,
        Title: 'Portable Smart LED Bulb',
        Description:
            'A versatile Smart LED Bulb featuring portable construction and dependable performance for daily tasks.',
        datasetDate: '2024-08-21',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 89,
        },
    },
    {
        ProductID: 234,
        Title: 'Wireless Mechanical Keyboard',
        Description:
            'Experience improved productivity with this Wireless Mechanical Keyboard, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-08-22',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 345,
        },
    },
    {
        ProductID: 235,
        Title: 'Smart 4K Monitor',
        Description:
            'Designed for everyday use, this Smart 4K Monitor delivers reliable performance and modern features.',
        datasetDate: '2024-08-23',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 677,
        },
    },
    {
        ProductID: 236,
        Title: 'Premium 4K Monitor',
        Description: 'The Premium 4K Monitor combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-08-24',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 868,
        },
    },
    {
        ProductID: 237,
        Title: 'Smart USB-C Hub',
        Description:
            'Designed for everyday use, this Smart USB-C Hub delivers reliable performance and modern features.',
        datasetDate: '2024-08-25',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 970,
        },
    },
    {
        ProductID: 238,
        Title: 'Pro Webcam',
        Description:
            'Experience improved productivity with this Pro Webcam, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-08-26',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 715,
        },
    },
    {
        ProductID: 239,
        Title: 'Compact Laptop Stand',
        Description:
            'The Compact Laptop Stand combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-08-27',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 491,
        },
    },
    {
        ProductID: 240,
        Title: 'Eco Home Security Camera',
        Description:
            'The Eco Home Security Camera combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-08-28',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 86,
        },
    },
    {
        ProductID: 241,
        Title: 'Eco Coffee Grinder',
        Description:
            'A versatile Coffee Grinder featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-08-29',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 818,
        },
    },
    {
        ProductID: 242,
        Title: 'Smart Bluetooth Speaker',
        Description:
            'The Smart Bluetooth Speaker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-08-30',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 484,
        },
    },
    {
        ProductID: 243,
        Title: 'Premium Action Camera',
        Description:
            'Upgrade your setup with the Premium Action Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-08-31',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 950,
        },
    },
    {
        ProductID: 244,
        Title: 'Durable Home Security Camera',
        Description:
            'Experience improved productivity with this Durable Home Security Camera, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-09-01',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 544,
        },
    },
    {
        ProductID: 245,
        Title: 'Durable USB-C Hub',
        Description:
            'Experience improved productivity with this Durable USB-C Hub, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-09-02',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 711,
        },
    },
    {
        ProductID: 246,
        Title: 'Portable 4K Monitor',
        Description:
            'The Portable 4K Monitor combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-09-03',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 851,
        },
    },
    {
        ProductID: 247,
        Title: 'Eco Fitness Tracker',
        Description:
            'Designed for everyday use, this Eco Fitness Tracker delivers reliable performance and modern features.',
        datasetDate: '2024-09-04',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 220,
        },
    },
    {
        ProductID: 248,
        Title: 'Advanced Webcam',
        Description: 'Upgrade your setup with the Advanced Webcam, engineered for speed, durability, and convenience.',
        datasetDate: '2024-09-05',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 161,
        },
    },
    {
        ProductID: 249,
        Title: 'Portable Smart Plug',
        Description:
            'A versatile Smart Plug featuring portable construction and dependable performance for daily tasks.',
        datasetDate: '2024-09-06',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 468,
        },
    },
    {
        ProductID: 250,
        Title: 'Advanced Smart LED Bulb',
        Description:
            'A versatile Smart LED Bulb featuring advanced construction and dependable performance for daily tasks.',
        datasetDate: '2024-09-07',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 544,
        },
    },
    {
        ProductID: 251,
        Title: 'Wireless 4K Monitor',
        Description:
            'A versatile 4K Monitor featuring wireless construction and dependable performance for daily tasks.',
        datasetDate: '2024-09-08',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 738,
        },
    },
    {
        ProductID: 252,
        Title: 'Advanced Bluetooth Speaker',
        Description:
            'Designed for everyday use, this Advanced Bluetooth Speaker delivers reliable performance and modern features.',
        datasetDate: '2024-09-09',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 58,
        },
    },
    {
        ProductID: 253,
        Title: 'Ultra Action Camera',
        Description:
            'The Ultra Action Camera combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-09-10',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 1,
        },
    },
    {
        ProductID: 254,
        Title: 'Pro Air Purifier',
        Description: 'The Pro Air Purifier combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-09-11',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 387,
        },
    },
    {
        ProductID: 255,
        Title: 'Smart Electric Toothbrush',
        Description:
            'Designed for everyday use, this Smart Electric Toothbrush delivers reliable performance and modern features.',
        datasetDate: '2024-09-12',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 207,
        },
    },
    {
        ProductID: 256,
        Title: 'Pro Home Security Camera',
        Description:
            'Upgrade your setup with the Pro Home Security Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-09-13',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 984,
        },
    },
    {
        ProductID: 257,
        Title: 'Durable Mechanical Keyboard',
        Description:
            'Designed for everyday use, this Durable Mechanical Keyboard delivers reliable performance and modern features.',
        datasetDate: '2024-09-14',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 97,
        },
    },
    {
        ProductID: 258,
        Title: 'Smart Wireless Charger',
        Description:
            'A versatile Wireless Charger featuring smart construction and dependable performance for daily tasks.',
        datasetDate: '2024-09-15',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 821,
        },
    },
    {
        ProductID: 259,
        Title: 'Smart Air Purifier',
        Description:
            'A versatile Air Purifier featuring smart construction and dependable performance for daily tasks.',
        datasetDate: '2024-09-16',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 558,
        },
    },
    {
        ProductID: 260,
        Title: 'Premium Smart Plug',
        Description:
            'Experience improved productivity with this Premium Smart Plug, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-09-17',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 683,
        },
    },
    {
        ProductID: 261,
        Title: 'Smart Air Purifier',
        Description:
            'Upgrade your setup with the Smart Air Purifier, engineered for speed, durability, and convenience.',
        datasetDate: '2024-09-18',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 434,
        },
    },
    {
        ProductID: 262,
        Title: 'Ultra 4K Monitor',
        Description: 'The Ultra 4K Monitor combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-09-19',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 630,
        },
    },
    {
        ProductID: 263,
        Title: 'Wireless Wireless Charger',
        Description:
            'Designed for everyday use, this Wireless Wireless Charger delivers reliable performance and modern features.',
        datasetDate: '2024-09-20',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 324,
        },
    },
    {
        ProductID: 264,
        Title: 'Smart Laptop Stand',
        Description: 'The Smart Laptop Stand combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-09-21',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 70,
        },
    },
    {
        ProductID: 265,
        Title: 'Wireless Fitness Tracker',
        Description:
            'A versatile Fitness Tracker featuring wireless construction and dependable performance for daily tasks.',
        datasetDate: '2024-09-22',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 95,
        },
    },
    {
        ProductID: 266,
        Title: 'Portable Robot Vacuum',
        Description:
            'Designed for everyday use, this Portable Robot Vacuum delivers reliable performance and modern features.',
        datasetDate: '2024-09-23',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 556,
        },
    },
    {
        ProductID: 267,
        Title: 'Advanced Electric Toothbrush',
        Description:
            'Experience improved productivity with this Advanced Electric Toothbrush, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-09-24',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 294,
        },
    },
    {
        ProductID: 268,
        Title: 'Wireless Air Purifier',
        Description:
            'Designed for everyday use, this Wireless Air Purifier delivers reliable performance and modern features.',
        datasetDate: '2024-09-25',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 844,
        },
    },
    {
        ProductID: 269,
        Title: 'Wireless Electric Toothbrush',
        Description:
            'Designed for everyday use, this Wireless Electric Toothbrush delivers reliable performance and modern features.',
        datasetDate: '2024-09-26',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 804,
        },
    },
    {
        ProductID: 270,
        Title: 'Portable Coffee Grinder',
        Description:
            'Upgrade your setup with the Portable Coffee Grinder, engineered for speed, durability, and convenience.',
        datasetDate: '2024-09-27',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 750,
        },
    },
    {
        ProductID: 271,
        Title: 'Pro External SSD',
        Description:
            'Designed for everyday use, this Pro External SSD delivers reliable performance and modern features.',
        datasetDate: '2024-09-28',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 183,
        },
    },
    {
        ProductID: 272,
        Title: 'Premium Bluetooth Speaker',
        Description:
            'The Premium Bluetooth Speaker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-09-29',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 548,
        },
    },
    {
        ProductID: 273,
        Title: 'Portable Coffee Grinder',
        Description:
            'Designed for everyday use, this Portable Coffee Grinder delivers reliable performance and modern features.',
        datasetDate: '2024-09-30',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 571,
        },
    },
    {
        ProductID: 274,
        Title: 'Smart USB-C Hub',
        Description: 'A versatile USB-C Hub featuring smart construction and dependable performance for daily tasks.',
        datasetDate: '2024-10-01',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 260,
        },
    },
    {
        ProductID: 275,
        Title: 'Smart Smart Plug',
        Description:
            'Designed for everyday use, this Smart Smart Plug delivers reliable performance and modern features.',
        datasetDate: '2024-10-02',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 300,
        },
    },
    {
        ProductID: 276,
        Title: 'Smart Noise Cancelling Headphones',
        Description:
            'Designed for everyday use, this Smart Noise Cancelling Headphones delivers reliable performance and modern features.',
        datasetDate: '2024-10-03',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 192,
        },
    },
    {
        ProductID: 277,
        Title: 'Compact Electric Toothbrush',
        Description:
            'Designed for everyday use, this Compact Electric Toothbrush delivers reliable performance and modern features.',
        datasetDate: '2024-10-04',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 167,
        },
    },
    {
        ProductID: 278,
        Title: 'Eco Electric Toothbrush',
        Description:
            'The Eco Electric Toothbrush combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-10-05',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 346,
        },
    },
    {
        ProductID: 279,
        Title: 'Portable Noise Cancelling Headphones',
        Description:
            // eslint-disable-next-line max-len
            'Experience improved productivity with this Portable Noise Cancelling Headphones, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-10-06',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 531,
        },
    },
    {
        ProductID: 280,
        Title: 'Pro Mechanical Keyboard',
        Description:
            'The Pro Mechanical Keyboard combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-10-07',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 426,
        },
    },
    {
        ProductID: 281,
        Title: 'Ultra Wireless Charger',
        Description:
            'A versatile Wireless Charger featuring ultra construction and dependable performance for daily tasks.',
        datasetDate: '2024-10-08',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 301,
        },
    },
    {
        ProductID: 282,
        Title: 'Wireless Laptop Stand',
        Description:
            'The Wireless Laptop Stand combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-10-09',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 852,
        },
    },
    {
        ProductID: 283,
        Title: 'Ultra External SSD',
        Description:
            'Upgrade your setup with the Ultra External SSD, engineered for speed, durability, and convenience.',
        datasetDate: '2024-10-10',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 74,
        },
    },
    {
        ProductID: 284,
        Title: 'Durable Robot Vacuum',
        Description:
            'Designed for everyday use, this Durable Robot Vacuum delivers reliable performance and modern features.',
        datasetDate: '2024-10-11',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 395,
        },
    },
    {
        ProductID: 285,
        Title: 'Ultra Webcam',
        Description: 'The Ultra Webcam combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-10-12',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 775,
        },
    },
    {
        ProductID: 286,
        Title: 'Premium Robot Vacuum',
        Description:
            'Upgrade your setup with the Premium Robot Vacuum, engineered for speed, durability, and convenience.',
        datasetDate: '2024-10-13',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 357,
        },
    },
    {
        ProductID: 287,
        Title: 'Eco Wireless Charger',
        Description:
            'The Eco Wireless Charger combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-10-14',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 983,
        },
    },
    {
        ProductID: 288,
        Title: 'Premium Home Security Camera',
        Description:
            'Experience improved productivity with this Premium Home Security Camera, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-10-15',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 925,
        },
    },
    {
        ProductID: 289,
        Title: 'Pro Noise Cancelling Headphones',
        Description:
            'The Pro Noise Cancelling Headphones combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-10-16',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 323,
        },
    },
    {
        ProductID: 290,
        Title: 'Durable Electric Toothbrush',
        Description:
            'A versatile Electric Toothbrush featuring durable construction and dependable performance for daily tasks.',
        datasetDate: '2024-10-17',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 508,
        },
    },
    {
        ProductID: 291,
        Title: 'Pro 4K Monitor',
        Description: 'Upgrade your setup with the Pro 4K Monitor, engineered for speed, durability, and convenience.',
        datasetDate: '2024-10-18',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 331,
        },
    },
    {
        ProductID: 292,
        Title: 'Ultra Coffee Grinder',
        Description:
            'A versatile Coffee Grinder featuring ultra construction and dependable performance for daily tasks.',
        datasetDate: '2024-10-19',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 543,
        },
    },
    {
        ProductID: 293,
        Title: 'Smart Noise Cancelling Headphones',
        Description:
            'Experience improved productivity with this Smart Noise Cancelling Headphones, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-10-20',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 994,
        },
    },
    {
        ProductID: 294,
        Title: 'Advanced Action Camera',
        Description:
            'Upgrade your setup with the Advanced Action Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-10-21',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 434,
        },
    },
    {
        ProductID: 295,
        Title: 'Compact Robot Vacuum',
        Description:
            'Designed for everyday use, this Compact Robot Vacuum delivers reliable performance and modern features.',
        datasetDate: '2024-10-22',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 37,
        },
    },
    {
        ProductID: 296,
        Title: 'Compact Robot Vacuum',
        Description:
            'The Compact Robot Vacuum combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-10-23',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 520,
        },
    },
    {
        ProductID: 297,
        Title: 'Portable Action Camera',
        Description:
            'Designed for everyday use, this Portable Action Camera delivers reliable performance and modern features.',
        datasetDate: '2024-10-24',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 206,
        },
    },
    {
        ProductID: 298,
        Title: 'Compact Home Security Camera',
        Description:
            'Upgrade your setup with the Compact Home Security Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-10-25',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 772,
        },
    },
    {
        ProductID: 299,
        Title: 'Wireless Smart Plug',
        Description:
            'Designed for everyday use, this Wireless Smart Plug delivers reliable performance and modern features.',
        datasetDate: '2024-10-26',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 751,
        },
    },
    {
        ProductID: 300,
        Title: 'Portable Coffee Grinder',
        Description:
            'Designed for everyday use, this Portable Coffee Grinder delivers reliable performance and modern features.',
        datasetDate: '2024-10-27',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 497,
        },
    },
    {
        ProductID: 301,
        Title: 'Compact Smart Plug',
        Description:
            'Experience improved productivity with this Compact Smart Plug, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-10-28',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 982,
        },
    },
    {
        ProductID: 302,
        Title: 'Durable Mechanical Keyboard',
        Description:
            'Designed for everyday use, this Durable Mechanical Keyboard delivers reliable performance and modern features.',
        datasetDate: '2024-10-29',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 210,
        },
    },
    {
        ProductID: 303,
        Title: 'Portable Action Camera',
        Description:
            'Designed for everyday use, this Portable Action Camera delivers reliable performance and modern features.',
        datasetDate: '2024-10-30',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 674,
        },
    },
    {
        ProductID: 304,
        Title: 'Durable Air Purifier',
        Description:
            'Experience improved productivity with this Durable Air Purifier, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-10-31',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 344,
        },
    },
    {
        ProductID: 305,
        Title: 'Portable Smart Plug',
        Description:
            'Upgrade your setup with the Portable Smart Plug, engineered for speed, durability, and convenience.',
        datasetDate: '2024-11-01',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 813,
        },
    },
    {
        ProductID: 306,
        Title: 'Portable Laptop Stand',
        Description:
            'Experience improved productivity with this Portable Laptop Stand, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-11-02',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 997,
        },
    },
    {
        ProductID: 307,
        Title: 'Eco Robot Vacuum',
        Description: 'Upgrade your setup with the Eco Robot Vacuum, engineered for speed, durability, and convenience.',
        datasetDate: '2024-11-03',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 96,
        },
    },
    {
        ProductID: 308,
        Title: 'Eco Fitness Tracker',
        Description:
            'Designed for everyday use, this Eco Fitness Tracker delivers reliable performance and modern features.',
        datasetDate: '2024-11-04',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 789,
        },
    },
    {
        ProductID: 309,
        Title: 'Ultra Action Camera',
        Description:
            'Experience improved productivity with this Ultra Action Camera, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-11-05',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 862,
        },
    },
    {
        ProductID: 310,
        Title: 'Advanced Gaming Mouse',
        Description:
            'The Advanced Gaming Mouse combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-11-06',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 656,
        },
    },
    {
        ProductID: 311,
        Title: 'Durable Home Security Camera',
        Description:
            'Designed for everyday use, this Durable Home Security Camera delivers reliable performance and modern features.',
        datasetDate: '2024-11-07',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 353,
        },
    },
    {
        ProductID: 312,
        Title: 'Pro Smart Plug',
        Description: 'A versatile Smart Plug featuring pro construction and dependable performance for daily tasks.',
        datasetDate: '2024-11-08',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 714,
        },
    },
    {
        ProductID: 313,
        Title: 'Durable Action Camera',
        Description:
            'Experience improved productivity with this Durable Action Camera, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-11-09',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 891,
        },
    },
    {
        ProductID: 314,
        Title: 'Portable Wireless Charger',
        Description:
            'A versatile Wireless Charger featuring portable construction and dependable performance for daily tasks.',
        datasetDate: '2024-11-10',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 41,
        },
    },
    {
        ProductID: 315,
        Title: 'Pro Coffee Grinder',
        Description:
            'Designed for everyday use, this Pro Coffee Grinder delivers reliable performance and modern features.',
        datasetDate: '2024-11-11',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 441,
        },
    },
    {
        ProductID: 316,
        Title: 'Advanced Bluetooth Speaker',
        Description:
            'The Advanced Bluetooth Speaker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-11-12',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 798,
        },
    },
    {
        ProductID: 317,
        Title: 'Premium Laptop Stand',
        Description:
            'A versatile Laptop Stand featuring premium construction and dependable performance for daily tasks.',
        datasetDate: '2024-11-13',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 193,
        },
    },
    {
        ProductID: 318,
        Title: 'Durable Smart LED Bulb',
        Description:
            'Upgrade your setup with the Durable Smart LED Bulb, engineered for speed, durability, and convenience.',
        datasetDate: '2024-11-14',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 14,
        },
    },
    {
        ProductID: 319,
        Title: 'Compact Fitness Tracker',
        Description:
            'The Compact Fitness Tracker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-11-15',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 491,
        },
    },
    {
        ProductID: 320,
        Title: 'Ultra Gaming Mouse',
        Description:
            'Experience improved productivity with this Ultra Gaming Mouse, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-11-16',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 753,
        },
    },
    {
        ProductID: 321,
        Title: 'Portable Gaming Mouse',
        Description:
            'A versatile Gaming Mouse featuring portable construction and dependable performance for daily tasks.',
        datasetDate: '2024-11-17',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 843,
        },
    },
    {
        ProductID: 322,
        Title: 'Smart 4K Monitor',
        Description: 'The Smart 4K Monitor combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-11-18',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 22,
        },
    },
    {
        ProductID: 323,
        Title: 'Compact Webcam',
        Description:
            'Designed for everyday use, this Compact Webcam delivers reliable performance and modern features.',
        datasetDate: '2024-11-19',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 999,
        },
    },
    {
        ProductID: 324,
        Title: 'Durable Home Security Camera',
        Description:
            'Experience improved productivity with this Durable Home Security Camera, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-11-20',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 650,
        },
    },
    {
        ProductID: 325,
        Title: 'Durable Fitness Tracker',
        Description:
            'A versatile Fitness Tracker featuring durable construction and dependable performance for daily tasks.',
        datasetDate: '2024-11-21',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 206,
        },
    },
    {
        ProductID: 326,
        Title: 'Premium Webcam',
        Description: 'Upgrade your setup with the Premium Webcam, engineered for speed, durability, and convenience.',
        datasetDate: '2024-11-22',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 669,
        },
    },
    {
        ProductID: 327,
        Title: 'Portable Action Camera',
        Description:
            'Designed for everyday use, this Portable Action Camera delivers reliable performance and modern features.',
        datasetDate: '2024-11-23',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 56,
        },
    },
    {
        ProductID: 328,
        Title: 'Premium Mechanical Keyboard',
        Description:
            'Designed for everyday use, this Premium Mechanical Keyboard delivers reliable performance and modern features.',
        datasetDate: '2024-11-24',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 739,
        },
    },
    {
        ProductID: 329,
        Title: 'Ultra Webcam',
        Description:
            'Experience improved productivity with this Ultra Webcam, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-11-25',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 36,
        },
    },
    {
        ProductID: 330,
        Title: 'Eco Action Camera',
        Description:
            'Experience improved productivity with this Eco Action Camera, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-11-26',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 828,
        },
    },
    {
        ProductID: 331,
        Title: 'Premium Wireless Charger',
        Description:
            'The Premium Wireless Charger combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-11-27',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 69,
        },
    },
    {
        ProductID: 332,
        Title: 'Wireless Fitness Tracker',
        Description:
            'The Wireless Fitness Tracker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-11-28',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 894,
        },
    },
    {
        ProductID: 333,
        Title: 'Advanced Laptop Stand',
        Description:
            'The Advanced Laptop Stand combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-11-29',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 669,
        },
    },
    {
        ProductID: 334,
        Title: 'Durable Coffee Grinder',
        Description:
            'A versatile Coffee Grinder featuring durable construction and dependable performance for daily tasks.',
        datasetDate: '2024-11-30',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 994,
        },
    },
    {
        ProductID: 335,
        Title: 'Ultra Smart Plug',
        Description:
            'Designed for everyday use, this Ultra Smart Plug delivers reliable performance and modern features.',
        datasetDate: '2024-12-01',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 312,
        },
    },
    {
        ProductID: 336,
        Title: 'Smart 4K Monitor',
        Description: 'A versatile 4K Monitor featuring smart construction and dependable performance for daily tasks.',
        datasetDate: '2024-12-02',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 192,
        },
    },
    {
        ProductID: 337,
        Title: 'Premium Robot Vacuum',
        Description:
            'The Premium Robot Vacuum combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-12-03',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 224,
        },
    },
    {
        ProductID: 338,
        Title: 'Durable Smart LED Bulb',
        Description:
            'Experience improved productivity with this Durable Smart LED Bulb, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-12-04',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 119,
        },
    },
    {
        ProductID: 339,
        Title: 'Portable Fitness Tracker',
        Description:
            'A versatile Fitness Tracker featuring portable construction and dependable performance for daily tasks.',
        datasetDate: '2024-12-05',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 937,
        },
    },
    {
        ProductID: 340,
        Title: 'Compact 4K Monitor',
        Description:
            'Upgrade your setup with the Compact 4K Monitor, engineered for speed, durability, and convenience.',
        datasetDate: '2024-12-06',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 704,
        },
    },
    {
        ProductID: 341,
        Title: 'Eco Smart LED Bulb',
        Description:
            'Designed for everyday use, this Eco Smart LED Bulb delivers reliable performance and modern features.',
        datasetDate: '2024-12-07',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 967,
        },
    },
    {
        ProductID: 342,
        Title: 'Eco Wireless Charger',
        Description:
            'The Eco Wireless Charger combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-12-08',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 559,
        },
    },
    {
        ProductID: 343,
        Title: 'Pro Coffee Grinder',
        Description: 'The Pro Coffee Grinder combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-12-09',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 343,
        },
    },
    {
        ProductID: 344,
        Title: 'Portable Smart LED Bulb',
        Description:
            'Upgrade your setup with the Portable Smart LED Bulb, engineered for speed, durability, and convenience.',
        datasetDate: '2024-12-10',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 440,
        },
    },
    {
        ProductID: 345,
        Title: 'Durable USB-C Hub',
        Description: 'A versatile USB-C Hub featuring durable construction and dependable performance for daily tasks.',
        datasetDate: '2024-12-11',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 464,
        },
    },
    {
        ProductID: 346,
        Title: 'Wireless Webcam',
        Description: 'A versatile Webcam featuring wireless construction and dependable performance for daily tasks.',
        datasetDate: '2024-12-12',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 151,
        },
    },
    {
        ProductID: 347,
        Title: 'Durable Noise Cancelling Headphones',
        Description:
            // eslint-disable-next-line max-len
            'Experience improved productivity with this Durable Noise Cancelling Headphones, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-12-13',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 475,
        },
    },
    {
        ProductID: 348,
        Title: 'Wireless Robot Vacuum',
        Description:
            'Upgrade your setup with the Wireless Robot Vacuum, engineered for speed, durability, and convenience.',
        datasetDate: '2024-12-14',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 740,
        },
    },
    {
        ProductID: 349,
        Title: 'Durable Smart LED Bulb',
        Description:
            'A versatile Smart LED Bulb featuring durable construction and dependable performance for daily tasks.',
        datasetDate: '2024-12-15',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 418,
        },
    },
    {
        ProductID: 350,
        Title: 'Compact Action Camera',
        Description:
            'A versatile Action Camera featuring compact construction and dependable performance for daily tasks.',
        datasetDate: '2024-12-16',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 162,
        },
    },
    {
        ProductID: 351,
        Title: 'Portable Bluetooth Speaker',
        Description:
            'Designed for everyday use, this Portable Bluetooth Speaker delivers reliable performance and modern features.',
        datasetDate: '2024-12-17',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 525,
        },
    },
    {
        ProductID: 352,
        Title: 'Pro 4K Monitor',
        Description: 'A versatile 4K Monitor featuring pro construction and dependable performance for daily tasks.',
        datasetDate: '2024-12-18',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 945,
        },
    },
    {
        ProductID: 353,
        Title: 'Smart Gaming Mouse',
        Description:
            'Designed for everyday use, this Smart Gaming Mouse delivers reliable performance and modern features.',
        datasetDate: '2024-12-19',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 301,
        },
    },
    {
        ProductID: 354,
        Title: 'Portable Home Security Camera',
        Description:
            'Experience improved productivity with this Portable Home Security Camera, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-12-20',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 638,
        },
    },
    {
        ProductID: 355,
        Title: 'Advanced Bluetooth Speaker',
        Description:
            'Upgrade your setup with the Advanced Bluetooth Speaker, engineered for speed, durability, and convenience.',
        datasetDate: '2024-12-21',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 872,
        },
    },
    {
        ProductID: 356,
        Title: 'Ultra Bluetooth Speaker',
        Description:
            'Experience improved productivity with this Ultra Bluetooth Speaker, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-12-22',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 340,
        },
    },
    {
        ProductID: 357,
        Title: 'Premium Action Camera',
        Description:
            'Designed for everyday use, this Premium Action Camera delivers reliable performance and modern features.',
        datasetDate: '2024-12-23',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 494,
        },
    },
    {
        ProductID: 358,
        Title: 'Advanced Bluetooth Speaker',
        Description:
            'Designed for everyday use, this Advanced Bluetooth Speaker delivers reliable performance and modern features.',
        datasetDate: '2024-12-24',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 932,
        },
    },
    {
        ProductID: 359,
        Title: 'Compact Home Security Camera',
        Description:
            'The Compact Home Security Camera combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-12-25',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 598,
        },
    },
    {
        ProductID: 360,
        Title: 'Eco USB-C Hub',
        Description: 'Upgrade your setup with the Eco USB-C Hub, engineered for speed, durability, and convenience.',
        datasetDate: '2024-12-26',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 943,
        },
    },
    {
        ProductID: 361,
        Title: 'Wireless Mechanical Keyboard',
        Description:
            'A versatile Mechanical Keyboard featuring wireless construction and dependable performance for daily tasks.',
        datasetDate: '2024-12-27',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 324,
        },
    },
    {
        ProductID: 362,
        Title: 'Pro Mechanical Keyboard',
        Description:
            'The Pro Mechanical Keyboard combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-12-28',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 203,
        },
    },
    {
        ProductID: 363,
        Title: 'Smart Home Security Camera',
        Description:
            'Upgrade your setup with the Smart Home Security Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-12-29',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 22,
        },
    },
    {
        ProductID: 364,
        Title: 'Portable Smart Plug',
        Description:
            'A versatile Smart Plug featuring portable construction and dependable performance for daily tasks.',
        datasetDate: '2024-12-30',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 21,
        },
    },
    {
        ProductID: 365,
        Title: 'Durable Action Camera',
        Description:
            'Upgrade your setup with the Durable Action Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-01-01',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 211,
        },
    },
    {
        ProductID: 366,
        Title: 'Compact Action Camera',
        Description:
            'Designed for everyday use, this Compact Action Camera delivers reliable performance and modern features.',
        datasetDate: '2024-01-02',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 258,
        },
    },
    {
        ProductID: 367,
        Title: 'Wireless Bluetooth Speaker',
        Description:
            'Experience improved productivity with this Wireless Bluetooth Speaker, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-01-03',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 116,
        },
    },
    {
        ProductID: 368,
        Title: 'Compact Bluetooth Speaker',
        Description:
            'The Compact Bluetooth Speaker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-01-04',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 776,
        },
    },
    {
        ProductID: 369,
        Title: 'Pro Gaming Mouse',
        Description:
            'Experience improved productivity with this Pro Gaming Mouse, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-01-05',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 154,
        },
    },
    {
        ProductID: 370,
        Title: 'Pro Fitness Tracker',
        Description:
            'The Pro Fitness Tracker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-01-06',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 740,
        },
    },
    {
        ProductID: 371,
        Title: 'Eco Webcam',
        Description: 'A versatile Webcam featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-01-07',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 734,
        },
    },
    {
        ProductID: 372,
        Title: 'Pro USB-C Hub',
        Description: 'Upgrade your setup with the Pro USB-C Hub, engineered for speed, durability, and convenience.',
        datasetDate: '2024-01-08',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 160,
        },
    },
    {
        ProductID: 373,
        Title: 'Premium USB-C Hub',
        Description:
            'Designed for everyday use, this Premium USB-C Hub delivers reliable performance and modern features.',
        datasetDate: '2024-01-09',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 79,
        },
    },
    {
        ProductID: 374,
        Title: 'Compact Noise Cancelling Headphones',
        Description:
            'A versatile Noise Cancelling Headphones featuring compact construction and dependable performance for daily tasks.',
        datasetDate: '2024-01-10',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 228,
        },
    },
    {
        ProductID: 375,
        Title: 'Smart Smart LED Bulb',
        Description:
            'Designed for everyday use, this Smart Smart LED Bulb delivers reliable performance and modern features.',
        datasetDate: '2024-01-11',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 837,
        },
    },
    {
        ProductID: 376,
        Title: 'Advanced Air Purifier',
        Description:
            'Upgrade your setup with the Advanced Air Purifier, engineered for speed, durability, and convenience.',
        datasetDate: '2024-01-12',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 168,
        },
    },
    {
        ProductID: 377,
        Title: 'Eco Action Camera',
        Description: 'A versatile Action Camera featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-01-13',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 691,
        },
    },
    {
        ProductID: 378,
        Title: 'Ultra Laptop Stand',
        Description:
            'A versatile Laptop Stand featuring ultra construction and dependable performance for daily tasks.',
        datasetDate: '2024-01-14',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 685,
        },
    },
    {
        ProductID: 379,
        Title: 'Eco 4K Monitor',
        Description:
            'Experience improved productivity with this Eco 4K Monitor, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-01-15',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 771,
        },
    },
    {
        ProductID: 380,
        Title: 'Pro Gaming Mouse',
        Description: 'A versatile Gaming Mouse featuring pro construction and dependable performance for daily tasks.',
        datasetDate: '2024-01-16',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 333,
        },
    },
    {
        ProductID: 381,
        Title: 'Ultra Smart LED Bulb',
        Description:
            'A versatile Smart LED Bulb featuring ultra construction and dependable performance for daily tasks.',
        datasetDate: '2024-01-17',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 473,
        },
    },
    {
        ProductID: 382,
        Title: 'Compact Fitness Tracker',
        Description:
            'A versatile Fitness Tracker featuring compact construction and dependable performance for daily tasks.',
        datasetDate: '2024-01-18',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 534,
        },
    },
    {
        ProductID: 383,
        Title: 'Eco Gaming Mouse',
        Description:
            'Experience improved productivity with this Eco Gaming Mouse, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-01-19',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 514,
        },
    },
    {
        ProductID: 384,
        Title: 'Ultra Gaming Mouse',
        Description:
            'Experience improved productivity with this Ultra Gaming Mouse, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-01-20',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 845,
        },
    },
    {
        ProductID: 385,
        Title: 'Premium Smart LED Bulb',
        Description:
            'Upgrade your setup with the Premium Smart LED Bulb, engineered for speed, durability, and convenience.',
        datasetDate: '2024-01-21',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 669,
        },
    },
    {
        ProductID: 386,
        Title: 'Portable USB-C Hub',
        Description:
            'Designed for everyday use, this Portable USB-C Hub delivers reliable performance and modern features.',
        datasetDate: '2024-01-22',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 832,
        },
    },
    {
        ProductID: 387,
        Title: 'Smart Bluetooth Speaker',
        Description:
            'Designed for everyday use, this Smart Bluetooth Speaker delivers reliable performance and modern features.',
        datasetDate: '2024-01-23',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 294,
        },
    },
    {
        ProductID: 388,
        Title: 'Ultra Coffee Grinder',
        Description:
            'Upgrade your setup with the Ultra Coffee Grinder, engineered for speed, durability, and convenience.',
        datasetDate: '2024-01-24',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 153,
        },
    },
    {
        ProductID: 389,
        Title: 'Durable Coffee Grinder',
        Description:
            'The Durable Coffee Grinder combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-01-25',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 382,
        },
    },
    {
        ProductID: 390,
        Title: 'Durable Bluetooth Speaker',
        Description:
            'A versatile Bluetooth Speaker featuring durable construction and dependable performance for daily tasks.',
        datasetDate: '2024-01-26',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 643,
        },
    },
    {
        ProductID: 391,
        Title: 'Compact Fitness Tracker',
        Description:
            'Upgrade your setup with the Compact Fitness Tracker, engineered for speed, durability, and convenience.',
        datasetDate: '2024-01-27',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 267,
        },
    },
    {
        ProductID: 392,
        Title: 'Ultra 4K Monitor',
        Description:
            'Experience improved productivity with this Ultra 4K Monitor, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-01-28',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 230,
        },
    },
    {
        ProductID: 393,
        Title: 'Compact Action Camera',
        Description:
            'Experience improved productivity with this Compact Action Camera, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-01-29',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 576,
        },
    },
    {
        ProductID: 394,
        Title: 'Smart Fitness Tracker',
        Description:
            'Experience improved productivity with this Smart Fitness Tracker, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-01-30',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 246,
        },
    },
    {
        ProductID: 395,
        Title: 'Compact Gaming Mouse',
        Description:
            'The Compact Gaming Mouse combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-01-31',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 408,
        },
    },
    {
        ProductID: 396,
        Title: 'Pro Electric Toothbrush',
        Description:
            'A versatile Electric Toothbrush featuring pro construction and dependable performance for daily tasks.',
        datasetDate: '2024-02-01',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 29,
        },
    },
    {
        ProductID: 397,
        Title: 'Compact USB-C Hub',
        Description:
            'Designed for everyday use, this Compact USB-C Hub delivers reliable performance and modern features.',
        datasetDate: '2024-02-02',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 922,
        },
    },
    {
        ProductID: 398,
        Title: 'Ultra Fitness Tracker',
        Description:
            'The Ultra Fitness Tracker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-02-03',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 389,
        },
    },
    {
        ProductID: 399,
        Title: 'Premium Air Purifier',
        Description:
            'The Premium Air Purifier combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-02-04',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 821,
        },
    },
    {
        ProductID: 400,
        Title: 'Advanced Robot Vacuum',
        Description:
            'A versatile Robot Vacuum featuring advanced construction and dependable performance for daily tasks.',
        datasetDate: '2024-02-05',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 175,
        },
    },
    {
        ProductID: 401,
        Title: 'Ultra Fitness Tracker',
        Description:
            'Experience improved productivity with this Ultra Fitness Tracker, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-02-06',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 584,
        },
    },
    {
        ProductID: 402,
        Title: 'Portable 4K Monitor',
        Description:
            'Experience improved productivity with this Portable 4K Monitor, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-02-07',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 47,
        },
    },
    {
        ProductID: 403,
        Title: 'Ultra Air Purifier',
        Description:
            'Upgrade your setup with the Ultra Air Purifier, engineered for speed, durability, and convenience.',
        datasetDate: '2024-02-08',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 757,
        },
    },
    {
        ProductID: 404,
        Title: 'Wireless Coffee Grinder',
        Description:
            'The Wireless Coffee Grinder combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-02-09',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 572,
        },
    },
    {
        ProductID: 405,
        Title: 'Wireless External SSD',
        Description:
            'Designed for everyday use, this Wireless External SSD delivers reliable performance and modern features.',
        datasetDate: '2024-02-10',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 31,
        },
    },
    {
        ProductID: 406,
        Title: 'Advanced Home Security Camera',
        Description:
            'Upgrade your setup with the Advanced Home Security Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-02-11',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 221,
        },
    },
    {
        ProductID: 407,
        Title: 'Advanced Coffee Grinder',
        Description:
            'Designed for everyday use, this Advanced Coffee Grinder delivers reliable performance and modern features.',
        datasetDate: '2024-02-12',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 385,
        },
    },
    {
        ProductID: 408,
        Title: 'Premium USB-C Hub',
        Description:
            'Designed for everyday use, this Premium USB-C Hub delivers reliable performance and modern features.',
        datasetDate: '2024-02-13',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 426,
        },
    },
    {
        ProductID: 409,
        Title: 'Smart Gaming Mouse',
        Description:
            'Upgrade your setup with the Smart Gaming Mouse, engineered for speed, durability, and convenience.',
        datasetDate: '2024-02-14',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 154,
        },
    },
    {
        ProductID: 410,
        Title: 'Premium USB-C Hub',
        Description:
            'Upgrade your setup with the Premium USB-C Hub, engineered for speed, durability, and convenience.',
        datasetDate: '2024-02-15',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 268,
        },
    },
    {
        ProductID: 411,
        Title: 'Compact USB-C Hub',
        Description:
            'Experience improved productivity with this Compact USB-C Hub, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-02-16',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 849,
        },
    },
    {
        ProductID: 412,
        Title: 'Advanced Webcam',
        Description: 'Upgrade your setup with the Advanced Webcam, engineered for speed, durability, and convenience.',
        datasetDate: '2024-02-17',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 206,
        },
    },
    {
        ProductID: 413,
        Title: 'Ultra Robot Vacuum',
        Description: 'The Ultra Robot Vacuum combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-02-18',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 508,
        },
    },
    {
        ProductID: 414,
        Title: 'Ultra Fitness Tracker',
        Description:
            'Designed for everyday use, this Ultra Fitness Tracker delivers reliable performance and modern features.',
        datasetDate: '2024-02-19',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 866,
        },
    },
    {
        ProductID: 415,
        Title: 'Portable External SSD',
        Description:
            'Upgrade your setup with the Portable External SSD, engineered for speed, durability, and convenience.',
        datasetDate: '2024-02-20',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 801,
        },
    },
    {
        ProductID: 416,
        Title: 'Advanced Wireless Charger',
        Description:
            'Designed for everyday use, this Advanced Wireless Charger delivers reliable performance and modern features.',
        datasetDate: '2024-02-21',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 167,
        },
    },
    {
        ProductID: 417,
        Title: 'Portable Fitness Tracker',
        Description:
            'Upgrade your setup with the Portable Fitness Tracker, engineered for speed, durability, and convenience.',
        datasetDate: '2024-02-22',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 916,
        },
    },
    {
        ProductID: 418,
        Title: 'Portable Webcam',
        Description: 'The Portable Webcam combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-02-23',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 232,
        },
    },
    {
        ProductID: 419,
        Title: 'Eco Home Security Camera',
        Description:
            'Upgrade your setup with the Eco Home Security Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-02-24',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 330,
        },
    },
    {
        ProductID: 420,
        Title: 'Durable USB-C Hub',
        Description: 'The Durable USB-C Hub combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-02-25',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 570,
        },
    },
    {
        ProductID: 421,
        Title: 'Wireless Fitness Tracker',
        Description:
            'Designed for everyday use, this Wireless Fitness Tracker delivers reliable performance and modern features.',
        datasetDate: '2024-02-26',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 349,
        },
    },
    {
        ProductID: 422,
        Title: 'Compact Laptop Stand',
        Description:
            'Experience improved productivity with this Compact Laptop Stand, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-02-27',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 523,
        },
    },
    {
        ProductID: 423,
        Title: 'Premium 4K Monitor',
        Description:
            'Designed for everyday use, this Premium 4K Monitor delivers reliable performance and modern features.',
        datasetDate: '2024-02-28',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 45,
        },
    },
    {
        ProductID: 424,
        Title: 'Compact Noise Cancelling Headphones',
        Description:
            'Designed for everyday use, this Compact Noise Cancelling Headphones delivers reliable performance and modern features.',
        datasetDate: '2024-02-29',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 219,
        },
    },
    {
        ProductID: 425,
        Title: 'Eco USB-C Hub',
        Description: 'The Eco USB-C Hub combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-03-01',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 114,
        },
    },
    {
        ProductID: 426,
        Title: 'Eco Action Camera',
        Description:
            'Upgrade your setup with the Eco Action Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-03-02',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 18,
        },
    },
    {
        ProductID: 427,
        Title: 'Advanced Smart Plug',
        Description:
            'The Advanced Smart Plug combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-03-03',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 737,
        },
    },
    {
        ProductID: 428,
        Title: 'Ultra Laptop Stand',
        Description:
            'A versatile Laptop Stand featuring ultra construction and dependable performance for daily tasks.',
        datasetDate: '2024-03-04',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 871,
        },
    },
    {
        ProductID: 429,
        Title: 'Premium Air Purifier',
        Description:
            'The Premium Air Purifier combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-03-05',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 458,
        },
    },
    {
        ProductID: 430,
        Title: 'Premium Mechanical Keyboard',
        Description:
            'Upgrade your setup with the Premium Mechanical Keyboard, engineered for speed, durability, and convenience.',
        datasetDate: '2024-03-06',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 875,
        },
    },
    {
        ProductID: 431,
        Title: 'Advanced Wireless Charger',
        Description:
            'Designed for everyday use, this Advanced Wireless Charger delivers reliable performance and modern features.',
        datasetDate: '2024-03-07',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 896,
        },
    },
    {
        ProductID: 432,
        Title: 'Smart External SSD',
        Description:
            'Upgrade your setup with the Smart External SSD, engineered for speed, durability, and convenience.',
        datasetDate: '2024-03-08',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 404,
        },
    },
    {
        ProductID: 433,
        Title: 'Pro Air Purifier',
        Description:
            'Experience improved productivity with this Pro Air Purifier, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-03-09',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 17,
        },
    },
    {
        ProductID: 434,
        Title: 'Eco Laptop Stand',
        Description: 'The Eco Laptop Stand combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-03-10',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 12,
        },
    },
    {
        ProductID: 435,
        Title: 'Advanced Laptop Stand',
        Description:
            'The Advanced Laptop Stand combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-03-11',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 925,
        },
    },
    {
        ProductID: 436,
        Title: 'Portable Wireless Charger',
        Description:
            'A versatile Wireless Charger featuring portable construction and dependable performance for daily tasks.',
        datasetDate: '2024-03-12',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 12,
        },
    },
    {
        ProductID: 437,
        Title: 'Eco Gaming Mouse',
        Description:
            'Designed for everyday use, this Eco Gaming Mouse delivers reliable performance and modern features.',
        datasetDate: '2024-03-13',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 330,
        },
    },
    {
        ProductID: 438,
        Title: 'Advanced Air Purifier',
        Description:
            'Designed for everyday use, this Advanced Air Purifier delivers reliable performance and modern features.',
        datasetDate: '2024-03-14',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 84,
        },
    },
    {
        ProductID: 439,
        Title: 'Premium Noise Cancelling Headphones',
        Description:
            // eslint-disable-next-line max-len
            'Experience improved productivity with this Premium Noise Cancelling Headphones, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-03-15',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 892,
        },
    },
    {
        ProductID: 440,
        Title: 'Compact Fitness Tracker',
        Description:
            'The Compact Fitness Tracker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-03-16',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 789,
        },
    },
    {
        ProductID: 441,
        Title: 'Pro Action Camera',
        Description:
            'Experience improved productivity with this Pro Action Camera, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-03-17',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 932,
        },
    },
    {
        ProductID: 442,
        Title: 'Portable Coffee Grinder',
        Description:
            'Upgrade your setup with the Portable Coffee Grinder, engineered for speed, durability, and convenience.',
        datasetDate: '2024-03-18',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 827,
        },
    },
    {
        ProductID: 443,
        Title: 'Portable 4K Monitor',
        Description:
            'Experience improved productivity with this Portable 4K Monitor, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-03-19',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 944,
        },
    },
    {
        ProductID: 444,
        Title: 'Eco Air Purifier',
        Description: 'A versatile Air Purifier featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-03-20',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 886,
        },
    },
    {
        ProductID: 445,
        Title: 'Eco Laptop Stand',
        Description: 'A versatile Laptop Stand featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-03-21',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 584,
        },
    },
    {
        ProductID: 446,
        Title: 'Pro Bluetooth Speaker',
        Description:
            'A versatile Bluetooth Speaker featuring pro construction and dependable performance for daily tasks.',
        datasetDate: '2024-03-22',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 560,
        },
    },
    {
        ProductID: 447,
        Title: 'Portable USB-C Hub',
        Description:
            'A versatile USB-C Hub featuring portable construction and dependable performance for daily tasks.',
        datasetDate: '2024-03-23',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 435,
        },
    },
    {
        ProductID: 448,
        Title: 'Smart Bluetooth Speaker',
        Description:
            'Experience improved productivity with this Smart Bluetooth Speaker, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-03-24',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 386,
        },
    },
    {
        ProductID: 449,
        Title: 'Advanced Smart Plug',
        Description:
            'A versatile Smart Plug featuring advanced construction and dependable performance for daily tasks.',
        datasetDate: '2024-03-25',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 951,
        },
    },
    {
        ProductID: 450,
        Title: 'Portable Fitness Tracker',
        Description:
            'Upgrade your setup with the Portable Fitness Tracker, engineered for speed, durability, and convenience.',
        datasetDate: '2024-03-26',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 123,
        },
    },
    {
        ProductID: 451,
        Title: 'Advanced Smart Plug',
        Description:
            'The Advanced Smart Plug combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-03-27',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 822,
        },
    },
    {
        ProductID: 452,
        Title: 'Advanced Air Purifier',
        Description:
            'Experience improved productivity with this Advanced Air Purifier, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-03-28',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 830,
        },
    },
    {
        ProductID: 453,
        Title: 'Premium External SSD',
        Description:
            'Upgrade your setup with the Premium External SSD, engineered for speed, durability, and convenience.',
        datasetDate: '2024-03-29',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 948,
        },
    },
    {
        ProductID: 454,
        Title: 'Wireless Bluetooth Speaker',
        Description:
            'The Wireless Bluetooth Speaker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-03-30',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 230,
        },
    },
    {
        ProductID: 455,
        Title: 'Compact Robot Vacuum',
        Description:
            'Upgrade your setup with the Compact Robot Vacuum, engineered for speed, durability, and convenience.',
        datasetDate: '2024-03-31',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 473,
        },
    },
    {
        ProductID: 456,
        Title: 'Eco Coffee Grinder',
        Description:
            'Designed for everyday use, this Eco Coffee Grinder delivers reliable performance and modern features.',
        datasetDate: '2024-04-01',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 698,
        },
    },
    {
        ProductID: 457,
        Title: 'Eco Action Camera',
        Description:
            'Experience improved productivity with this Eco Action Camera, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-04-02',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 955,
        },
    },
    {
        ProductID: 458,
        Title: 'Premium Air Purifier',
        Description:
            'Experience improved productivity with this Premium Air Purifier, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-04-03',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 662,
        },
    },
    {
        ProductID: 459,
        Title: 'Ultra Noise Cancelling Headphones',
        Description:
            'Experience improved productivity with this Ultra Noise Cancelling Headphones, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-04-04',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 305,
        },
    },
    {
        ProductID: 460,
        Title: 'Pro Home Security Camera',
        Description:
            'The Pro Home Security Camera combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-04-05',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 812,
        },
    },
    {
        ProductID: 461,
        Title: 'Durable Laptop Stand',
        Description:
            'Upgrade your setup with the Durable Laptop Stand, engineered for speed, durability, and convenience.',
        datasetDate: '2024-04-06',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 646,
        },
    },
    {
        ProductID: 462,
        Title: 'Smart Noise Cancelling Headphones',
        Description:
            'Upgrade your setup with the Smart Noise Cancelling Headphones, engineered for speed, durability, and convenience.',
        datasetDate: '2024-04-07',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 849,
        },
    },
    {
        ProductID: 463,
        Title: 'Eco Robot Vacuum',
        Description: 'Upgrade your setup with the Eco Robot Vacuum, engineered for speed, durability, and convenience.',
        datasetDate: '2024-04-08',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 755,
        },
    },
    {
        ProductID: 464,
        Title: 'Ultra Noise Cancelling Headphones',
        Description:
            'Designed for everyday use, this Ultra Noise Cancelling Headphones delivers reliable performance and modern features.',
        datasetDate: '2024-04-09',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 541,
        },
    },
    {
        ProductID: 465,
        Title: 'Pro Air Purifier',
        Description:
            'Experience improved productivity with this Pro Air Purifier, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-04-10',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 720,
        },
    },
    {
        ProductID: 466,
        Title: 'Eco External SSD',
        Description: 'Upgrade your setup with the Eco External SSD, engineered for speed, durability, and convenience.',
        datasetDate: '2024-04-11',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 351,
        },
    },
    {
        ProductID: 467,
        Title: 'Pro Robot Vacuum',
        Description:
            'Experience improved productivity with this Pro Robot Vacuum, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-04-12',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 939,
        },
    },
    {
        ProductID: 468,
        Title: 'Pro Fitness Tracker',
        Description:
            'Designed for everyday use, this Pro Fitness Tracker delivers reliable performance and modern features.',
        datasetDate: '2024-04-13',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 899,
        },
    },
    {
        ProductID: 469,
        Title: 'Advanced Webcam',
        Description: 'A versatile Webcam featuring advanced construction and dependable performance for daily tasks.',
        datasetDate: '2024-04-14',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 727,
        },
    },
    {
        ProductID: 470,
        Title: 'Premium Mechanical Keyboard',
        Description:
            'Experience improved productivity with this Premium Mechanical Keyboard, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-04-15',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 466,
        },
    },
    {
        ProductID: 471,
        Title: 'Wireless Coffee Grinder',
        Description:
            'A versatile Coffee Grinder featuring wireless construction and dependable performance for daily tasks.',
        datasetDate: '2024-04-16',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 786,
        },
    },
    {
        ProductID: 472,
        Title: 'Wireless Wireless Charger',
        Description:
            'The Wireless Wireless Charger combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-04-17',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 471,
        },
    },
    {
        ProductID: 473,
        Title: 'Eco Smart LED Bulb',
        Description:
            'A versatile Smart LED Bulb featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-04-18',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 3,
        },
    },
    {
        ProductID: 474,
        Title: 'Wireless Noise Cancelling Headphones',
        Description:
            'Upgrade your setup with the Wireless Noise Cancelling Headphones, engineered for speed, durability, and convenience.',
        datasetDate: '2024-04-19',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 946,
        },
    },
    {
        ProductID: 475,
        Title: 'Smart Fitness Tracker',
        Description:
            'Upgrade your setup with the Smart Fitness Tracker, engineered for speed, durability, and convenience.',
        datasetDate: '2024-04-20',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 58,
        },
    },
    {
        ProductID: 476,
        Title: 'Advanced Electric Toothbrush',
        Description:
            'The Advanced Electric Toothbrush combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-04-21',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 260,
        },
    },
    {
        ProductID: 477,
        Title: 'Pro Fitness Tracker',
        Description:
            'Experience improved productivity with this Pro Fitness Tracker, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-04-22',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 957,
        },
    },
    {
        ProductID: 478,
        Title: 'Eco Smart LED Bulb',
        Description: 'The Eco Smart LED Bulb combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-04-23',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 428,
        },
    },
    {
        ProductID: 479,
        Title: 'Ultra Smart Plug',
        Description:
            'Experience improved productivity with this Ultra Smart Plug, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-04-24',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 453,
        },
    },
    {
        ProductID: 480,
        Title: 'Durable Gaming Mouse',
        Description:
            'The Durable Gaming Mouse combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-04-25',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 982,
        },
    },
    {
        ProductID: 481,
        Title: 'Eco Air Purifier',
        Description: 'Upgrade your setup with the Eco Air Purifier, engineered for speed, durability, and convenience.',
        datasetDate: '2024-04-26',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 569,
        },
    },
    {
        ProductID: 482,
        Title: 'Compact Gaming Mouse',
        Description:
            'Experience improved productivity with this Compact Gaming Mouse, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-04-27',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 459,
        },
    },
    {
        ProductID: 483,
        Title: 'Portable External SSD',
        Description:
            'The Portable External SSD combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-04-28',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 240,
        },
    },
    {
        ProductID: 484,
        Title: 'Compact Smart LED Bulb',
        Description:
            'The Compact Smart LED Bulb combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-04-29',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 645,
        },
    },
    {
        ProductID: 485,
        Title: 'Pro Home Security Camera',
        Description:
            'Experience improved productivity with this Pro Home Security Camera, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-04-30',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 222,
        },
    },
    {
        ProductID: 486,
        Title: 'Durable Laptop Stand',
        Description:
            'Experience improved productivity with this Durable Laptop Stand, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-05-01',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 523,
        },
    },
    {
        ProductID: 487,
        Title: 'Advanced Webcam',
        Description: 'The Advanced Webcam combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-05-02',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 715,
        },
    },
    {
        ProductID: 488,
        Title: 'Smart Laptop Stand',
        Description:
            'Experience improved productivity with this Smart Laptop Stand, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-05-03',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 602,
        },
    },
    {
        ProductID: 489,
        Title: 'Compact Webcam',
        Description:
            'Designed for everyday use, this Compact Webcam delivers reliable performance and modern features.',
        datasetDate: '2024-05-04',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 859,
        },
    },
    {
        ProductID: 490,
        Title: 'Ultra Electric Toothbrush',
        Description:
            'Experience improved productivity with this Ultra Electric Toothbrush, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-05-05',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 475,
        },
    },
    {
        ProductID: 491,
        Title: 'Wireless Smart Plug',
        Description:
            'Upgrade your setup with the Wireless Smart Plug, engineered for speed, durability, and convenience.',
        datasetDate: '2024-05-06',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 293,
        },
    },
    {
        ProductID: 492,
        Title: 'Pro Robot Vacuum',
        Description: 'The Pro Robot Vacuum combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-05-07',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 914,
        },
    },
    {
        ProductID: 493,
        Title: 'Premium Noise Cancelling Headphones',
        Description:
            'A versatile Noise Cancelling Headphones featuring premium construction and dependable performance for daily tasks.',
        datasetDate: '2024-05-08',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 587,
        },
    },
    {
        ProductID: 494,
        Title: 'Compact Gaming Mouse',
        Description:
            'The Compact Gaming Mouse combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-05-09',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 553,
        },
    },
    {
        ProductID: 495,
        Title: 'Wireless External SSD',
        Description:
            'A versatile External SSD featuring wireless construction and dependable performance for daily tasks.',
        datasetDate: '2024-05-10',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 898,
        },
    },
    {
        ProductID: 496,
        Title: 'Ultra Mechanical Keyboard',
        Description:
            'Upgrade your setup with the Ultra Mechanical Keyboard, engineered for speed, durability, and convenience.',
        datasetDate: '2024-05-11',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 76,
        },
    },
    {
        ProductID: 497,
        Title: 'Compact External SSD',
        Description:
            'A versatile External SSD featuring compact construction and dependable performance for daily tasks.',
        datasetDate: '2024-05-12',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 752,
        },
    },
    {
        ProductID: 498,
        Title: 'Smart Robot Vacuum',
        Description:
            'Designed for everyday use, this Smart Robot Vacuum delivers reliable performance and modern features.',
        datasetDate: '2024-05-13',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 74,
        },
    },
    {
        ProductID: 499,
        Title: 'Premium Smart LED Bulb',
        Description:
            'Experience improved productivity with this Premium Smart LED Bulb, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-05-14',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 745,
        },
    },
    {
        ProductID: 500,
        Title: 'Smart Fitness Tracker',
        Description:
            'A versatile Fitness Tracker featuring smart construction and dependable performance for daily tasks.',
        datasetDate: '2024-05-15',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 779,
        },
    },
    {
        ProductID: 501,
        Title: 'Pro Smart Plug',
        Description:
            'Designed for everyday use, this Pro Smart Plug delivers reliable performance and modern features.',
        datasetDate: '2024-05-16',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 944,
        },
    },
    {
        ProductID: 502,
        Title: 'Eco 4K Monitor',
        Description: 'The Eco 4K Monitor combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-05-17',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 646,
        },
    },
    {
        ProductID: 503,
        Title: 'Smart Bluetooth Speaker',
        Description:
            'Designed for everyday use, this Smart Bluetooth Speaker delivers reliable performance and modern features.',
        datasetDate: '2024-05-18',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 25,
        },
    },
    {
        ProductID: 504,
        Title: 'Portable Smart Plug',
        Description:
            'Designed for everyday use, this Portable Smart Plug delivers reliable performance and modern features.',
        datasetDate: '2024-05-19',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 585,
        },
    },
    {
        ProductID: 505,
        Title: 'Eco Action Camera',
        Description:
            'Designed for everyday use, this Eco Action Camera delivers reliable performance and modern features.',
        datasetDate: '2024-05-20',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 965,
        },
    },
    {
        ProductID: 506,
        Title: 'Durable 4K Monitor',
        Description: 'The Durable 4K Monitor combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-05-21',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 489,
        },
    },
    {
        ProductID: 507,
        Title: 'Durable Webcam',
        Description: 'A versatile Webcam featuring durable construction and dependable performance for daily tasks.',
        datasetDate: '2024-05-22',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 149,
        },
    },
    {
        ProductID: 508,
        Title: 'Durable Air Purifier',
        Description:
            'A versatile Air Purifier featuring durable construction and dependable performance for daily tasks.',
        datasetDate: '2024-05-23',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 99,
        },
    },
    {
        ProductID: 509,
        Title: 'Smart Fitness Tracker',
        Description:
            'A versatile Fitness Tracker featuring smart construction and dependable performance for daily tasks.',
        datasetDate: '2024-05-24',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 363,
        },
    },
    {
        ProductID: 510,
        Title: 'Smart Webcam',
        Description: 'The Smart Webcam combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-05-25',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 395,
        },
    },
    {
        ProductID: 511,
        Title: 'Premium USB-C Hub',
        Description:
            'Designed for everyday use, this Premium USB-C Hub delivers reliable performance and modern features.',
        datasetDate: '2024-05-26',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 992,
        },
    },
    {
        ProductID: 512,
        Title: 'Eco Webcam',
        Description: 'A versatile Webcam featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-05-27',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 715,
        },
    },
    {
        ProductID: 513,
        Title: 'Compact Action Camera',
        Description:
            'Upgrade your setup with the Compact Action Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-05-28',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 436,
        },
    },
    {
        ProductID: 514,
        Title: 'Durable Webcam',
        Description:
            'Designed for everyday use, this Durable Webcam delivers reliable performance and modern features.',
        datasetDate: '2024-05-29',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 460,
        },
    },
    {
        ProductID: 515,
        Title: 'Ultra Home Security Camera',
        Description:
            'Experience improved productivity with this Ultra Home Security Camera, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-05-30',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 289,
        },
    },
    {
        ProductID: 516,
        Title: 'Portable Mechanical Keyboard',
        Description:
            'A versatile Mechanical Keyboard featuring portable construction and dependable performance for daily tasks.',
        datasetDate: '2024-05-31',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 57,
        },
    },
    {
        ProductID: 517,
        Title: 'Portable USB-C Hub',
        Description:
            'A versatile USB-C Hub featuring portable construction and dependable performance for daily tasks.',
        datasetDate: '2024-06-01',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 125,
        },
    },
    {
        ProductID: 518,
        Title: 'Compact Electric Toothbrush',
        Description:
            'A versatile Electric Toothbrush featuring compact construction and dependable performance for daily tasks.',
        datasetDate: '2024-06-02',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 414,
        },
    },
    {
        ProductID: 519,
        Title: 'Smart Webcam',
        Description: 'Upgrade your setup with the Smart Webcam, engineered for speed, durability, and convenience.',
        datasetDate: '2024-06-03',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 210,
        },
    },
    {
        ProductID: 520,
        Title: 'Portable Coffee Grinder',
        Description:
            'Designed for everyday use, this Portable Coffee Grinder delivers reliable performance and modern features.',
        datasetDate: '2024-06-04',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 889,
        },
    },
    {
        ProductID: 521,
        Title: 'Wireless Smart LED Bulb',
        Description:
            'Experience improved productivity with this Wireless Smart LED Bulb, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-06-05',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 121,
        },
    },
    {
        ProductID: 522,
        Title: 'Pro Electric Toothbrush',
        Description:
            'Designed for everyday use, this Pro Electric Toothbrush delivers reliable performance and modern features.',
        datasetDate: '2024-06-06',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 538,
        },
    },
    {
        ProductID: 523,
        Title: 'Advanced Gaming Mouse',
        Description:
            'Designed for everyday use, this Advanced Gaming Mouse delivers reliable performance and modern features.',
        datasetDate: '2024-06-07',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 166,
        },
    },
    {
        ProductID: 524,
        Title: 'Premium Fitness Tracker',
        Description:
            'Upgrade your setup with the Premium Fitness Tracker, engineered for speed, durability, and convenience.',
        datasetDate: '2024-06-08',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 337,
        },
    },
    {
        ProductID: 525,
        Title: 'Advanced Robot Vacuum',
        Description:
            'A versatile Robot Vacuum featuring advanced construction and dependable performance for daily tasks.',
        datasetDate: '2024-06-09',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 314,
        },
    },
    {
        ProductID: 526,
        Title: 'Pro USB-C Hub',
        Description: 'Designed for everyday use, this Pro USB-C Hub delivers reliable performance and modern features.',
        datasetDate: '2024-06-10',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 513,
        },
    },
    {
        ProductID: 527,
        Title: 'Portable Action Camera',
        Description:
            'Upgrade your setup with the Portable Action Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-06-11',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 31,
        },
    },
    {
        ProductID: 528,
        Title: 'Smart Bluetooth Speaker',
        Description:
            'Designed for everyday use, this Smart Bluetooth Speaker delivers reliable performance and modern features.',
        datasetDate: '2024-06-12',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 391,
        },
    },
    {
        ProductID: 529,
        Title: 'Wireless Wireless Charger',
        Description:
            'The Wireless Wireless Charger combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-06-13',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 317,
        },
    },
    {
        ProductID: 530,
        Title: 'Eco Home Security Camera',
        Description:
            'The Eco Home Security Camera combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-06-14',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 109,
        },
    },
    {
        ProductID: 531,
        Title: 'Smart Noise Cancelling Headphones',
        Description:
            'Upgrade your setup with the Smart Noise Cancelling Headphones, engineered for speed, durability, and convenience.',
        datasetDate: '2024-06-15',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 568,
        },
    },
    {
        ProductID: 532,
        Title: 'Premium Smart Plug',
        Description:
            'Upgrade your setup with the Premium Smart Plug, engineered for speed, durability, and convenience.',
        datasetDate: '2024-06-16',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 503,
        },
    },
    {
        ProductID: 533,
        Title: 'Durable Coffee Grinder',
        Description:
            'Experience improved productivity with this Durable Coffee Grinder, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-06-17',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 611,
        },
    },
    {
        ProductID: 534,
        Title: 'Wireless 4K Monitor',
        Description:
            'Upgrade your setup with the Wireless 4K Monitor, engineered for speed, durability, and convenience.',
        datasetDate: '2024-06-18',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 236,
        },
    },
    {
        ProductID: 535,
        Title: 'Premium Home Security Camera',
        Description:
            'Designed for everyday use, this Premium Home Security Camera delivers reliable performance and modern features.',
        datasetDate: '2024-06-19',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 47,
        },
    },
    {
        ProductID: 536,
        Title: 'Smart Smart Plug',
        Description:
            'Experience improved productivity with this Smart Smart Plug, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-06-20',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 734,
        },
    },
    {
        ProductID: 537,
        Title: 'Pro Webcam',
        Description: 'The Pro Webcam combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-06-21',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 104,
        },
    },
    {
        ProductID: 538,
        Title: 'Compact External SSD',
        Description:
            'A versatile External SSD featuring compact construction and dependable performance for daily tasks.',
        datasetDate: '2024-06-22',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 325,
        },
    },
    {
        ProductID: 539,
        Title: 'Ultra Action Camera',
        Description:
            'A versatile Action Camera featuring ultra construction and dependable performance for daily tasks.',
        datasetDate: '2024-06-23',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 698,
        },
    },
    {
        ProductID: 540,
        Title: 'Portable Smart LED Bulb',
        Description:
            'A versatile Smart LED Bulb featuring portable construction and dependable performance for daily tasks.',
        datasetDate: '2024-06-24',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 110,
        },
    },
    {
        ProductID: 541,
        Title: 'Wireless Robot Vacuum',
        Description:
            'Designed for everyday use, this Wireless Robot Vacuum delivers reliable performance and modern features.',
        datasetDate: '2024-06-25',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 920,
        },
    },
    {
        ProductID: 542,
        Title: 'Durable Air Purifier',
        Description:
            'Experience improved productivity with this Durable Air Purifier, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-06-26',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 242,
        },
    },
    {
        ProductID: 543,
        Title: 'Eco Fitness Tracker',
        Description:
            'A versatile Fitness Tracker featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-06-27',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 831,
        },
    },
    {
        ProductID: 544,
        Title: 'Advanced Coffee Grinder',
        Description:
            'Upgrade your setup with the Advanced Coffee Grinder, engineered for speed, durability, and convenience.',
        datasetDate: '2024-06-28',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 387,
        },
    },
    {
        ProductID: 545,
        Title: 'Compact Gaming Mouse',
        Description:
            'Upgrade your setup with the Compact Gaming Mouse, engineered for speed, durability, and convenience.',
        datasetDate: '2024-06-29',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 588,
        },
    },
    {
        ProductID: 546,
        Title: 'Wireless Gaming Mouse',
        Description:
            'The Wireless Gaming Mouse combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-06-30',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 141,
        },
    },
    {
        ProductID: 547,
        Title: 'Wireless Coffee Grinder',
        Description:
            'The Wireless Coffee Grinder combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-07-01',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 698,
        },
    },
    {
        ProductID: 548,
        Title: 'Compact Action Camera',
        Description:
            'The Compact Action Camera combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-07-02',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 675,
        },
    },
    {
        ProductID: 549,
        Title: 'Smart Laptop Stand',
        Description:
            'Upgrade your setup with the Smart Laptop Stand, engineered for speed, durability, and convenience.',
        datasetDate: '2024-07-03',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 92,
        },
    },
    {
        ProductID: 550,
        Title: 'Compact Gaming Mouse',
        Description:
            'Designed for everyday use, this Compact Gaming Mouse delivers reliable performance and modern features.',
        datasetDate: '2024-07-04',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 210,
        },
    },
    {
        ProductID: 551,
        Title: 'Wireless 4K Monitor',
        Description:
            'Upgrade your setup with the Wireless 4K Monitor, engineered for speed, durability, and convenience.',
        datasetDate: '2024-07-05',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 139,
        },
    },
    {
        ProductID: 552,
        Title: 'Durable Fitness Tracker',
        Description:
            'A versatile Fitness Tracker featuring durable construction and dependable performance for daily tasks.',
        datasetDate: '2024-07-06',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 678,
        },
    },
    {
        ProductID: 553,
        Title: 'Compact Air Purifier',
        Description:
            'A versatile Air Purifier featuring compact construction and dependable performance for daily tasks.',
        datasetDate: '2024-07-07',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 585,
        },
    },
    {
        ProductID: 554,
        Title: 'Ultra Laptop Stand',
        Description: 'The Ultra Laptop Stand combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-07-08',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 242,
        },
    },
    {
        ProductID: 555,
        Title: 'Durable Noise Cancelling Headphones',
        Description:
            'A versatile Noise Cancelling Headphones featuring durable construction and dependable performance for daily tasks.',
        datasetDate: '2024-07-09',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 481,
        },
    },
    {
        ProductID: 556,
        Title: 'Portable Bluetooth Speaker',
        Description:
            'Designed for everyday use, this Portable Bluetooth Speaker delivers reliable performance and modern features.',
        datasetDate: '2024-07-10',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 346,
        },
    },
    {
        ProductID: 557,
        Title: 'Pro Noise Cancelling Headphones',
        Description:
            'Experience improved productivity with this Pro Noise Cancelling Headphones, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-07-11',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 113,
        },
    },
    {
        ProductID: 558,
        Title: 'Portable Bluetooth Speaker',
        Description:
            'A versatile Bluetooth Speaker featuring portable construction and dependable performance for daily tasks.',
        datasetDate: '2024-07-12',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 4,
        },
    },
    {
        ProductID: 559,
        Title: 'Compact Laptop Stand',
        Description:
            'Designed for everyday use, this Compact Laptop Stand delivers reliable performance and modern features.',
        datasetDate: '2024-07-13',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 752,
        },
    },
    {
        ProductID: 560,
        Title: 'Pro 4K Monitor',
        Description: 'Upgrade your setup with the Pro 4K Monitor, engineered for speed, durability, and convenience.',
        datasetDate: '2024-07-14',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 103,
        },
    },
    {
        ProductID: 561,
        Title: 'Advanced Robot Vacuum',
        Description:
            'Experience improved productivity with this Advanced Robot Vacuum, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-07-15',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 29,
        },
    },
    {
        ProductID: 562,
        Title: 'Portable External SSD',
        Description:
            'Designed for everyday use, this Portable External SSD delivers reliable performance and modern features.',
        datasetDate: '2024-07-16',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 488,
        },
    },
    {
        ProductID: 563,
        Title: 'Durable Smart Plug',
        Description:
            'Experience improved productivity with this Durable Smart Plug, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-07-17',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 384,
        },
    },
    {
        ProductID: 564,
        Title: 'Premium Smart Plug',
        Description:
            'Upgrade your setup with the Premium Smart Plug, engineered for speed, durability, and convenience.',
        datasetDate: '2024-07-18',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 925,
        },
    },
    {
        ProductID: 565,
        Title: 'Advanced Gaming Mouse',
        Description:
            'Upgrade your setup with the Advanced Gaming Mouse, engineered for speed, durability, and convenience.',
        datasetDate: '2024-07-19',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 568,
        },
    },
    {
        ProductID: 566,
        Title: 'Eco Bluetooth Speaker',
        Description:
            'A versatile Bluetooth Speaker featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-07-20',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 981,
        },
    },
    {
        ProductID: 567,
        Title: 'Advanced External SSD',
        Description:
            'A versatile External SSD featuring advanced construction and dependable performance for daily tasks.',
        datasetDate: '2024-07-21',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 882,
        },
    },
    {
        ProductID: 568,
        Title: 'Smart Robot Vacuum',
        Description:
            'Designed for everyday use, this Smart Robot Vacuum delivers reliable performance and modern features.',
        datasetDate: '2024-07-22',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 114,
        },
    },
    {
        ProductID: 569,
        Title: 'Smart Smart LED Bulb',
        Description:
            'Designed for everyday use, this Smart Smart LED Bulb delivers reliable performance and modern features.',
        datasetDate: '2024-07-23',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 455,
        },
    },
    {
        ProductID: 570,
        Title: 'Smart Smart LED Bulb',
        Description:
            'Experience improved productivity with this Smart Smart LED Bulb, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-07-24',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 914,
        },
    },
    {
        ProductID: 571,
        Title: 'Premium Smart LED Bulb',
        Description:
            'The Premium Smart LED Bulb combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-07-25',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 237,
        },
    },
    {
        ProductID: 572,
        Title: 'Advanced Webcam',
        Description: 'The Advanced Webcam combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-07-26',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 871,
        },
    },
    {
        ProductID: 573,
        Title: 'Pro Fitness Tracker',
        Description:
            'The Pro Fitness Tracker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-07-27',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 1,
        },
    },
    {
        ProductID: 574,
        Title: 'Ultra Air Purifier',
        Description:
            'Experience improved productivity with this Ultra Air Purifier, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-07-28',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 813,
        },
    },
    {
        ProductID: 575,
        Title: 'Wireless Home Security Camera',
        Description:
            'A versatile Home Security Camera featuring wireless construction and dependable performance for daily tasks.',
        datasetDate: '2024-07-29',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 889,
        },
    },
    {
        ProductID: 576,
        Title: 'Smart Wireless Charger',
        Description:
            'Experience improved productivity with this Smart Wireless Charger, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-07-30',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 632,
        },
    },
    {
        ProductID: 577,
        Title: 'Portable Laptop Stand',
        Description:
            'Designed for everyday use, this Portable Laptop Stand delivers reliable performance and modern features.',
        datasetDate: '2024-07-31',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 203,
        },
    },
    {
        ProductID: 578,
        Title: 'Durable Action Camera',
        Description:
            'Upgrade your setup with the Durable Action Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-08-01',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 110,
        },
    },
    {
        ProductID: 579,
        Title: 'Smart 4K Monitor',
        Description:
            'Designed for everyday use, this Smart 4K Monitor delivers reliable performance and modern features.',
        datasetDate: '2024-08-02',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 139,
        },
    },
    {
        ProductID: 580,
        Title: 'Advanced Gaming Mouse',
        Description:
            'A versatile Gaming Mouse featuring advanced construction and dependable performance for daily tasks.',
        datasetDate: '2024-08-03',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 438,
        },
    },
    {
        ProductID: 581,
        Title: 'Eco Smart LED Bulb',
        Description:
            'Upgrade your setup with the Eco Smart LED Bulb, engineered for speed, durability, and convenience.',
        datasetDate: '2024-08-04',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 278,
        },
    },
    {
        ProductID: 582,
        Title: 'Pro Bluetooth Speaker',
        Description:
            'Upgrade your setup with the Pro Bluetooth Speaker, engineered for speed, durability, and convenience.',
        datasetDate: '2024-08-05',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 262,
        },
    },
    {
        ProductID: 583,
        Title: 'Eco Robot Vacuum',
        Description: 'The Eco Robot Vacuum combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-08-06',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 496,
        },
    },
    {
        ProductID: 584,
        Title: 'Ultra Wireless Charger',
        Description:
            'Designed for everyday use, this Ultra Wireless Charger delivers reliable performance and modern features.',
        datasetDate: '2024-08-07',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 48,
        },
    },
    {
        ProductID: 585,
        Title: 'Wireless External SSD',
        Description:
            'The Wireless External SSD combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-08-08',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 682,
        },
    },
    {
        ProductID: 586,
        Title: 'Premium Coffee Grinder',
        Description:
            'The Premium Coffee Grinder combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-08-09',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 357,
        },
    },
    {
        ProductID: 587,
        Title: 'Compact Coffee Grinder',
        Description:
            'Designed for everyday use, this Compact Coffee Grinder delivers reliable performance and modern features.',
        datasetDate: '2024-08-10',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 93,
        },
    },
    {
        ProductID: 588,
        Title: 'Durable Webcam',
        Description:
            'Designed for everyday use, this Durable Webcam delivers reliable performance and modern features.',
        datasetDate: '2024-08-11',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 119,
        },
    },
    {
        ProductID: 589,
        Title: 'Premium Webcam',
        Description: 'Upgrade your setup with the Premium Webcam, engineered for speed, durability, and convenience.',
        datasetDate: '2024-08-12',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 849,
        },
    },
    {
        ProductID: 590,
        Title: 'Smart Laptop Stand',
        Description:
            'A versatile Laptop Stand featuring smart construction and dependable performance for daily tasks.',
        datasetDate: '2024-08-13',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 352,
        },
    },
    {
        ProductID: 591,
        Title: 'Advanced 4K Monitor',
        Description:
            'Experience improved productivity with this Advanced 4K Monitor, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-08-14',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 856,
        },
    },
    {
        ProductID: 592,
        Title: 'Advanced Wireless Charger',
        Description:
            'The Advanced Wireless Charger combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-08-15',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 79,
        },
    },
    {
        ProductID: 593,
        Title: 'Portable Home Security Camera',
        Description:
            'Experience improved productivity with this Portable Home Security Camera, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-08-16',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 711,
        },
    },
    {
        ProductID: 594,
        Title: 'Pro External SSD',
        Description:
            'Designed for everyday use, this Pro External SSD delivers reliable performance and modern features.',
        datasetDate: '2024-08-17',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 600,
        },
    },
    {
        ProductID: 595,
        Title: 'Ultra Laptop Stand',
        Description:
            'A versatile Laptop Stand featuring ultra construction and dependable performance for daily tasks.',
        datasetDate: '2024-08-18',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 329,
        },
    },
    {
        ProductID: 596,
        Title: 'Smart Air Purifier',
        Description:
            'Designed for everyday use, this Smart Air Purifier delivers reliable performance and modern features.',
        datasetDate: '2024-08-19',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 717,
        },
    },
    {
        ProductID: 597,
        Title: 'Compact Air Purifier',
        Description:
            'A versatile Air Purifier featuring compact construction and dependable performance for daily tasks.',
        datasetDate: '2024-08-20',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 371,
        },
    },
    {
        ProductID: 598,
        Title: 'Advanced Electric Toothbrush',
        Description:
            'Designed for everyday use, this Advanced Electric Toothbrush delivers reliable performance and modern features.',
        datasetDate: '2024-08-21',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 925,
        },
    },
    {
        ProductID: 599,
        Title: 'Wireless Home Security Camera',
        Description:
            'Experience improved productivity with this Wireless Home Security Camera, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-08-22',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 584,
        },
    },
    {
        ProductID: 600,
        Title: 'Wireless Noise Cancelling Headphones',
        Description:
            'Designed for everyday use, this Wireless Noise Cancelling Headphones delivers reliable performance and modern features.',
        datasetDate: '2024-08-23',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 629,
        },
    },
    {
        ProductID: 601,
        Title: 'Pro Action Camera',
        Description:
            'Designed for everyday use, this Pro Action Camera delivers reliable performance and modern features.',
        datasetDate: '2024-08-24',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 386,
        },
    },
    {
        ProductID: 602,
        Title: 'Premium Fitness Tracker',
        Description:
            'Experience improved productivity with this Premium Fitness Tracker, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-08-25',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 986,
        },
    },
    {
        ProductID: 603,
        Title: 'Durable Laptop Stand',
        Description:
            'The Durable Laptop Stand combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-08-26',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 548,
        },
    },
    {
        ProductID: 604,
        Title: 'Premium Noise Cancelling Headphones',
        Description:
            'The Premium Noise Cancelling Headphones combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-08-27',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 573,
        },
    },
    {
        ProductID: 605,
        Title: 'Premium Fitness Tracker',
        Description:
            'Designed for everyday use, this Premium Fitness Tracker delivers reliable performance and modern features.',
        datasetDate: '2024-08-28',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 92,
        },
    },
    {
        ProductID: 606,
        Title: 'Advanced USB-C Hub',
        Description:
            'A versatile USB-C Hub featuring advanced construction and dependable performance for daily tasks.',
        datasetDate: '2024-08-29',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 477,
        },
    },
    {
        ProductID: 607,
        Title: 'Ultra Robot Vacuum',
        Description:
            'A versatile Robot Vacuum featuring ultra construction and dependable performance for daily tasks.',
        datasetDate: '2024-08-30',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 715,
        },
    },
    {
        ProductID: 608,
        Title: 'Advanced Mechanical Keyboard',
        Description:
            'Experience improved productivity with this Advanced Mechanical Keyboard, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-08-31',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 224,
        },
    },
    {
        ProductID: 609,
        Title: 'Pro Bluetooth Speaker',
        Description:
            'Upgrade your setup with the Pro Bluetooth Speaker, engineered for speed, durability, and convenience.',
        datasetDate: '2024-09-01',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 651,
        },
    },
    {
        ProductID: 610,
        Title: 'Compact Mechanical Keyboard',
        Description:
            'Designed for everyday use, this Compact Mechanical Keyboard delivers reliable performance and modern features.',
        datasetDate: '2024-09-02',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 349,
        },
    },
    {
        ProductID: 611,
        Title: 'Advanced Webcam',
        Description: 'A versatile Webcam featuring advanced construction and dependable performance for daily tasks.',
        datasetDate: '2024-09-03',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 717,
        },
    },
    {
        ProductID: 612,
        Title: 'Smart Air Purifier',
        Description:
            'Experience improved productivity with this Smart Air Purifier, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-09-04',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 899,
        },
    },
    {
        ProductID: 613,
        Title: 'Compact 4K Monitor',
        Description:
            'Upgrade your setup with the Compact 4K Monitor, engineered for speed, durability, and convenience.',
        datasetDate: '2024-09-05',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 450,
        },
    },
    {
        ProductID: 614,
        Title: 'Premium Fitness Tracker',
        Description:
            'Designed for everyday use, this Premium Fitness Tracker delivers reliable performance and modern features.',
        datasetDate: '2024-09-06',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 30,
        },
    },
    {
        ProductID: 615,
        Title: 'Advanced Noise Cancelling Headphones',
        Description:
            'The Advanced Noise Cancelling Headphones combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-09-07',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 515,
        },
    },
    {
        ProductID: 616,
        Title: 'Eco Smart Plug',
        Description:
            'Experience improved productivity with this Eco Smart Plug, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-09-08',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 1000,
        },
    },
    {
        ProductID: 617,
        Title: 'Ultra 4K Monitor',
        Description: 'Upgrade your setup with the Ultra 4K Monitor, engineered for speed, durability, and convenience.',
        datasetDate: '2024-09-09',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 516,
        },
    },
    {
        ProductID: 618,
        Title: 'Wireless Fitness Tracker',
        Description:
            'A versatile Fitness Tracker featuring wireless construction and dependable performance for daily tasks.',
        datasetDate: '2024-09-10',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 585,
        },
    },
    {
        ProductID: 619,
        Title: 'Advanced Robot Vacuum',
        Description:
            'The Advanced Robot Vacuum combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-09-11',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 805,
        },
    },
    {
        ProductID: 620,
        Title: 'Ultra Air Purifier',
        Description:
            'A versatile Air Purifier featuring ultra construction and dependable performance for daily tasks.',
        datasetDate: '2024-09-12',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 935,
        },
    },
    {
        ProductID: 621,
        Title: 'Compact Air Purifier',
        Description:
            'Upgrade your setup with the Compact Air Purifier, engineered for speed, durability, and convenience.',
        datasetDate: '2024-09-13',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 29,
        },
    },
    {
        ProductID: 622,
        Title: 'Portable Laptop Stand',
        Description:
            'Experience improved productivity with this Portable Laptop Stand, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-09-14',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 320,
        },
    },
    {
        ProductID: 623,
        Title: 'Smart Action Camera',
        Description:
            'Upgrade your setup with the Smart Action Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-09-15',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 877,
        },
    },
    {
        ProductID: 624,
        Title: 'Durable Smart Plug',
        Description:
            'Experience improved productivity with this Durable Smart Plug, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-09-16',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 670,
        },
    },
    {
        ProductID: 625,
        Title: 'Eco Electric Toothbrush',
        Description:
            'A versatile Electric Toothbrush featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-09-17',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 654,
        },
    },
    {
        ProductID: 626,
        Title: 'Pro Smart LED Bulb',
        Description:
            'Experience improved productivity with this Pro Smart LED Bulb, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-09-18',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 696,
        },
    },
    {
        ProductID: 627,
        Title: 'Ultra Coffee Grinder',
        Description:
            'The Ultra Coffee Grinder combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-09-19',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 345,
        },
    },
    {
        ProductID: 628,
        Title: 'Durable Smart Plug',
        Description:
            'A versatile Smart Plug featuring durable construction and dependable performance for daily tasks.',
        datasetDate: '2024-09-20',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 265,
        },
    },
    {
        ProductID: 629,
        Title: 'Eco Coffee Grinder',
        Description:
            'A versatile Coffee Grinder featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-09-21',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 316,
        },
    },
    {
        ProductID: 630,
        Title: 'Compact Robot Vacuum',
        Description:
            'Upgrade your setup with the Compact Robot Vacuum, engineered for speed, durability, and convenience.',
        datasetDate: '2024-09-22',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 115,
        },
    },
    {
        ProductID: 631,
        Title: 'Premium Noise Cancelling Headphones',
        Description:
            'Upgrade your setup with the Premium Noise Cancelling Headphones, engineered for speed, durability, and convenience.',
        datasetDate: '2024-09-23',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 166,
        },
    },
    {
        ProductID: 632,
        Title: 'Compact Home Security Camera',
        Description:
            'Upgrade your setup with the Compact Home Security Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-09-24',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 193,
        },
    },
    {
        ProductID: 633,
        Title: 'Pro Action Camera',
        Description: 'A versatile Action Camera featuring pro construction and dependable performance for daily tasks.',
        datasetDate: '2024-09-25',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 57,
        },
    },
    {
        ProductID: 634,
        Title: 'Pro Bluetooth Speaker',
        Description:
            'A versatile Bluetooth Speaker featuring pro construction and dependable performance for daily tasks.',
        datasetDate: '2024-09-26',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 235,
        },
    },
    {
        ProductID: 635,
        Title: 'Premium Webcam',
        Description:
            'Experience improved productivity with this Premium Webcam, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-09-27',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 569,
        },
    },
    {
        ProductID: 636,
        Title: 'Ultra Smart Plug',
        Description: 'Upgrade your setup with the Ultra Smart Plug, engineered for speed, durability, and convenience.',
        datasetDate: '2024-09-28',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 74,
        },
    },
    {
        ProductID: 637,
        Title: 'Ultra Bluetooth Speaker',
        Description:
            'Upgrade your setup with the Ultra Bluetooth Speaker, engineered for speed, durability, and convenience.',
        datasetDate: '2024-09-29',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 156,
        },
    },
    {
        ProductID: 638,
        Title: 'Smart Electric Toothbrush',
        Description:
            'Experience improved productivity with this Smart Electric Toothbrush, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-09-30',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 950,
        },
    },
    {
        ProductID: 639,
        Title: 'Smart Webcam',
        Description: 'A versatile Webcam featuring smart construction and dependable performance for daily tasks.',
        datasetDate: '2024-10-01',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 288,
        },
    },
    {
        ProductID: 640,
        Title: 'Smart Noise Cancelling Headphones',
        Description:
            'Experience improved productivity with this Smart Noise Cancelling Headphones, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-10-02',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 822,
        },
    },
    {
        ProductID: 641,
        Title: 'Pro USB-C Hub',
        Description: 'Upgrade your setup with the Pro USB-C Hub, engineered for speed, durability, and convenience.',
        datasetDate: '2024-10-03',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 336,
        },
    },
    {
        ProductID: 642,
        Title: 'Wireless Laptop Stand',
        Description:
            'Upgrade your setup with the Wireless Laptop Stand, engineered for speed, durability, and convenience.',
        datasetDate: '2024-10-04',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 955,
        },
    },
    {
        ProductID: 643,
        Title: 'Portable Gaming Mouse',
        Description:
            'Experience improved productivity with this Portable Gaming Mouse, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-10-05',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 811,
        },
    },
    {
        ProductID: 644,
        Title: 'Pro 4K Monitor',
        Description: 'A versatile 4K Monitor featuring pro construction and dependable performance for daily tasks.',
        datasetDate: '2024-10-06',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 108,
        },
    },
    {
        ProductID: 645,
        Title: 'Advanced Gaming Mouse',
        Description:
            'The Advanced Gaming Mouse combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-10-07',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 784,
        },
    },
    {
        ProductID: 646,
        Title: 'Smart Fitness Tracker',
        Description:
            'Designed for everyday use, this Smart Fitness Tracker delivers reliable performance and modern features.',
        datasetDate: '2024-10-08',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 506,
        },
    },
    {
        ProductID: 647,
        Title: 'Premium Mechanical Keyboard',
        Description:
            'A versatile Mechanical Keyboard featuring premium construction and dependable performance for daily tasks.',
        datasetDate: '2024-10-09',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 94,
        },
    },
    {
        ProductID: 648,
        Title: 'Pro USB-C Hub',
        Description: 'A versatile USB-C Hub featuring pro construction and dependable performance for daily tasks.',
        datasetDate: '2024-10-10',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 486,
        },
    },
    {
        ProductID: 649,
        Title: 'Wireless Gaming Mouse',
        Description:
            'Experience improved productivity with this Wireless Gaming Mouse, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-10-11',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 989,
        },
    },
    {
        ProductID: 650,
        Title: 'Smart Robot Vacuum',
        Description:
            'A versatile Robot Vacuum featuring smart construction and dependable performance for daily tasks.',
        datasetDate: '2024-10-12',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 899,
        },
    },
    {
        ProductID: 651,
        Title: 'Compact Noise Cancelling Headphones',
        Description:
            'Designed for everyday use, this Compact Noise Cancelling Headphones delivers reliable performance and modern features.',
        datasetDate: '2024-10-13',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 258,
        },
    },
    {
        ProductID: 652,
        Title: 'Advanced Noise Cancelling Headphones',
        Description:
            'A versatile Noise Cancelling Headphones featuring advanced construction and dependable performance for daily tasks.',
        datasetDate: '2024-10-14',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 757,
        },
    },
    {
        ProductID: 653,
        Title: 'Durable Mechanical Keyboard',
        Description:
            'Experience improved productivity with this Durable Mechanical Keyboard, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-10-15',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 787,
        },
    },
    {
        ProductID: 654,
        Title: 'Ultra Gaming Mouse',
        Description:
            'Upgrade your setup with the Ultra Gaming Mouse, engineered for speed, durability, and convenience.',
        datasetDate: '2024-10-16',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 91,
        },
    },
    {
        ProductID: 655,
        Title: 'Ultra Robot Vacuum',
        Description:
            'Upgrade your setup with the Ultra Robot Vacuum, engineered for speed, durability, and convenience.',
        datasetDate: '2024-10-17',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 427,
        },
    },
    {
        ProductID: 656,
        Title: 'Premium Action Camera',
        Description:
            'Upgrade your setup with the Premium Action Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-10-18',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 519,
        },
    },
    {
        ProductID: 657,
        Title: 'Advanced Action Camera',
        Description:
            'Designed for everyday use, this Advanced Action Camera delivers reliable performance and modern features.',
        datasetDate: '2024-10-19',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 463,
        },
    },
    {
        ProductID: 658,
        Title: 'Advanced External SSD',
        Description:
            'Experience improved productivity with this Advanced External SSD, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-10-20',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 940,
        },
    },
    {
        ProductID: 659,
        Title: 'Eco Laptop Stand',
        Description: 'The Eco Laptop Stand combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-10-21',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 796,
        },
    },
    {
        ProductID: 660,
        Title: 'Wireless 4K Monitor',
        Description:
            'A versatile 4K Monitor featuring wireless construction and dependable performance for daily tasks.',
        datasetDate: '2024-10-22',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 541,
        },
    },
    {
        ProductID: 661,
        Title: 'Eco Air Purifier',
        Description: 'Upgrade your setup with the Eco Air Purifier, engineered for speed, durability, and convenience.',
        datasetDate: '2024-10-23',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 300,
        },
    },
    {
        ProductID: 662,
        Title: 'Advanced Action Camera',
        Description:
            'Experience improved productivity with this Advanced Action Camera, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-10-24',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 661,
        },
    },
    {
        ProductID: 663,
        Title: 'Smart Webcam',
        Description:
            'Experience improved productivity with this Smart Webcam, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-10-25',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 271,
        },
    },
    {
        ProductID: 664,
        Title: 'Durable Robot Vacuum',
        Description:
            'Experience improved productivity with this Durable Robot Vacuum, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-10-26',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 510,
        },
    },
    {
        ProductID: 665,
        Title: 'Advanced Electric Toothbrush',
        Description:
            'Upgrade your setup with the Advanced Electric Toothbrush, engineered for speed, durability, and convenience.',
        datasetDate: '2024-10-27',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 752,
        },
    },
    {
        ProductID: 666,
        Title: 'Eco Air Purifier',
        Description: 'Upgrade your setup with the Eco Air Purifier, engineered for speed, durability, and convenience.',
        datasetDate: '2024-10-28',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 620,
        },
    },
    {
        ProductID: 667,
        Title: 'Advanced Smart LED Bulb',
        Description:
            'Experience improved productivity with this Advanced Smart LED Bulb, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-10-29',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 940,
        },
    },
    {
        ProductID: 668,
        Title: 'Compact Home Security Camera',
        Description:
            'The Compact Home Security Camera combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-10-30',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 858,
        },
    },
    {
        ProductID: 669,
        Title: 'Portable Gaming Mouse',
        Description:
            'Designed for everyday use, this Portable Gaming Mouse delivers reliable performance and modern features.',
        datasetDate: '2024-10-31',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 282,
        },
    },
    {
        ProductID: 670,
        Title: 'Premium Laptop Stand',
        Description:
            'Upgrade your setup with the Premium Laptop Stand, engineered for speed, durability, and convenience.',
        datasetDate: '2024-11-01',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 531,
        },
    },
    {
        ProductID: 671,
        Title: 'Wireless External SSD',
        Description:
            'The Wireless External SSD combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-11-02',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 552,
        },
    },
    {
        ProductID: 672,
        Title: 'Durable Smart LED Bulb',
        Description:
            'A versatile Smart LED Bulb featuring durable construction and dependable performance for daily tasks.',
        datasetDate: '2024-11-03',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 673,
        },
    },
    {
        ProductID: 673,
        Title: 'Eco Fitness Tracker',
        Description:
            'The Eco Fitness Tracker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-11-04',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 261,
        },
    },
    {
        ProductID: 674,
        Title: 'Portable Mechanical Keyboard',
        Description:
            'Experience improved productivity with this Portable Mechanical Keyboard, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-11-05',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 210,
        },
    },
    {
        ProductID: 675,
        Title: 'Portable Electric Toothbrush',
        Description:
            'Designed for everyday use, this Portable Electric Toothbrush delivers reliable performance and modern features.',
        datasetDate: '2024-11-06',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 166,
        },
    },
    {
        ProductID: 676,
        Title: 'Compact Air Purifier',
        Description:
            'A versatile Air Purifier featuring compact construction and dependable performance for daily tasks.',
        datasetDate: '2024-11-07',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 160,
        },
    },
    {
        ProductID: 677,
        Title: 'Compact Wireless Charger',
        Description:
            'A versatile Wireless Charger featuring compact construction and dependable performance for daily tasks.',
        datasetDate: '2024-11-08',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 895,
        },
    },
    {
        ProductID: 678,
        Title: 'Premium Wireless Charger',
        Description:
            'Designed for everyday use, this Premium Wireless Charger delivers reliable performance and modern features.',
        datasetDate: '2024-11-09',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 917,
        },
    },
    {
        ProductID: 679,
        Title: 'Portable Fitness Tracker',
        Description:
            'Upgrade your setup with the Portable Fitness Tracker, engineered for speed, durability, and convenience.',
        datasetDate: '2024-11-10',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 167,
        },
    },
    {
        ProductID: 680,
        Title: 'Smart Home Security Camera',
        Description:
            'A versatile Home Security Camera featuring smart construction and dependable performance for daily tasks.',
        datasetDate: '2024-11-11',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 468,
        },
    },
    {
        ProductID: 681,
        Title: 'Wireless Smart Plug',
        Description:
            'Upgrade your setup with the Wireless Smart Plug, engineered for speed, durability, and convenience.',
        datasetDate: '2024-11-12',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 613,
        },
    },
    {
        ProductID: 682,
        Title: 'Ultra Mechanical Keyboard',
        Description:
            'Designed for everyday use, this Ultra Mechanical Keyboard delivers reliable performance and modern features.',
        datasetDate: '2024-11-13',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 80,
        },
    },
    {
        ProductID: 683,
        Title: 'Eco Mechanical Keyboard',
        Description:
            'Designed for everyday use, this Eco Mechanical Keyboard delivers reliable performance and modern features.',
        datasetDate: '2024-11-14',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 818,
        },
    },
    {
        ProductID: 684,
        Title: 'Premium Coffee Grinder',
        Description:
            'The Premium Coffee Grinder combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-11-15',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 883,
        },
    },
    {
        ProductID: 685,
        Title: 'Durable Fitness Tracker',
        Description:
            'Designed for everyday use, this Durable Fitness Tracker delivers reliable performance and modern features.',
        datasetDate: '2024-11-16',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 35,
        },
    },
    {
        ProductID: 686,
        Title: 'Compact Bluetooth Speaker',
        Description:
            'A versatile Bluetooth Speaker featuring compact construction and dependable performance for daily tasks.',
        datasetDate: '2024-11-17',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 338,
        },
    },
    {
        ProductID: 687,
        Title: 'Advanced USB-C Hub',
        Description:
            'Upgrade your setup with the Advanced USB-C Hub, engineered for speed, durability, and convenience.',
        datasetDate: '2024-11-18',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 349,
        },
    },
    {
        ProductID: 688,
        Title: 'Ultra Mechanical Keyboard',
        Description:
            'Designed for everyday use, this Ultra Mechanical Keyboard delivers reliable performance and modern features.',
        datasetDate: '2024-11-19',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 24,
        },
    },
    {
        ProductID: 689,
        Title: 'Compact Coffee Grinder',
        Description:
            'Experience improved productivity with this Compact Coffee Grinder, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-11-20',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 509,
        },
    },
    {
        ProductID: 690,
        Title: 'Portable USB-C Hub',
        Description:
            'A versatile USB-C Hub featuring portable construction and dependable performance for daily tasks.',
        datasetDate: '2024-11-21',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 369,
        },
    },
    {
        ProductID: 691,
        Title: 'Wireless Bluetooth Speaker',
        Description:
            'Experience improved productivity with this Wireless Bluetooth Speaker, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-11-22',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 57,
        },
    },
    {
        ProductID: 692,
        Title: 'Ultra Smart LED Bulb',
        Description:
            'The Ultra Smart LED Bulb combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-11-23',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 920,
        },
    },
    {
        ProductID: 693,
        Title: 'Pro Gaming Mouse',
        Description: 'A versatile Gaming Mouse featuring pro construction and dependable performance for daily tasks.',
        datasetDate: '2024-11-24',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 978,
        },
    },
    {
        ProductID: 694,
        Title: 'Eco Action Camera',
        Description:
            'Upgrade your setup with the Eco Action Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-11-25',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 7,
        },
    },
    {
        ProductID: 695,
        Title: 'Wireless Bluetooth Speaker',
        Description:
            'Upgrade your setup with the Wireless Bluetooth Speaker, engineered for speed, durability, and convenience.',
        datasetDate: '2024-11-26',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 177,
        },
    },
    {
        ProductID: 696,
        Title: 'Eco Air Purifier',
        Description:
            'Experience improved productivity with this Eco Air Purifier, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-11-27',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 209,
        },
    },
    {
        ProductID: 697,
        Title: 'Compact Robot Vacuum',
        Description:
            'The Compact Robot Vacuum combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-11-28',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 277,
        },
    },
    {
        ProductID: 698,
        Title: 'Ultra Mechanical Keyboard',
        Description:
            'Upgrade your setup with the Ultra Mechanical Keyboard, engineered for speed, durability, and convenience.',
        datasetDate: '2024-11-29',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 31,
        },
    },
    {
        ProductID: 699,
        Title: 'Premium Smart Plug',
        Description:
            'A versatile Smart Plug featuring premium construction and dependable performance for daily tasks.',
        datasetDate: '2024-11-30',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 912,
        },
    },
    {
        ProductID: 700,
        Title: 'Premium Bluetooth Speaker',
        Description:
            'Upgrade your setup with the Premium Bluetooth Speaker, engineered for speed, durability, and convenience.',
        datasetDate: '2024-12-01',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 690,
        },
    },
    {
        ProductID: 701,
        Title: 'Eco Gaming Mouse',
        Description: 'A versatile Gaming Mouse featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-12-02',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 545,
        },
    },
    {
        ProductID: 702,
        Title: 'Wireless USB-C Hub',
        Description:
            'Experience improved productivity with this Wireless USB-C Hub, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-12-03',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 507,
        },
    },
    {
        ProductID: 703,
        Title: 'Advanced Fitness Tracker',
        Description:
            'Designed for everyday use, this Advanced Fitness Tracker delivers reliable performance and modern features.',
        datasetDate: '2024-12-04',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 762,
        },
    },
    {
        ProductID: 704,
        Title: 'Ultra Fitness Tracker',
        Description:
            'Designed for everyday use, this Ultra Fitness Tracker delivers reliable performance and modern features.',
        datasetDate: '2024-12-05',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 158,
        },
    },
    {
        ProductID: 705,
        Title: 'Portable Webcam',
        Description: 'Upgrade your setup with the Portable Webcam, engineered for speed, durability, and convenience.',
        datasetDate: '2024-12-06',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 179,
        },
    },
    {
        ProductID: 706,
        Title: 'Pro Electric Toothbrush',
        Description:
            'Designed for everyday use, this Pro Electric Toothbrush delivers reliable performance and modern features.',
        datasetDate: '2024-12-07',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 737,
        },
    },
    {
        ProductID: 707,
        Title: 'Advanced Fitness Tracker',
        Description:
            'Upgrade your setup with the Advanced Fitness Tracker, engineered for speed, durability, and convenience.',
        datasetDate: '2024-12-08',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 379,
        },
    },
    {
        ProductID: 708,
        Title: 'Durable Action Camera',
        Description:
            'The Durable Action Camera combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-12-09',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 603,
        },
    },
    {
        ProductID: 709,
        Title: 'Premium External SSD',
        Description:
            'A versatile External SSD featuring premium construction and dependable performance for daily tasks.',
        datasetDate: '2024-12-10',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 628,
        },
    },
    {
        ProductID: 710,
        Title: 'Advanced Smart Plug',
        Description:
            'The Advanced Smart Plug combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-12-11',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 360,
        },
    },
    {
        ProductID: 711,
        Title: 'Portable USB-C Hub',
        Description: 'The Portable USB-C Hub combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-12-12',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 810,
        },
    },
    {
        ProductID: 712,
        Title: 'Premium Bluetooth Speaker',
        Description:
            'The Premium Bluetooth Speaker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-12-13',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 128,
        },
    },
    {
        ProductID: 713,
        Title: 'Premium Laptop Stand',
        Description:
            'Experience improved productivity with this Premium Laptop Stand, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-12-14',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 913,
        },
    },
    {
        ProductID: 714,
        Title: 'Pro Fitness Tracker',
        Description:
            'The Pro Fitness Tracker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-12-15',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 523,
        },
    },
    {
        ProductID: 715,
        Title: 'Eco Fitness Tracker',
        Description:
            'Designed for everyday use, this Eco Fitness Tracker delivers reliable performance and modern features.',
        datasetDate: '2024-12-16',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 887,
        },
    },
    {
        ProductID: 716,
        Title: 'Durable Mechanical Keyboard',
        Description:
            'Experience improved productivity with this Durable Mechanical Keyboard, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-12-17',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 105,
        },
    },
    {
        ProductID: 717,
        Title: 'Pro 4K Monitor',
        Description: 'The Pro 4K Monitor combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-12-18',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 98,
        },
    },
    {
        ProductID: 718,
        Title: 'Pro Smart Plug',
        Description:
            'Experience improved productivity with this Pro Smart Plug, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-12-19',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 969,
        },
    },
    {
        ProductID: 719,
        Title: 'Advanced Smart LED Bulb',
        Description:
            'Upgrade your setup with the Advanced Smart LED Bulb, engineered for speed, durability, and convenience.',
        datasetDate: '2024-12-20',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 96,
        },
    },
    {
        ProductID: 720,
        Title: 'Eco Coffee Grinder',
        Description:
            'Experience improved productivity with this Eco Coffee Grinder, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-12-21',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 46,
        },
    },
    {
        ProductID: 721,
        Title: 'Pro Wireless Charger',
        Description:
            'Upgrade your setup with the Pro Wireless Charger, engineered for speed, durability, and convenience.',
        datasetDate: '2024-12-22',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 149,
        },
    },
    {
        ProductID: 722,
        Title: 'Durable Noise Cancelling Headphones',
        Description:
            'Designed for everyday use, this Durable Noise Cancelling Headphones delivers reliable performance and modern features.',
        datasetDate: '2024-12-23',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 962,
        },
    },
    {
        ProductID: 723,
        Title: 'Pro Mechanical Keyboard',
        Description:
            'The Pro Mechanical Keyboard combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-12-24',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 896,
        },
    },
    {
        ProductID: 724,
        Title: 'Durable Laptop Stand',
        Description:
            'A versatile Laptop Stand featuring durable construction and dependable performance for daily tasks.',
        datasetDate: '2024-12-25',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 325,
        },
    },
    {
        ProductID: 725,
        Title: 'Advanced Action Camera',
        Description:
            'The Advanced Action Camera combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-12-26',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 190,
        },
    },
    {
        ProductID: 726,
        Title: 'Pro Wireless Charger',
        Description:
            'The Pro Wireless Charger combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-12-27',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 827,
        },
    },
    {
        ProductID: 727,
        Title: 'Portable Coffee Grinder',
        Description:
            'The Portable Coffee Grinder combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-12-28',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 877,
        },
    },
    {
        ProductID: 728,
        Title: 'Compact Action Camera',
        Description:
            'A versatile Action Camera featuring compact construction and dependable performance for daily tasks.',
        datasetDate: '2024-12-29',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 287,
        },
    },
    {
        ProductID: 729,
        Title: 'Durable Air Purifier',
        Description:
            'Designed for everyday use, this Durable Air Purifier delivers reliable performance and modern features.',
        datasetDate: '2024-12-30',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 469,
        },
    },
    {
        ProductID: 730,
        Title: 'Advanced USB-C Hub',
        Description:
            'Designed for everyday use, this Advanced USB-C Hub delivers reliable performance and modern features.',
        datasetDate: '2024-01-01',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 736,
        },
    },
    {
        ProductID: 731,
        Title: 'Durable Gaming Mouse',
        Description:
            'Upgrade your setup with the Durable Gaming Mouse, engineered for speed, durability, and convenience.',
        datasetDate: '2024-01-02',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 794,
        },
    },
    {
        ProductID: 732,
        Title: 'Wireless Gaming Mouse',
        Description:
            'Upgrade your setup with the Wireless Gaming Mouse, engineered for speed, durability, and convenience.',
        datasetDate: '2024-01-03',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 612,
        },
    },
    {
        ProductID: 733,
        Title: 'Pro External SSD',
        Description:
            'Designed for everyday use, this Pro External SSD delivers reliable performance and modern features.',
        datasetDate: '2024-01-04',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 194,
        },
    },
    {
        ProductID: 734,
        Title: 'Compact Smart Plug',
        Description:
            'A versatile Smart Plug featuring compact construction and dependable performance for daily tasks.',
        datasetDate: '2024-01-05',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 458,
        },
    },
    {
        ProductID: 735,
        Title: 'Portable Noise Cancelling Headphones',
        Description:
            // eslint-disable-next-line max-len
            'Experience improved productivity with this Portable Noise Cancelling Headphones, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-01-06',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 729,
        },
    },
    {
        ProductID: 736,
        Title: 'Wireless Mechanical Keyboard',
        Description:
            'A versatile Mechanical Keyboard featuring wireless construction and dependable performance for daily tasks.',
        datasetDate: '2024-01-07',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 189,
        },
    },
    {
        ProductID: 737,
        Title: 'Wireless 4K Monitor',
        Description:
            'Upgrade your setup with the Wireless 4K Monitor, engineered for speed, durability, and convenience.',
        datasetDate: '2024-01-08',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 992,
        },
    },
    {
        ProductID: 738,
        Title: 'Durable USB-C Hub',
        Description: 'The Durable USB-C Hub combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-01-09',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 226,
        },
    },
    {
        ProductID: 739,
        Title: 'Smart Robot Vacuum',
        Description:
            'A versatile Robot Vacuum featuring smart construction and dependable performance for daily tasks.',
        datasetDate: '2024-01-10',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 570,
        },
    },
    {
        ProductID: 740,
        Title: 'Pro Mechanical Keyboard',
        Description:
            'Designed for everyday use, this Pro Mechanical Keyboard delivers reliable performance and modern features.',
        datasetDate: '2024-01-11',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 524,
        },
    },
    {
        ProductID: 741,
        Title: 'Compact Smart LED Bulb',
        Description:
            'A versatile Smart LED Bulb featuring compact construction and dependable performance for daily tasks.',
        datasetDate: '2024-01-12',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 807,
        },
    },
    {
        ProductID: 742,
        Title: 'Portable Gaming Mouse',
        Description:
            'A versatile Gaming Mouse featuring portable construction and dependable performance for daily tasks.',
        datasetDate: '2024-01-13',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 845,
        },
    },
    {
        ProductID: 743,
        Title: 'Wireless 4K Monitor',
        Description:
            'A versatile 4K Monitor featuring wireless construction and dependable performance for daily tasks.',
        datasetDate: '2024-01-14',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 801,
        },
    },
    {
        ProductID: 744,
        Title: 'Ultra Electric Toothbrush',
        Description:
            'A versatile Electric Toothbrush featuring ultra construction and dependable performance for daily tasks.',
        datasetDate: '2024-01-15',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 325,
        },
    },
    {
        ProductID: 745,
        Title: 'Premium External SSD',
        Description:
            'The Premium External SSD combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-01-16',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 537,
        },
    },
    {
        ProductID: 746,
        Title: 'Pro External SSD',
        Description: 'The Pro External SSD combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-01-17',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 213,
        },
    },
    {
        ProductID: 747,
        Title: 'Portable Wireless Charger',
        Description:
            'Experience improved productivity with this Portable Wireless Charger, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-01-18',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 971,
        },
    },
    {
        ProductID: 748,
        Title: 'Eco Home Security Camera',
        Description:
            'Designed for everyday use, this Eco Home Security Camera delivers reliable performance and modern features.',
        datasetDate: '2024-01-19',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 241,
        },
    },
    {
        ProductID: 749,
        Title: 'Advanced Wireless Charger',
        Description:
            'A versatile Wireless Charger featuring advanced construction and dependable performance for daily tasks.',
        datasetDate: '2024-01-20',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 259,
        },
    },
    {
        ProductID: 750,
        Title: 'Advanced Smart Plug',
        Description:
            'Experience improved productivity with this Advanced Smart Plug, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-01-21',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 255,
        },
    },
    {
        ProductID: 751,
        Title: 'Smart Robot Vacuum',
        Description:
            'A versatile Robot Vacuum featuring smart construction and dependable performance for daily tasks.',
        datasetDate: '2024-01-22',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 657,
        },
    },
    {
        ProductID: 752,
        Title: 'Ultra Laptop Stand',
        Description:
            'Designed for everyday use, this Ultra Laptop Stand delivers reliable performance and modern features.',
        datasetDate: '2024-01-23',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 169,
        },
    },
    {
        ProductID: 753,
        Title: 'Ultra Wireless Charger',
        Description:
            'Designed for everyday use, this Ultra Wireless Charger delivers reliable performance and modern features.',
        datasetDate: '2024-01-24',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 745,
        },
    },
    {
        ProductID: 754,
        Title: 'Pro Noise Cancelling Headphones',
        Description:
            'The Pro Noise Cancelling Headphones combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-01-25',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 753,
        },
    },
    {
        ProductID: 755,
        Title: 'Premium Laptop Stand',
        Description:
            'A versatile Laptop Stand featuring premium construction and dependable performance for daily tasks.',
        datasetDate: '2024-01-26',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 844,
        },
    },
    {
        ProductID: 756,
        Title: 'Durable Home Security Camera',
        Description:
            'Experience improved productivity with this Durable Home Security Camera, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-01-27',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 757,
        },
    },
    {
        ProductID: 757,
        Title: 'Premium USB-C Hub',
        Description:
            'Experience improved productivity with this Premium USB-C Hub, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-01-28',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 760,
        },
    },
    {
        ProductID: 758,
        Title: 'Eco Gaming Mouse',
        Description:
            'Experience improved productivity with this Eco Gaming Mouse, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-01-29',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 446,
        },
    },
    {
        ProductID: 759,
        Title: 'Smart Smart Plug',
        Description:
            'Designed for everyday use, this Smart Smart Plug delivers reliable performance and modern features.',
        datasetDate: '2024-01-30',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 922,
        },
    },
    {
        ProductID: 760,
        Title: 'Premium Smart Plug',
        Description:
            'Designed for everyday use, this Premium Smart Plug delivers reliable performance and modern features.',
        datasetDate: '2024-01-31',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 68,
        },
    },
    {
        ProductID: 761,
        Title: 'Smart Coffee Grinder',
        Description:
            'Designed for everyday use, this Smart Coffee Grinder delivers reliable performance and modern features.',
        datasetDate: '2024-02-01',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 722,
        },
    },
    {
        ProductID: 762,
        Title: 'Advanced Robot Vacuum',
        Description:
            'Designed for everyday use, this Advanced Robot Vacuum delivers reliable performance and modern features.',
        datasetDate: '2024-02-02',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 868,
        },
    },
    {
        ProductID: 763,
        Title: 'Wireless 4K Monitor',
        Description:
            'Upgrade your setup with the Wireless 4K Monitor, engineered for speed, durability, and convenience.',
        datasetDate: '2024-02-03',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 536,
        },
    },
    {
        ProductID: 764,
        Title: 'Advanced Wireless Charger',
        Description:
            'Upgrade your setup with the Advanced Wireless Charger, engineered for speed, durability, and convenience.',
        datasetDate: '2024-02-04',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 123,
        },
    },
    {
        ProductID: 765,
        Title: 'Compact Home Security Camera',
        Description:
            'Upgrade your setup with the Compact Home Security Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-02-05',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 595,
        },
    },
    {
        ProductID: 766,
        Title: 'Compact USB-C Hub',
        Description:
            'Experience improved productivity with this Compact USB-C Hub, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-02-06',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 47,
        },
    },
    {
        ProductID: 767,
        Title: 'Durable Laptop Stand',
        Description:
            'Designed for everyday use, this Durable Laptop Stand delivers reliable performance and modern features.',
        datasetDate: '2024-02-07',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 540,
        },
    },
    {
        ProductID: 768,
        Title: 'Ultra Mechanical Keyboard',
        Description:
            'Experience improved productivity with this Ultra Mechanical Keyboard, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-02-08',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 795,
        },
    },
    {
        ProductID: 769,
        Title: 'Eco Gaming Mouse',
        Description: 'A versatile Gaming Mouse featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-02-09',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 42,
        },
    },
    {
        ProductID: 770,
        Title: 'Portable Wireless Charger',
        Description:
            'A versatile Wireless Charger featuring portable construction and dependable performance for daily tasks.',
        datasetDate: '2024-02-10',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 988,
        },
    },
    {
        ProductID: 771,
        Title: 'Advanced Noise Cancelling Headphones',
        Description:
            'The Advanced Noise Cancelling Headphones combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-02-11',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 7,
        },
    },
    {
        ProductID: 772,
        Title: 'Advanced Bluetooth Speaker',
        Description:
            'Designed for everyday use, this Advanced Bluetooth Speaker delivers reliable performance and modern features.',
        datasetDate: '2024-02-12',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 436,
        },
    },
    {
        ProductID: 773,
        Title: 'Portable Action Camera',
        Description:
            'Experience improved productivity with this Portable Action Camera, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-02-13',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 226,
        },
    },
    {
        ProductID: 774,
        Title: 'Durable Wireless Charger',
        Description:
            'A versatile Wireless Charger featuring durable construction and dependable performance for daily tasks.',
        datasetDate: '2024-02-14',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 836,
        },
    },
    {
        ProductID: 775,
        Title: 'Portable Bluetooth Speaker',
        Description:
            'Upgrade your setup with the Portable Bluetooth Speaker, engineered for speed, durability, and convenience.',
        datasetDate: '2024-02-15',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 288,
        },
    },
    {
        ProductID: 776,
        Title: 'Portable Noise Cancelling Headphones',
        Description:
            // eslint-disable-next-line max-len
            'Experience improved productivity with this Portable Noise Cancelling Headphones, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-02-16',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 170,
        },
    },
    {
        ProductID: 777,
        Title: 'Eco Smart Plug',
        Description:
            'Experience improved productivity with this Eco Smart Plug, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-02-17',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 229,
        },
    },
    {
        ProductID: 778,
        Title: 'Compact 4K Monitor',
        Description:
            'Upgrade your setup with the Compact 4K Monitor, engineered for speed, durability, and convenience.',
        datasetDate: '2024-02-18',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 747,
        },
    },
    {
        ProductID: 779,
        Title: 'Premium Gaming Mouse',
        Description:
            'A versatile Gaming Mouse featuring premium construction and dependable performance for daily tasks.',
        datasetDate: '2024-02-19',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 650,
        },
    },
    {
        ProductID: 780,
        Title: 'Premium Coffee Grinder',
        Description:
            'The Premium Coffee Grinder combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-02-20',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 163,
        },
    },
    {
        ProductID: 781,
        Title: 'Eco Action Camera',
        Description: 'A versatile Action Camera featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-02-21',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 356,
        },
    },
    {
        ProductID: 782,
        Title: 'Ultra 4K Monitor',
        Description:
            'Experience improved productivity with this Ultra 4K Monitor, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-02-22',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 145,
        },
    },
    {
        ProductID: 783,
        Title: 'Portable Smart Plug',
        Description:
            'A versatile Smart Plug featuring portable construction and dependable performance for daily tasks.',
        datasetDate: '2024-02-23',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 859,
        },
    },
    {
        ProductID: 784,
        Title: 'Ultra Coffee Grinder',
        Description:
            'Designed for everyday use, this Ultra Coffee Grinder delivers reliable performance and modern features.',
        datasetDate: '2024-02-24',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 940,
        },
    },
    {
        ProductID: 785,
        Title: 'Premium 4K Monitor',
        Description:
            'Experience improved productivity with this Premium 4K Monitor, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-02-25',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 405,
        },
    },
    {
        ProductID: 786,
        Title: 'Smart Electric Toothbrush',
        Description:
            'A versatile Electric Toothbrush featuring smart construction and dependable performance for daily tasks.',
        datasetDate: '2024-02-26',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 413,
        },
    },
    {
        ProductID: 787,
        Title: 'Compact Coffee Grinder',
        Description:
            'Designed for everyday use, this Compact Coffee Grinder delivers reliable performance and modern features.',
        datasetDate: '2024-02-27',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 232,
        },
    },
    {
        ProductID: 788,
        Title: 'Smart Smart LED Bulb',
        Description:
            'Designed for everyday use, this Smart Smart LED Bulb delivers reliable performance and modern features.',
        datasetDate: '2024-02-28',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 935,
        },
    },
    {
        ProductID: 789,
        Title: 'Pro Robot Vacuum',
        Description: 'Upgrade your setup with the Pro Robot Vacuum, engineered for speed, durability, and convenience.',
        datasetDate: '2024-02-29',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 617,
        },
    },
    {
        ProductID: 790,
        Title: 'Smart Electric Toothbrush',
        Description:
            'Designed for everyday use, this Smart Electric Toothbrush delivers reliable performance and modern features.',
        datasetDate: '2024-03-01',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 410,
        },
    },
    {
        ProductID: 791,
        Title: 'Premium Noise Cancelling Headphones',
        Description:
            'Upgrade your setup with the Premium Noise Cancelling Headphones, engineered for speed, durability, and convenience.',
        datasetDate: '2024-03-02',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 146,
        },
    },
    {
        ProductID: 792,
        Title: 'Pro Action Camera',
        Description:
            'Upgrade your setup with the Pro Action Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-03-03',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 726,
        },
    },
    {
        ProductID: 793,
        Title: 'Durable External SSD',
        Description:
            'Upgrade your setup with the Durable External SSD, engineered for speed, durability, and convenience.',
        datasetDate: '2024-03-04',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 904,
        },
    },
    {
        ProductID: 794,
        Title: 'Eco Fitness Tracker',
        Description:
            'Upgrade your setup with the Eco Fitness Tracker, engineered for speed, durability, and convenience.',
        datasetDate: '2024-03-05',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 932,
        },
    },
    {
        ProductID: 795,
        Title: 'Premium Fitness Tracker',
        Description:
            'Upgrade your setup with the Premium Fitness Tracker, engineered for speed, durability, and convenience.',
        datasetDate: '2024-03-06',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 851,
        },
    },
    {
        ProductID: 796,
        Title: 'Durable Bluetooth Speaker',
        Description:
            'Designed for everyday use, this Durable Bluetooth Speaker delivers reliable performance and modern features.',
        datasetDate: '2024-03-07',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 429,
        },
    },
    {
        ProductID: 797,
        Title: 'Durable 4K Monitor',
        Description:
            'Upgrade your setup with the Durable 4K Monitor, engineered for speed, durability, and convenience.',
        datasetDate: '2024-03-08',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 749,
        },
    },
    {
        ProductID: 798,
        Title: 'Smart Smart Plug',
        Description:
            'Designed for everyday use, this Smart Smart Plug delivers reliable performance and modern features.',
        datasetDate: '2024-03-09',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 491,
        },
    },
    {
        ProductID: 799,
        Title: 'Smart Coffee Grinder',
        Description:
            'Designed for everyday use, this Smart Coffee Grinder delivers reliable performance and modern features.',
        datasetDate: '2024-03-10',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 875,
        },
    },
    {
        ProductID: 800,
        Title: 'Premium Laptop Stand',
        Description:
            'A versatile Laptop Stand featuring premium construction and dependable performance for daily tasks.',
        datasetDate: '2024-03-11',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 719,
        },
    },
    {
        ProductID: 801,
        Title: 'Eco Webcam',
        Description: 'A versatile Webcam featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-03-12',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 264,
        },
    },
    {
        ProductID: 802,
        Title: 'Wireless USB-C Hub',
        Description:
            'Experience improved productivity with this Wireless USB-C Hub, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-03-13',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 395,
        },
    },
    {
        ProductID: 803,
        Title: 'Advanced Air Purifier',
        Description:
            'The Advanced Air Purifier combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-03-14',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 536,
        },
    },
    {
        ProductID: 804,
        Title: 'Compact Webcam',
        Description: 'A versatile Webcam featuring compact construction and dependable performance for daily tasks.',
        datasetDate: '2024-03-15',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 730,
        },
    },
    {
        ProductID: 805,
        Title: 'Smart Robot Vacuum',
        Description:
            'Designed for everyday use, this Smart Robot Vacuum delivers reliable performance and modern features.',
        datasetDate: '2024-03-16',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 558,
        },
    },
    {
        ProductID: 806,
        Title: 'Smart Smart Plug',
        Description: 'A versatile Smart Plug featuring smart construction and dependable performance for daily tasks.',
        datasetDate: '2024-03-17',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 197,
        },
    },
    {
        ProductID: 807,
        Title: 'Portable 4K Monitor',
        Description:
            'Upgrade your setup with the Portable 4K Monitor, engineered for speed, durability, and convenience.',
        datasetDate: '2024-03-18',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 470,
        },
    },
    {
        ProductID: 808,
        Title: 'Portable Gaming Mouse',
        Description:
            'The Portable Gaming Mouse combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-03-19',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 903,
        },
    },
    {
        ProductID: 809,
        Title: 'Ultra Gaming Mouse',
        Description:
            'A versatile Gaming Mouse featuring ultra construction and dependable performance for daily tasks.',
        datasetDate: '2024-03-20',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 584,
        },
    },
    {
        ProductID: 810,
        Title: 'Durable Smart LED Bulb',
        Description:
            'The Durable Smart LED Bulb combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-03-21',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 541,
        },
    },
    {
        ProductID: 811,
        Title: 'Smart Gaming Mouse',
        Description:
            'A versatile Gaming Mouse featuring smart construction and dependable performance for daily tasks.',
        datasetDate: '2024-03-22',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 582,
        },
    },
    {
        ProductID: 812,
        Title: 'Eco Webcam',
        Description: 'The Eco Webcam combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-03-23',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 717,
        },
    },
    {
        ProductID: 813,
        Title: 'Pro Wireless Charger',
        Description:
            'Designed for everyday use, this Pro Wireless Charger delivers reliable performance and modern features.',
        datasetDate: '2024-03-24',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 321,
        },
    },
    {
        ProductID: 814,
        Title: 'Durable External SSD',
        Description:
            'The Durable External SSD combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-03-25',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 452,
        },
    },
    {
        ProductID: 815,
        Title: 'Ultra Action Camera',
        Description:
            'A versatile Action Camera featuring ultra construction and dependable performance for daily tasks.',
        datasetDate: '2024-03-26',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 735,
        },
    },
    {
        ProductID: 816,
        Title: 'Eco USB-C Hub',
        Description: 'Designed for everyday use, this Eco USB-C Hub delivers reliable performance and modern features.',
        datasetDate: '2024-03-27',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 814,
        },
    },
    {
        ProductID: 817,
        Title: 'Eco Fitness Tracker',
        Description:
            'A versatile Fitness Tracker featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-03-28',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 74,
        },
    },
    {
        ProductID: 818,
        Title: 'Ultra Fitness Tracker',
        Description:
            'Designed for everyday use, this Ultra Fitness Tracker delivers reliable performance and modern features.',
        datasetDate: '2024-03-29',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 509,
        },
    },
    {
        ProductID: 819,
        Title: 'Smart Noise Cancelling Headphones',
        Description:
            'Experience improved productivity with this Smart Noise Cancelling Headphones, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-03-30',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 181,
        },
    },
    {
        ProductID: 820,
        Title: 'Portable Laptop Stand',
        Description:
            'A versatile Laptop Stand featuring portable construction and dependable performance for daily tasks.',
        datasetDate: '2024-03-31',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 603,
        },
    },
    {
        ProductID: 821,
        Title: 'Wireless Webcam',
        Description: 'Upgrade your setup with the Wireless Webcam, engineered for speed, durability, and convenience.',
        datasetDate: '2024-04-01',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 711,
        },
    },
    {
        ProductID: 822,
        Title: 'Advanced Webcam',
        Description:
            'Experience improved productivity with this Advanced Webcam, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-04-02',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 543,
        },
    },
    {
        ProductID: 823,
        Title: 'Compact Wireless Charger',
        Description:
            'A versatile Wireless Charger featuring compact construction and dependable performance for daily tasks.',
        datasetDate: '2024-04-03',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 221,
        },
    },
    {
        ProductID: 824,
        Title: 'Ultra External SSD',
        Description:
            'Upgrade your setup with the Ultra External SSD, engineered for speed, durability, and convenience.',
        datasetDate: '2024-04-04',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 290,
        },
    },
    {
        ProductID: 825,
        Title: 'Ultra Noise Cancelling Headphones',
        Description:
            'A versatile Noise Cancelling Headphones featuring ultra construction and dependable performance for daily tasks.',
        datasetDate: '2024-04-05',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 382,
        },
    },
    {
        ProductID: 826,
        Title: 'Advanced Mechanical Keyboard',
        Description:
            'Experience improved productivity with this Advanced Mechanical Keyboard, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-04-06',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 882,
        },
    },
    {
        ProductID: 827,
        Title: 'Ultra Laptop Stand',
        Description:
            'Designed for everyday use, this Ultra Laptop Stand delivers reliable performance and modern features.',
        datasetDate: '2024-04-07',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 282,
        },
    },
    {
        ProductID: 828,
        Title: 'Wireless Action Camera',
        Description:
            'Designed for everyday use, this Wireless Action Camera delivers reliable performance and modern features.',
        datasetDate: '2024-04-08',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 939,
        },
    },
    {
        ProductID: 829,
        Title: 'Wireless Smart Plug',
        Description:
            'A versatile Smart Plug featuring wireless construction and dependable performance for daily tasks.',
        datasetDate: '2024-04-09',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 422,
        },
    },
    {
        ProductID: 830,
        Title: 'Eco Air Purifier',
        Description:
            'Experience improved productivity with this Eco Air Purifier, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-04-10',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 62,
        },
    },
    {
        ProductID: 831,
        Title: 'Premium Smart Plug',
        Description:
            'A versatile Smart Plug featuring premium construction and dependable performance for daily tasks.',
        datasetDate: '2024-04-11',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 446,
        },
    },
    {
        ProductID: 832,
        Title: 'Premium 4K Monitor',
        Description:
            'Designed for everyday use, this Premium 4K Monitor delivers reliable performance and modern features.',
        datasetDate: '2024-04-12',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 15,
        },
    },
    {
        ProductID: 833,
        Title: 'Premium Bluetooth Speaker',
        Description:
            'A versatile Bluetooth Speaker featuring premium construction and dependable performance for daily tasks.',
        datasetDate: '2024-04-13',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 284,
        },
    },
    {
        ProductID: 834,
        Title: 'Advanced Robot Vacuum',
        Description:
            'A versatile Robot Vacuum featuring advanced construction and dependable performance for daily tasks.',
        datasetDate: '2024-04-14',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 98,
        },
    },
    {
        ProductID: 835,
        Title: 'Portable Robot Vacuum',
        Description:
            'Designed for everyday use, this Portable Robot Vacuum delivers reliable performance and modern features.',
        datasetDate: '2024-04-15',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 897,
        },
    },
    {
        ProductID: 836,
        Title: 'Eco Action Camera',
        Description:
            'Experience improved productivity with this Eco Action Camera, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-04-16',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 340,
        },
    },
    {
        ProductID: 837,
        Title: 'Wireless Electric Toothbrush',
        Description:
            'A versatile Electric Toothbrush featuring wireless construction and dependable performance for daily tasks.',
        datasetDate: '2024-04-17',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 41,
        },
    },
    {
        ProductID: 838,
        Title: 'Pro External SSD',
        Description:
            'Experience improved productivity with this Pro External SSD, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-04-18',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 425,
        },
    },
    {
        ProductID: 839,
        Title: 'Eco Wireless Charger',
        Description:
            'Upgrade your setup with the Eco Wireless Charger, engineered for speed, durability, and convenience.',
        datasetDate: '2024-04-19',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 749,
        },
    },
    {
        ProductID: 840,
        Title: 'Advanced Robot Vacuum',
        Description:
            'Designed for everyday use, this Advanced Robot Vacuum delivers reliable performance and modern features.',
        datasetDate: '2024-04-20',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 178,
        },
    },
    {
        ProductID: 841,
        Title: 'Durable Smart Plug',
        Description:
            'Experience improved productivity with this Durable Smart Plug, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-04-21',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 769,
        },
    },
    {
        ProductID: 842,
        Title: 'Wireless Gaming Mouse',
        Description:
            'A versatile Gaming Mouse featuring wireless construction and dependable performance for daily tasks.',
        datasetDate: '2024-04-22',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 506,
        },
    },
    {
        ProductID: 843,
        Title: 'Durable Home Security Camera',
        Description:
            'The Durable Home Security Camera combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-04-23',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 158,
        },
    },
    {
        ProductID: 844,
        Title: 'Eco Gaming Mouse',
        Description:
            'Experience improved productivity with this Eco Gaming Mouse, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-04-24',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 956,
        },
    },
    {
        ProductID: 845,
        Title: 'Portable Fitness Tracker',
        Description:
            'The Portable Fitness Tracker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-04-25',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 754,
        },
    },
    {
        ProductID: 846,
        Title: 'Compact Bluetooth Speaker',
        Description:
            'A versatile Bluetooth Speaker featuring compact construction and dependable performance for daily tasks.',
        datasetDate: '2024-04-26',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 507,
        },
    },
    {
        ProductID: 847,
        Title: 'Ultra Smart LED Bulb',
        Description:
            'A versatile Smart LED Bulb featuring ultra construction and dependable performance for daily tasks.',
        datasetDate: '2024-04-27',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 71,
        },
    },
    {
        ProductID: 848,
        Title: 'Premium Home Security Camera',
        Description:
            'Upgrade your setup with the Premium Home Security Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-04-28',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 357,
        },
    },
    {
        ProductID: 849,
        Title: 'Portable Air Purifier',
        Description:
            'Upgrade your setup with the Portable Air Purifier, engineered for speed, durability, and convenience.',
        datasetDate: '2024-04-29',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 168,
        },
    },
    {
        ProductID: 850,
        Title: 'Pro Fitness Tracker',
        Description:
            'A versatile Fitness Tracker featuring pro construction and dependable performance for daily tasks.',
        datasetDate: '2024-04-30',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 154,
        },
    },
    {
        ProductID: 851,
        Title: 'Smart Noise Cancelling Headphones',
        Description:
            'Upgrade your setup with the Smart Noise Cancelling Headphones, engineered for speed, durability, and convenience.',
        datasetDate: '2024-05-01',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 599,
        },
    },
    {
        ProductID: 852,
        Title: 'Wireless USB-C Hub',
        Description:
            'Designed for everyday use, this Wireless USB-C Hub delivers reliable performance and modern features.',
        datasetDate: '2024-05-02',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 673,
        },
    },
    {
        ProductID: 853,
        Title: 'Advanced External SSD',
        Description:
            'Designed for everyday use, this Advanced External SSD delivers reliable performance and modern features.',
        datasetDate: '2024-05-03',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 921,
        },
    },
    {
        ProductID: 854,
        Title: 'Pro Air Purifier',
        Description:
            'Designed for everyday use, this Pro Air Purifier delivers reliable performance and modern features.',
        datasetDate: '2024-05-04',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 990,
        },
    },
    {
        ProductID: 855,
        Title: 'Wireless External SSD',
        Description:
            'A versatile External SSD featuring wireless construction and dependable performance for daily tasks.',
        datasetDate: '2024-05-05',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 412,
        },
    },
    {
        ProductID: 856,
        Title: 'Smart Smart LED Bulb',
        Description:
            'The Smart Smart LED Bulb combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-05-06',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 99,
        },
    },
    {
        ProductID: 857,
        Title: 'Portable External SSD',
        Description:
            'Experience improved productivity with this Portable External SSD, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-05-07',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 738,
        },
    },
    {
        ProductID: 858,
        Title: 'Eco Bluetooth Speaker',
        Description:
            'Experience improved productivity with this Eco Bluetooth Speaker, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-05-08',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 580,
        },
    },
    {
        ProductID: 859,
        Title: 'Eco Air Purifier',
        Description: 'A versatile Air Purifier featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-05-09',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 227,
        },
    },
    {
        ProductID: 860,
        Title: 'Smart Electric Toothbrush',
        Description:
            'A versatile Electric Toothbrush featuring smart construction and dependable performance for daily tasks.',
        datasetDate: '2024-05-10',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 276,
        },
    },
    {
        ProductID: 861,
        Title: 'Eco Smart Plug',
        Description: 'Upgrade your setup with the Eco Smart Plug, engineered for speed, durability, and convenience.',
        datasetDate: '2024-05-11',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 778,
        },
    },
    {
        ProductID: 862,
        Title: 'Pro Fitness Tracker',
        Description:
            'A versatile Fitness Tracker featuring pro construction and dependable performance for daily tasks.',
        datasetDate: '2024-05-12',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 507,
        },
    },
    {
        ProductID: 863,
        Title: 'Eco Bluetooth Speaker',
        Description:
            'The Eco Bluetooth Speaker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-05-13',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 657,
        },
    },
    {
        ProductID: 864,
        Title: 'Ultra Smart LED Bulb',
        Description:
            'Designed for everyday use, this Ultra Smart LED Bulb delivers reliable performance and modern features.',
        datasetDate: '2024-05-14',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 124,
        },
    },
    {
        ProductID: 865,
        Title: 'Durable Webcam',
        Description: 'A versatile Webcam featuring durable construction and dependable performance for daily tasks.',
        datasetDate: '2024-05-15',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 683,
        },
    },
    {
        ProductID: 866,
        Title: 'Premium Noise Cancelling Headphones',
        Description:
            'Upgrade your setup with the Premium Noise Cancelling Headphones, engineered for speed, durability, and convenience.',
        datasetDate: '2024-05-16',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 449,
        },
    },
    {
        ProductID: 867,
        Title: 'Smart Laptop Stand',
        Description:
            'A versatile Laptop Stand featuring smart construction and dependable performance for daily tasks.',
        datasetDate: '2024-05-17',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 566,
        },
    },
    {
        ProductID: 868,
        Title: 'Smart Gaming Mouse',
        Description:
            'A versatile Gaming Mouse featuring smart construction and dependable performance for daily tasks.',
        datasetDate: '2024-05-18',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 438,
        },
    },
    {
        ProductID: 869,
        Title: 'Advanced USB-C Hub',
        Description:
            'Designed for everyday use, this Advanced USB-C Hub delivers reliable performance and modern features.',
        datasetDate: '2024-05-19',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 971,
        },
    },
    {
        ProductID: 870,
        Title: 'Portable Home Security Camera',
        Description:
            'Experience improved productivity with this Portable Home Security Camera, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-05-20',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 902,
        },
    },
    {
        ProductID: 871,
        Title: 'Advanced Gaming Mouse',
        Description:
            'A versatile Gaming Mouse featuring advanced construction and dependable performance for daily tasks.',
        datasetDate: '2024-05-21',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 872,
        },
    },
    {
        ProductID: 872,
        Title: 'Portable Noise Cancelling Headphones',
        Description:
            'The Portable Noise Cancelling Headphones combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-05-22',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 120,
        },
    },
    {
        ProductID: 873,
        Title: 'Wireless Wireless Charger',
        Description:
            'Designed for everyday use, this Wireless Wireless Charger delivers reliable performance and modern features.',
        datasetDate: '2024-05-23',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 161,
        },
    },
    {
        ProductID: 874,
        Title: 'Durable External SSD',
        Description:
            'Upgrade your setup with the Durable External SSD, engineered for speed, durability, and convenience.',
        datasetDate: '2024-05-24',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 358,
        },
    },
    {
        ProductID: 875,
        Title: 'Compact Home Security Camera',
        Description:
            'Upgrade your setup with the Compact Home Security Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-05-25',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 908,
        },
    },
    {
        ProductID: 876,
        Title: 'Advanced Fitness Tracker',
        Description:
            'Upgrade your setup with the Advanced Fitness Tracker, engineered for speed, durability, and convenience.',
        datasetDate: '2024-05-26',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 222,
        },
    },
    {
        ProductID: 877,
        Title: 'Pro Electric Toothbrush',
        Description:
            'Experience improved productivity with this Pro Electric Toothbrush, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-05-27',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 26,
        },
    },
    {
        ProductID: 878,
        Title: 'Eco Electric Toothbrush',
        Description:
            'A versatile Electric Toothbrush featuring eco construction and dependable performance for daily tasks.',
        datasetDate: '2024-05-28',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 191,
        },
    },
    {
        ProductID: 879,
        Title: 'Premium Webcam',
        Description:
            'Designed for everyday use, this Premium Webcam delivers reliable performance and modern features.',
        datasetDate: '2024-05-29',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 751,
        },
    },
    {
        ProductID: 880,
        Title: 'Premium Smart Plug',
        Description:
            'Upgrade your setup with the Premium Smart Plug, engineered for speed, durability, and convenience.',
        datasetDate: '2024-05-30',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 500,
        },
    },
    {
        ProductID: 881,
        Title: 'Pro Gaming Mouse',
        Description:
            'Experience improved productivity with this Pro Gaming Mouse, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-05-31',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 14,
        },
    },
    {
        ProductID: 882,
        Title: 'Ultra Smart LED Bulb',
        Description:
            'Designed for everyday use, this Ultra Smart LED Bulb delivers reliable performance and modern features.',
        datasetDate: '2024-06-01',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 802,
        },
    },
    {
        ProductID: 883,
        Title: 'Smart Laptop Stand',
        Description: 'The Smart Laptop Stand combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-06-02',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 648,
        },
    },
    {
        ProductID: 884,
        Title: 'Compact Mechanical Keyboard',
        Description:
            'Experience improved productivity with this Compact Mechanical Keyboard, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-06-03',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 447,
        },
    },
    {
        ProductID: 885,
        Title: 'Wireless Coffee Grinder',
        Description:
            'The Wireless Coffee Grinder combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-06-04',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 616,
        },
    },
    {
        ProductID: 886,
        Title: 'Advanced Fitness Tracker',
        Description:
            'Upgrade your setup with the Advanced Fitness Tracker, engineered for speed, durability, and convenience.',
        datasetDate: '2024-06-05',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 338,
        },
    },
    {
        ProductID: 887,
        Title: 'Eco Smart Plug',
        Description:
            'Designed for everyday use, this Eco Smart Plug delivers reliable performance and modern features.',
        datasetDate: '2024-06-06',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 565,
        },
    },
    {
        ProductID: 888,
        Title: 'Premium Noise Cancelling Headphones',
        Description:
            // eslint-disable-next-line max-len
            'Experience improved productivity with this Premium Noise Cancelling Headphones, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-06-07',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 621,
        },
    },
    {
        ProductID: 889,
        Title: 'Wireless Home Security Camera',
        Description:
            'The Wireless Home Security Camera combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-06-08',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 255,
        },
    },
    {
        ProductID: 890,
        Title: 'Portable Webcam',
        Description:
            'Experience improved productivity with this Portable Webcam, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-06-09',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 542,
        },
    },
    {
        ProductID: 891,
        Title: 'Advanced Action Camera',
        Description:
            'The Advanced Action Camera combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-06-10',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 308,
        },
    },
    {
        ProductID: 892,
        Title: 'Eco USB-C Hub',
        Description:
            'Experience improved productivity with this Eco USB-C Hub, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-06-11',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 677,
        },
    },
    {
        ProductID: 893,
        Title: 'Compact 4K Monitor',
        Description:
            'A versatile 4K Monitor featuring compact construction and dependable performance for daily tasks.',
        datasetDate: '2024-06-12',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 519,
        },
    },
    {
        ProductID: 894,
        Title: 'Premium Laptop Stand',
        Description:
            'Upgrade your setup with the Premium Laptop Stand, engineered for speed, durability, and convenience.',
        datasetDate: '2024-06-13',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 821,
        },
    },
    {
        ProductID: 895,
        Title: 'Pro Action Camera',
        Description: 'A versatile Action Camera featuring pro construction and dependable performance for daily tasks.',
        datasetDate: '2024-06-14',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 227,
        },
    },
    {
        ProductID: 896,
        Title: 'Ultra Wireless Charger',
        Description:
            'Upgrade your setup with the Ultra Wireless Charger, engineered for speed, durability, and convenience.',
        datasetDate: '2024-06-15',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 133,
        },
    },
    {
        ProductID: 897,
        Title: 'Smart Mechanical Keyboard',
        Description:
            'Experience improved productivity with this Smart Mechanical Keyboard, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-06-16',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 182,
        },
    },
    {
        ProductID: 898,
        Title: 'Wireless Noise Cancelling Headphones',
        Description:
            // eslint-disable-next-line max-len
            'Experience improved productivity with this Wireless Noise Cancelling Headphones, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-06-17',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 467,
        },
    },
    {
        ProductID: 899,
        Title: 'Ultra 4K Monitor',
        Description: 'The Ultra 4K Monitor combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-06-18',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 51,
        },
    },
    {
        ProductID: 900,
        Title: 'Wireless Gaming Mouse',
        Description:
            'Designed for everyday use, this Wireless Gaming Mouse delivers reliable performance and modern features.',
        datasetDate: '2024-06-19',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 933,
        },
    },
    {
        ProductID: 901,
        Title: 'Advanced Laptop Stand',
        Description:
            'Designed for everyday use, this Advanced Laptop Stand delivers reliable performance and modern features.',
        datasetDate: '2024-06-20',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 853,
        },
    },
    {
        ProductID: 902,
        Title: 'Wireless Laptop Stand',
        Description:
            'The Wireless Laptop Stand combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-06-21',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 593,
        },
    },
    {
        ProductID: 903,
        Title: 'Durable Smart Plug',
        Description:
            'Upgrade your setup with the Durable Smart Plug, engineered for speed, durability, and convenience.',
        datasetDate: '2024-06-22',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 852,
        },
    },
    {
        ProductID: 904,
        Title: 'Ultra Gaming Mouse',
        Description:
            'A versatile Gaming Mouse featuring ultra construction and dependable performance for daily tasks.',
        datasetDate: '2024-06-23',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 167,
        },
    },
    {
        ProductID: 905,
        Title: 'Portable Gaming Mouse',
        Description:
            'Upgrade your setup with the Portable Gaming Mouse, engineered for speed, durability, and convenience.',
        datasetDate: '2024-06-24',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 391,
        },
    },
    {
        ProductID: 906,
        Title: 'Pro Air Purifier',
        Description: 'A versatile Air Purifier featuring pro construction and dependable performance for daily tasks.',
        datasetDate: '2024-06-25',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 795,
        },
    },
    {
        ProductID: 907,
        Title: 'Portable USB-C Hub',
        Description: 'The Portable USB-C Hub combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-06-26',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 926,
        },
    },
    {
        ProductID: 908,
        Title: 'Compact Action Camera',
        Description:
            'Designed for everyday use, this Compact Action Camera delivers reliable performance and modern features.',
        datasetDate: '2024-06-27',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 548,
        },
    },
    {
        ProductID: 909,
        Title: 'Smart Action Camera',
        Description:
            'Designed for everyday use, this Smart Action Camera delivers reliable performance and modern features.',
        datasetDate: '2024-06-28',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 450,
        },
    },
    {
        ProductID: 910,
        Title: 'Premium Air Purifier',
        Description:
            'Designed for everyday use, this Premium Air Purifier delivers reliable performance and modern features.',
        datasetDate: '2024-06-29',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 120,
        },
    },
    {
        ProductID: 911,
        Title: 'Smart Webcam',
        Description: 'The Smart Webcam combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-06-30',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 350,
        },
    },
    {
        ProductID: 912,
        Title: 'Pro Fitness Tracker',
        Description:
            'Upgrade your setup with the Pro Fitness Tracker, engineered for speed, durability, and convenience.',
        datasetDate: '2024-07-01',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 125,
        },
    },
    {
        ProductID: 913,
        Title: 'Compact 4K Monitor',
        Description:
            'Upgrade your setup with the Compact 4K Monitor, engineered for speed, durability, and convenience.',
        datasetDate: '2024-07-02',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 469,
        },
    },
    {
        ProductID: 914,
        Title: 'Durable Bluetooth Speaker',
        Description:
            'Upgrade your setup with the Durable Bluetooth Speaker, engineered for speed, durability, and convenience.',
        datasetDate: '2024-07-03',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 743,
        },
    },
    {
        ProductID: 915,
        Title: 'Wireless External SSD',
        Description:
            'Upgrade your setup with the Wireless External SSD, engineered for speed, durability, and convenience.',
        datasetDate: '2024-07-04',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 794,
        },
    },
    {
        ProductID: 916,
        Title: 'Durable Robot Vacuum',
        Description:
            'The Durable Robot Vacuum combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-07-05',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 361,
        },
    },
    {
        ProductID: 917,
        Title: 'Smart Webcam',
        Description:
            'Experience improved productivity with this Smart Webcam, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-07-06',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 687,
        },
    },
    {
        ProductID: 918,
        Title: 'Premium Smart LED Bulb',
        Description:
            'Designed for everyday use, this Premium Smart LED Bulb delivers reliable performance and modern features.',
        datasetDate: '2024-07-07',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 106,
        },
    },
    {
        ProductID: 919,
        Title: 'Ultra Webcam',
        Description: 'A versatile Webcam featuring ultra construction and dependable performance for daily tasks.',
        datasetDate: '2024-07-08',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 475,
        },
    },
    {
        ProductID: 920,
        Title: 'Advanced Smart LED Bulb',
        Description:
            'The Advanced Smart LED Bulb combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-07-09',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 230,
        },
    },
    {
        ProductID: 921,
        Title: 'Advanced Smart LED Bulb',
        Description:
            'A versatile Smart LED Bulb featuring advanced construction and dependable performance for daily tasks.',
        datasetDate: '2024-07-10',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 713,
        },
    },
    {
        ProductID: 922,
        Title: 'Premium Air Purifier',
        Description:
            'The Premium Air Purifier combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-07-11',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 363,
        },
    },
    {
        ProductID: 923,
        Title: 'Pro Gaming Mouse',
        Description:
            'Experience improved productivity with this Pro Gaming Mouse, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-07-12',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 989,
        },
    },
    {
        ProductID: 924,
        Title: 'Wireless Electric Toothbrush',
        Description:
            'The Wireless Electric Toothbrush combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-07-13',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 751,
        },
    },
    {
        ProductID: 925,
        Title: 'Eco Noise Cancelling Headphones',
        Description:
            'Designed for everyday use, this Eco Noise Cancelling Headphones delivers reliable performance and modern features.',
        datasetDate: '2024-07-14',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 258,
        },
    },
    {
        ProductID: 926,
        Title: 'Pro Wireless Charger',
        Description:
            'Upgrade your setup with the Pro Wireless Charger, engineered for speed, durability, and convenience.',
        datasetDate: '2024-07-15',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 675,
        },
    },
    {
        ProductID: 927,
        Title: 'Smart Smart Plug',
        Description:
            'Designed for everyday use, this Smart Smart Plug delivers reliable performance and modern features.',
        datasetDate: '2024-07-16',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 583,
        },
    },
    {
        ProductID: 928,
        Title: 'Wireless Noise Cancelling Headphones',
        Description:
            'Upgrade your setup with the Wireless Noise Cancelling Headphones, engineered for speed, durability, and convenience.',
        datasetDate: '2024-07-17',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 69,
        },
    },
    {
        ProductID: 929,
        Title: 'Portable External SSD',
        Description:
            'The Portable External SSD combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-07-18',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 539,
        },
    },
    {
        ProductID: 930,
        Title: 'Advanced Fitness Tracker',
        Description:
            'The Advanced Fitness Tracker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-07-19',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 771,
        },
    },
    {
        ProductID: 931,
        Title: 'Durable External SSD',
        Description:
            'Designed for everyday use, this Durable External SSD delivers reliable performance and modern features.',
        datasetDate: '2024-07-20',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 958,
        },
    },
    {
        ProductID: 932,
        Title: 'Premium Smart Plug',
        Description: 'The Premium Smart Plug combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-07-21',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 777,
        },
    },
    {
        ProductID: 933,
        Title: 'Compact Electric Toothbrush',
        Description:
            'The Compact Electric Toothbrush combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-07-22',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 325,
        },
    },
    {
        ProductID: 934,
        Title: 'Advanced Noise Cancelling Headphones',
        Description:
            'A versatile Noise Cancelling Headphones featuring advanced construction and dependable performance for daily tasks.',
        datasetDate: '2024-07-23',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 584,
        },
    },
    {
        ProductID: 935,
        Title: 'Premium Bluetooth Speaker',
        Description:
            'Designed for everyday use, this Premium Bluetooth Speaker delivers reliable performance and modern features.',
        datasetDate: '2024-07-24',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 318,
        },
    },
    {
        ProductID: 936,
        Title: 'Ultra Air Purifier',
        Description: 'The Ultra Air Purifier combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-07-25',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 797,
        },
    },
    {
        ProductID: 937,
        Title: 'Premium Bluetooth Speaker',
        Description:
            'Designed for everyday use, this Premium Bluetooth Speaker delivers reliable performance and modern features.',
        datasetDate: '2024-07-26',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 665,
        },
    },
    {
        ProductID: 938,
        Title: 'Compact Mechanical Keyboard',
        Description:
            'A versatile Mechanical Keyboard featuring compact construction and dependable performance for daily tasks.',
        datasetDate: '2024-07-27',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 755,
        },
    },
    {
        ProductID: 939,
        Title: 'Portable Smart LED Bulb',
        Description:
            'Experience improved productivity with this Portable Smart LED Bulb, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-07-28',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 405,
        },
    },
    {
        ProductID: 940,
        Title: 'Portable USB-C Hub',
        Description:
            'Experience improved productivity with this Portable USB-C Hub, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-07-29',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 714,
        },
    },
    {
        ProductID: 941,
        Title: 'Compact Coffee Grinder',
        Description:
            'The Compact Coffee Grinder combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-07-30',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 262,
        },
    },
    {
        ProductID: 942,
        Title: 'Compact Gaming Mouse',
        Description:
            'Experience improved productivity with this Compact Gaming Mouse, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-07-31',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 581,
        },
    },
    {
        ProductID: 943,
        Title: 'Eco Action Camera',
        Description:
            'Upgrade your setup with the Eco Action Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-08-01',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 343,
        },
    },
    {
        ProductID: 944,
        Title: 'Premium External SSD',
        Description:
            'Designed for everyday use, this Premium External SSD delivers reliable performance and modern features.',
        datasetDate: '2024-08-02',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 49,
        },
    },
    {
        ProductID: 945,
        Title: 'Compact Electric Toothbrush',
        Description:
            'Designed for everyday use, this Compact Electric Toothbrush delivers reliable performance and modern features.',
        datasetDate: '2024-08-03',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 779,
        },
    },
    {
        ProductID: 946,
        Title: 'Compact Air Purifier',
        Description:
            'The Compact Air Purifier combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-08-04',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 935,
        },
    },
    {
        ProductID: 947,
        Title: 'Pro Mechanical Keyboard',
        Description:
            'Experience improved productivity with this Pro Mechanical Keyboard, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-08-05',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 717,
        },
    },
    {
        ProductID: 948,
        Title: 'Smart Webcam',
        Description: 'Designed for everyday use, this Smart Webcam delivers reliable performance and modern features.',
        datasetDate: '2024-08-06',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 628,
        },
    },
    {
        ProductID: 949,
        Title: 'Compact Smart LED Bulb',
        Description:
            'The Compact Smart LED Bulb combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-08-07',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 152,
        },
    },
    {
        ProductID: 950,
        Title: 'Pro Gaming Mouse',
        Description: 'The Pro Gaming Mouse combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-08-08',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 583,
        },
    },
    {
        ProductID: 951,
        Title: 'Ultra USB-C Hub',
        Description: 'A versatile USB-C Hub featuring ultra construction and dependable performance for daily tasks.',
        datasetDate: '2024-08-09',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 393,
        },
    },
    {
        ProductID: 952,
        Title: 'Eco USB-C Hub',
        Description: 'The Eco USB-C Hub combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-08-10',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 249,
        },
    },
    {
        ProductID: 953,
        Title: 'Compact Fitness Tracker',
        Description:
            'Designed for everyday use, this Compact Fitness Tracker delivers reliable performance and modern features.',
        datasetDate: '2024-08-11',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 224,
        },
    },
    {
        ProductID: 954,
        Title: 'Pro External SSD',
        Description: 'Upgrade your setup with the Pro External SSD, engineered for speed, durability, and convenience.',
        datasetDate: '2024-08-12',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 390,
        },
    },
    {
        ProductID: 955,
        Title: 'Premium USB-C Hub',
        Description:
            'Upgrade your setup with the Premium USB-C Hub, engineered for speed, durability, and convenience.',
        datasetDate: '2024-08-13',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 763,
        },
    },
    {
        ProductID: 956,
        Title: 'Eco Wireless Charger',
        Description:
            'Upgrade your setup with the Eco Wireless Charger, engineered for speed, durability, and convenience.',
        datasetDate: '2024-08-14',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 108,
        },
    },
    {
        ProductID: 957,
        Title: 'Advanced 4K Monitor',
        Description:
            'Experience improved productivity with this Advanced 4K Monitor, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-08-15',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 17,
        },
    },
    {
        ProductID: 958,
        Title: 'Compact 4K Monitor',
        Description:
            'Designed for everyday use, this Compact 4K Monitor delivers reliable performance and modern features.',
        datasetDate: '2024-08-16',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 261,
        },
    },
    {
        ProductID: 959,
        Title: 'Smart Fitness Tracker',
        Description:
            'Experience improved productivity with this Smart Fitness Tracker, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-08-17',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 863,
        },
    },
    {
        ProductID: 960,
        Title: 'Ultra Coffee Grinder',
        Description:
            'Designed for everyday use, this Ultra Coffee Grinder delivers reliable performance and modern features.',
        datasetDate: '2024-08-18',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 906,
        },
    },
    {
        ProductID: 961,
        Title: 'Durable Gaming Mouse',
        Description:
            'Upgrade your setup with the Durable Gaming Mouse, engineered for speed, durability, and convenience.',
        datasetDate: '2024-08-19',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 434,
        },
    },
    {
        ProductID: 962,
        Title: 'Pro Smart Plug',
        Description: 'A versatile Smart Plug featuring pro construction and dependable performance for daily tasks.',
        datasetDate: '2024-08-20',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 167,
        },
    },
    {
        ProductID: 963,
        Title: 'Durable Smart Plug',
        Description:
            'Designed for everyday use, this Durable Smart Plug delivers reliable performance and modern features.',
        datasetDate: '2024-08-21',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 760,
        },
    },
    {
        ProductID: 964,
        Title: 'Premium Mechanical Keyboard',
        Description:
            'Experience improved productivity with this Premium Mechanical Keyboard, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-08-22',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 727,
        },
    },
    {
        ProductID: 965,
        Title: 'Smart Coffee Grinder',
        Description:
            'Experience improved productivity with this Smart Coffee Grinder, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-08-23',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 320,
        },
    },
    {
        ProductID: 966,
        Title: 'Durable Smart Plug',
        Description:
            'Upgrade your setup with the Durable Smart Plug, engineered for speed, durability, and convenience.',
        datasetDate: '2024-08-24',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 752,
        },
    },
    {
        ProductID: 967,
        Title: 'Ultra Webcam',
        Description: 'A versatile Webcam featuring ultra construction and dependable performance for daily tasks.',
        datasetDate: '2024-08-25',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 306,
        },
    },
    {
        ProductID: 968,
        Title: 'Advanced USB-C Hub',
        Description:
            'Experience improved productivity with this Advanced USB-C Hub, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-08-26',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 153,
        },
    },
    {
        ProductID: 969,
        Title: 'Ultra Home Security Camera',
        Description:
            'Designed for everyday use, this Ultra Home Security Camera delivers reliable performance and modern features.',
        datasetDate: '2024-08-27',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 271,
        },
    },
    {
        ProductID: 970,
        Title: 'Premium Action Camera',
        Description:
            'The Premium Action Camera combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-08-28',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 275,
        },
    },
    {
        ProductID: 971,
        Title: 'Wireless Smart LED Bulb',
        Description:
            'The Wireless Smart LED Bulb combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-08-29',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 185,
        },
    },
    {
        ProductID: 972,
        Title: 'Portable Laptop Stand',
        Description:
            'Experience improved productivity with this Portable Laptop Stand, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-08-30',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 509,
        },
    },
    {
        ProductID: 973,
        Title: 'Portable 4K Monitor',
        Description:
            'Upgrade your setup with the Portable 4K Monitor, engineered for speed, durability, and convenience.',
        datasetDate: '2024-08-31',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 806,
        },
    },
    {
        ProductID: 974,
        Title: 'Smart Electric Toothbrush',
        Description:
            'Designed for everyday use, this Smart Electric Toothbrush delivers reliable performance and modern features.',
        datasetDate: '2024-09-01',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 945,
        },
    },
    {
        ProductID: 975,
        Title: 'Durable Wireless Charger',
        Description:
            'A versatile Wireless Charger featuring durable construction and dependable performance for daily tasks.',
        datasetDate: '2024-09-02',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 337,
        },
    },
    {
        ProductID: 976,
        Title: 'Wireless Bluetooth Speaker',
        Description:
            'The Wireless Bluetooth Speaker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-09-03',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 373,
        },
    },
    {
        ProductID: 977,
        Title: 'Portable External SSD',
        Description:
            'Upgrade your setup with the Portable External SSD, engineered for speed, durability, and convenience.',
        datasetDate: '2024-09-04',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 16,
        },
    },
    {
        ProductID: 978,
        Title: 'Portable Action Camera',
        Description:
            'The Portable Action Camera combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-09-05',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 349,
        },
    },
    {
        ProductID: 979,
        Title: 'Compact Mechanical Keyboard',
        Description:
            'Designed for everyday use, this Compact Mechanical Keyboard delivers reliable performance and modern features.',
        datasetDate: '2024-09-06',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 860,
        },
    },
    {
        ProductID: 980,
        Title: 'Advanced Webcam',
        Description:
            'Designed for everyday use, this Advanced Webcam delivers reliable performance and modern features.',
        datasetDate: '2024-09-07',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 854,
        },
    },
    {
        ProductID: 981,
        Title: 'Durable USB-C Hub',
        Description:
            'Designed for everyday use, this Durable USB-C Hub delivers reliable performance and modern features.',
        datasetDate: '2024-09-08',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 970,
        },
    },
    {
        ProductID: 982,
        Title: 'Premium Gaming Mouse',
        Description:
            'Upgrade your setup with the Premium Gaming Mouse, engineered for speed, durability, and convenience.',
        datasetDate: '2024-09-09',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 238,
        },
    },
    {
        ProductID: 983,
        Title: 'Pro Air Purifier',
        Description: 'Upgrade your setup with the Pro Air Purifier, engineered for speed, durability, and convenience.',
        datasetDate: '2024-09-10',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 317,
        },
    },
    {
        ProductID: 984,
        Title: 'Durable Smart Plug',
        Description:
            'Experience improved productivity with this Durable Smart Plug, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-09-11',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 695,
        },
    },
    {
        ProductID: 985,
        Title: 'Portable Wireless Charger',
        Description:
            'Designed for everyday use, this Portable Wireless Charger delivers reliable performance and modern features.',
        datasetDate: '2024-09-12',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 82,
        },
    },
    {
        ProductID: 986,
        Title: 'Eco Gaming Mouse',
        Description:
            'Designed for everyday use, this Eco Gaming Mouse delivers reliable performance and modern features.',
        datasetDate: '2024-09-13',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 456,
        },
    },
    {
        ProductID: 987,
        Title: 'Pro Smart Plug',
        Description: 'The Pro Smart Plug combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-09-14',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 53,
        },
    },
    {
        ProductID: 988,
        Title: 'Compact Bluetooth Speaker',
        Description:
            'A versatile Bluetooth Speaker featuring compact construction and dependable performance for daily tasks.',
        datasetDate: '2024-09-15',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 753,
        },
    },
    {
        ProductID: 989,
        Title: 'Smart Wireless Charger',
        Description:
            'Experience improved productivity with this Smart Wireless Charger, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-09-16',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 968,
        },
    },
    {
        ProductID: 990,
        Title: 'Eco Electric Toothbrush',
        Description:
            'Designed for everyday use, this Eco Electric Toothbrush delivers reliable performance and modern features.',
        datasetDate: '2024-09-17',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 183,
        },
    },
    {
        ProductID: 991,
        Title: 'Compact Action Camera',
        Description:
            'The Compact Action Camera combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-09-18',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'GREEN',
            score: 358,
        },
    },
    {
        ProductID: 992,
        Title: 'Premium Noise Cancelling Headphones',
        Description:
            'The Premium Noise Cancelling Headphones combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-09-19',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'GREEN',
            score: 784,
        },
    },
    {
        ProductID: 993,
        Title: 'Pro Bluetooth Speaker',
        Description:
            'Experience improved productivity with this Pro Bluetooth Speaker, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-09-20',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 1,
        },
    },
    {
        ProductID: 994,
        Title: 'Compact Wireless Charger',
        Description:
            'Experience improved productivity with this Compact Wireless Charger, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-09-21',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 441,
        },
    },
    {
        ProductID: 995,
        Title: 'Compact Home Security Camera',
        Description:
            'Upgrade your setup with the Compact Home Security Camera, engineered for speed, durability, and convenience.',
        datasetDate: '2024-09-22',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'RED',
            score: 994,
        },
    },
    {
        ProductID: 996,
        Title: 'Ultra Air Purifier',
        Description:
            'A versatile Air Purifier featuring ultra construction and dependable performance for daily tasks.',
        datasetDate: '2024-09-23',
        reviewedStatus: 'Reviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 463,
        },
    },
    {
        ProductID: 997,
        Title: 'Premium USB-C Hub',
        Description:
            'Experience improved productivity with this Premium USB-C Hub, built with quality materials and thoughtful engineering.',
        datasetDate: '2024-09-24',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'AMBER',
            score: 988,
        },
    },
    {
        ProductID: 998,
        Title: 'Durable Wireless Charger',
        Description:
            'The Durable Wireless Charger combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-09-25',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 65,
        },
    },
    {
        ProductID: 999,
        Title: 'Pro Mechanical Keyboard',
        Description:
            'Upgrade your setup with the Pro Mechanical Keyboard, engineered for speed, durability, and convenience.',
        datasetDate: '2024-09-26',
        reviewedStatus: 'Unreviewed',
        isActive: true,
        score: {
            colour: 'AMBER',
            score: 764,
        },
    },
    {
        ProductID: 1000,
        Title: 'Premium Fitness Tracker',
        Description:
            'The Premium Fitness Tracker combines sleek design with dependable functionality for work or home use.',
        datasetDate: '2024-09-27',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: 254,
        },
    },
];
